var map = {
  "./_deziiign/s-jurisprudence/routesList": [
    "35639",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85500"
  ],
  "./_deziiign/lpudesign/styles": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/adcrdafesnet/app": [
    "72893",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "68398"
  ],
  "./_deziiign/main/pages/moderView/index.ts": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/books/core/components/grid": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles.ts": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/s-geography/routesList.tsx": [
    "10596",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionsAdmin/components/BottomActionMenu": [
    "29489",
    9,
    "93706"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles.ts": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/main/pages/tagAdmin": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_geograffee/dafes/icons/sliderIcons/FIcon": [
    "53767",
    9,
    "2476"
  ],
  "./_ftbl/main/assets/leagues/italy.png": [
    "62782",
    1,
    "59283"
  ],
  "./_geograffee/dafes/icons/awardsNominations/System108Icon": [
    "94777",
    9,
    "15874"
  ],
  "./_competition/pages/PreRegistrationResult": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/onlines/routesList": [
    "68354",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6047"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign.tsx": [
    "61848",
    9,
    "45825"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles.ts": [
    "93487",
    9,
    "77316"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilDafesIcon.tsx": [
    "31174",
    9,
    "45579"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsCategory": [
    "40313",
    9,
    "51042"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/PlatformFeatures": [
    "23507",
    9,
    "83504"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationTwo.svg": [
    "53123",
    1,
    "28832"
  ],
  "./_geograffee/dafes/pages/CountryShowcase.tsx": [
    "62779",
    9,
    "15969",
    "6049",
    "99448",
    "16433"
  ],
  "./_geograffee/dafes/icons/footerIcons/TelegramIcon": [
    "3387",
    9,
    "4689"
  ],
  "./_ftbl/main/assets/icons/WorldIcon": [
    "76684",
    9
  ],
  "./_deziiign/monalisatravels/routesList.tsx": [
    "58745",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "93410"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview.tsx": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/main/pages/projectDeziign/styles.tsx": [
    "16478",
    9,
    "13043"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconEn.tsx": [
    "99755",
    9,
    "57336"
  ],
  "./_deziiign/greenaward/components/IndexTitle": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection.tsx": [
    "80194",
    9,
    "59071"
  ],
  "./_deziiign/s-public-administration/routesList.tsx": [
    "96916",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "51125"
  ],
  "./_ftbl/main/assets/icons/WorldIcon.tsx": [
    "76684",
    9
  ],
  "./_deziiign/ageytomesh/routesList": [
    "92044",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67741"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/styles.ts": [
    "52030",
    9,
    "28051"
  ],
  "./_deziiign/s-cinema/routesList": [
    "18301",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5262"
  ],
  "./_deziiign/s-mediadepartment/app.tsx": [
    "85213",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1006"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage.tsx": [
    "21593",
    9,
    "62850"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/ColorfulBlocks.tsx": [
    "96835",
    9,
    "95992",
    "20565",
    "72768"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/Timelines.tsx": [
    "29534",
    9,
    "36435"
  ],
  "./_competition/pages/AllCompetitionsPage/types/types.ts": [
    "49608",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage.tsx": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/designmediiia/app": [
    "72483",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25760"
  ],
  "./_deziiign/books/core/book-delegate.ts": [
    "88325",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools": [
    "19117",
    9
  ],
  "./_deziiign/lab/routesList.tsx": [
    "59821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "68990"
  ],
  "./_deziiign/online/styles": [
    "10509",
    9,
    "50718"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderFashionIcon.tsx": [
    "42216",
    9,
    "43793"
  ],
  "./_geograffee/dafes/pages/data/awards2025Data": [
    "11673",
    9,
    "94498"
  ],
  "./_competition/pages/CompetitionResultsPage": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/kiiids/components/IndexTitle": [
    "58818",
    9,
    "53023"
  ],
  "./_deziiign/books/core/components/shareButton/index.ts": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles.ts": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/school/routesList": [
    "262",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87723"
  ],
  "./_deziiign/fairmediiia/app.tsx": [
    "6467",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "54624"
  ],
  "./_deziiign/kiiids/routesList": [
    "85885",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81038"
  ],
  "./_deziiign/books/core/components/tooltips/": [
    "40356",
    9
  ],
  "./_deziiign/s-oriental/routesList.tsx": [
    "27850",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "9367"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer.tsx": [
    "29312",
    9,
    "97305"
  ],
  "./_deziiign/greenaward/utils": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/books/core/hook/api/useBookList.ts": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/s-international-relations/routesList.tsx": [
    "48390",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99627"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage.tsx": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/styles.ts": [
    "97041",
    9,
    "24682"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/NominationsIcon.tsx": [
    "54893",
    9,
    "42654"
  ],
  "./_deziiign/hsecreative/styles.tsx": [
    "41431",
    9,
    "7036"
  ],
  "./_geograffee/dafes/images/F1_jewellery_design.jpg": [
    "60858",
    1,
    "12935"
  ],
  "./_deziiign/s-philosophy/routesList": [
    "89821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/tag": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index.ts": [
    "25672",
    9,
    "32049"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/styles.tsx": [
    "94468",
    9,
    "33861"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useProjectChapters": [
    "50502",
    9
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/LPUIcon": [
    "83451",
    9,
    "57352"
  ],
  "./_fr/mumbai/styles.tsx": [
    "26294",
    9,
    "6171"
  ],
  "./_deziiign/automediiia/routesList": [
    "83561",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54130"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableLinkSortBlock.tsx": [
    "46829",
    9,
    "58599"
  ],
  "./_geograffee/academy/app": [
    "47617",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5370"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField": [
    "38958",
    9,
    "43907"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/AboutAwards2025.tsx": [
    "44807",
    9,
    "12725"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 135.jpg": [
    "82461",
    1,
    "73358"
  ],
  "./_deziiign/creativemediiia/app": [
    "38719",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86621"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesInfoComponent": [
    "69615",
    9,
    "17316"
  ],
  "./_ftbl/main/assets/clubEmblems/Forza_Milano.png": [
    "48501",
    1,
    "6230"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner6.svg": [
    "17281",
    1,
    "51610"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib1.jpg": [
    "20821",
    1,
    "91606"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/sliderImages.ts": [
    "58412",
    9,
    "68189"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 116.jpg": [
    "68136",
    1,
    "48689"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueList": [
    "33420",
    9,
    "99037"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/styles.ts": [
    "97894",
    9,
    "36107"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/normalizeTabName.ts": [
    "93513",
    9,
    "94130"
  ],
  "./_competition/components/style": [
    "10301",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition.tsx": [
    "94880",
    9,
    "17433"
  ],
  "./_uz/main/app": [
    "4050",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28431"
  ],
  "./_deziiign/kiiids/app": [
    "43814",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5227"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/CategoryPartner.tsx": [
    "5381",
    9,
    "82118"
  ],
  "./_ftbl/main/assets/icons/PredictionButtonArrow.tsx": [
    "35313",
    9,
    "41130"
  ],
  "./_deziiign/lpudesign/routesList": [
    "56163",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42368"
  ],
  "./_deziiign/hsedesign/styles": [
    "91408",
    9,
    "49545"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/hsespace/components/IndexTitle.tsx": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles": [
    "14954",
    9,
    "94807"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle": [
    "53341",
    9
  ],
  "./_geograffee/dafes/images/student_features.png": [
    "49615",
    1,
    "94052"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/interior.png": [
    "80421",
    1,
    "16294"
  ],
  "./_deziiign/cinemediiia/routesList.tsx": [
    "91311",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81188"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_deziiign/onlines/OnlinesMetaTags": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/books/pages/BookChapterCreate/": [
    "45234",
    9,
    "95855"
  ],
  "./_ftbl/main/types/games": [
    "40701",
    9,
    "84942"
  ],
  "./_deziiign/portfolioartz/routesList.tsx": [
    "28207",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45444"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList": [
    "33014",
    9
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/search.svg": [
    "93686",
    1,
    "51163"
  ],
  "./_deziiign/continuumsite/routesList.tsx": [
    "97765",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6886"
  ],
  "./_competition/pages/CompetitionsAdmin/const.ts": [
    "67035",
    9
  ],
  "./_fr/shanghai/routesList": [
    "7100",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88557"
  ],
  "./_deziiign/iqmedia/routesList": [
    "70364",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "96525"
  ],
  "./_fr/shanghai/styles.tsx": [
    "19132",
    9,
    "17293"
  ],
  "./_ftbl/main/pages/MainPage/MainPage.tsx": [
    "89526",
    9,
    "17316",
    "71641",
    "60764",
    "46075"
  ],
  "./_deziiign/s-oriental/routesList": [
    "27850",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "9367"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconEn": [
    "50085",
    9,
    "134"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionWinnersPage.tsx": [
    "26884",
    9,
    "60901",
    "84869"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage.tsx": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories": [
    "93506",
    9
  ],
  "./_fr/bengaluru/routesList.tsx": [
    "19488",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3449"
  ],
  "./_fr/kolkata/styles.tsx": [
    "6174",
    9,
    "26419"
  ],
  "./_deziiign/s-history/app": [
    "25571",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83552"
  ],
  "./_deziiign/books/pages/BookEdit/styles": [
    "27552",
    9
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_deziiign/s-philosophy/app": [
    "9222",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50155"
  ],
  "./_deziiign/s-psychology/routesList": [
    "81139",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25680"
  ],
  "./_fr/bengaluru/app.tsx": [
    "53377",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46938"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblTitle.tsx": [
    "32877",
    9,
    "49438"
  ],
  "./_deziiign/s-public-administration/app.tsx": [
    "21533",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39662"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/edu-8119c54fba784b5ba27098e025112721.jpg": [
    "18058",
    1,
    "33783"
  ],
  "./_deziiign/books/pages/BookListView/BookListView": [
    "85406",
    9,
    "13908",
    "21565",
    "5357",
    "96979"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/IntegrationBlock": [
    "41295",
    9,
    "95992",
    "48548"
  ],
  "./_deziiign/hsecolors/app": [
    "19735",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43452"
  ],
  "./_deziiign/booksmediiia/app.tsx": [
    "25247",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71668"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableRowLayout": [
    "51619",
    9,
    "92832"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage": [
    "14449",
    9
  ],
  "./_competition/votePrevStorage.ts": [
    "79433",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit.tsx": [
    "58466",
    9,
    "97599"
  ],
  "./_deziiign/lmshse/routesList": [
    "89406",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21267"
  ],
  "./_geograffee/dafes/images/awards2026/headerLogo.svg": [
    "92466",
    1,
    "38150"
  ],
  "./_fr/saopaulo/routesList": [
    "86257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20138"
  ],
  "./_ftbl/main/constants/tableHeader.ts": [
    "44616",
    9,
    "24712"
  ],
  "./_fr/dubai/app.tsx": [
    "12475",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "72168"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/BlackBlock.tsx": [
    "91156",
    9,
    "95992",
    "20565"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/TitleImg.tsx": [
    "63168",
    9,
    "89017"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage": [
    "69662",
    9,
    "87616"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileGlow.svg": [
    "27318",
    1,
    "74203"
  ],
  "./_deziiign/s-hsetto/routesList": [
    "54479",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25668"
  ],
  "./_deziiign/hsestart/routesList": [
    "94962",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85660"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderPrevButtonIcon": [
    "73059",
    9,
    "86304"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/artmediiia/routesList.tsx": [
    "6743",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88156"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/s-pro/app.tsx": [
    "45622",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "18651"
  ],
  "./_ftbl/main/helpers/getFlagUrl": [
    "73847",
    9
  ],
  "./_geograffee/dafes/images/awards2026/rivchun.png": [
    "43092",
    1,
    "35637"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesComponent": [
    "33879",
    9,
    "17316",
    "60764"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults": [
    "77349",
    9,
    "96678",
    "52071"
  ],
  "./_fr/paris/app.tsx": [
    "84249",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53346"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner1.svg": [
    "8350",
    1,
    "34643"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesTable.tsx": [
    "9707",
    9,
    "5894",
    "86041",
    "69592"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles.ts": [
    "18476",
    9
  ],
  "./_deziiign/s-digital/app": [
    "94875",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53032"
  ],
  "./_ftbl/main/hooks/useGetPeriods.ts": [
    "99170",
    9,
    "99007"
  ],
  "./_geograffee/dafes/images/awards2026/mobileHeaderBg.png": [
    "79355",
    1,
    "40"
  ],
  "./_deziiign/books/pages/BookEdit/constants": [
    "16292",
    9
  ],
  "./_deziiign/prohse/app": [
    "9256",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23313"
  ],
  "./_deziiign/hseanimation/styles": [
    "37256",
    9,
    "38641"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter": [
    "60313",
    9,
    "79298"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit": [
    "20260",
    9,
    "60901"
  ],
  "./_deziiign/galllleryart/styles.ts": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch.tsx": [
    "10268",
    9,
    "42029"
  ],
  "./_deziiign/aimediiia/app.tsx": [
    "49867",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31576"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards": [
    "70067",
    9
  ],
  "./_deziiign/school/pages/init.tsx": [
    "74957",
    9,
    "48382"
  ],
  "./_geograffee/dafes/routesList.tsx": [
    "58305",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "43290"
  ],
  "./_kz/dafes-art/app.tsx": [
    "8294",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22731"
  ],
  "./_deziiign/designmediiia/app.tsx": [
    "72483",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25760"
  ],
  "./_deziiign/mediiia/routesList.tsx": [
    "24864",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45497"
  ],
  "./_deziiign/books/pages/sections/ps-image.tsx": [
    "9421",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title.tsx": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/hsecreativehub/routesList.tsx": [
    "71242",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "57303"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/ColorfulBlocks": [
    "96835",
    9,
    "95992",
    "20565",
    "72768"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/getPartners.tsx": [
    "30927",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "60557"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit.tsx": [
    "72536",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497"
  ],
  "./_deziiign/conceptmediiia/routesList": [
    "83700",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "62165"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage": [
    "94292",
    9,
    "24074",
    "47268",
    "83275",
    "78037"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesSettings.tsx": [
    "90368",
    9,
    "5894",
    "86041"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom.tsx": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/ranepa/routesList.tsx": [
    "65621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69910"
  ],
  "./_deziiign/s-media/routesList.tsx": [
    "88674",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "89023"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ChildrensBookIcon": [
    "33834",
    9,
    "79671"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Profiles.tsx": [
    "70198",
    9,
    "95992",
    "86811"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-d5a5c00f112943a48acefac7bd0c53c0.jpg": [
    "34676",
    1,
    "32885"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext": [
    "82310",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "800"
  ],
  "./_deziiign/main/pages/projectDeziign/index.tsx": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/dafes/pages/data/awards2025Data.ts": [
    "11673",
    9,
    "94498"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/styles": [
    "54922",
    9,
    "37143"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/GameItemInfo.tsx": [
    "99100",
    9,
    "88493"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage.tsx": [
    "14449",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationFive.svg": [
    "66863",
    1,
    "13892"
  ],
  "./_ftbl/main/constants/countryIndexes": [
    "33770",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesSmallButton": [
    "88678",
    9,
    "34603"
  ],
  "./_deziiign/cgrave/styles.ts": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/adcrdafesnet/styles.ts": [
    "14100",
    9,
    "25653"
  ],
  "./_geograffee/dafes/images/university_slider_item_2.png": [
    "44835",
    1,
    "36416"
  ],
  "./_competition/pages/CompetitionsAdmin/components/SearchInput": [
    "99951",
    9,
    "22116"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/StatusesAdminPage.tsx": [
    "96596",
    9,
    "5894",
    "86041",
    "95605"
  ],
  "./_deziiign/kiiids/utils/index": [
    "80417",
    9,
    "14824"
  ],
  "./_geograffee/dafes/images/S1_brand_yearEN.jpg": [
    "1639",
    1,
    "40332"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilDafesIcon": [
    "31174",
    9,
    "45579"
  ],
  "./_deziiign/fairartz/app.tsx": [
    "76874",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76215"
  ],
  "./_deziiign/books/pages/BookEdit/types": [
    "62704",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/styles": [
    "71583",
    9,
    "30100"
  ],
  "./_deziiign/hsecolors/routesList.tsx": [
    "54706",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40751"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs": [
    "79982",
    9,
    "12035"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/eligibility.svg": [
    "41699",
    1,
    "65120"
  ],
  "./_deziiign/s-digital/app.tsx": [
    "94875",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53032"
  ],
  "./_deziiign/automediiia/app.tsx": [
    "38106",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99687"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave.tsx": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout": [
    "99082",
    9
  ],
  "./_competition/pages/CompetitionsAdmin/components/style": [
    "8608",
    9,
    "83321"
  ],
  "./_deziiign/aki/routesList.tsx": [
    "13233",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23018"
  ],
  "./_fr/mumbai/routesList.tsx": [
    "58622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87443"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate.tsx": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreativehub/app": [
    "44527",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95620"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools": [
    "56695",
    9,
    "76412"
  ],
  "./_deziiign/lmshse/styles": [
    "98454",
    9,
    "4731"
  ],
  "./_deziiign/s-management/routesList": [
    "86269",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35054"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/CommunicationAwards2025": [
    "16555",
    9,
    "40312"
  ],
  "./_deziiign/storiesmediiia/routesList": [
    "88515",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20800"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard": [
    "76742",
    9
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconEn": [
    "68643",
    9,
    "37289"
  ],
  "./_ftbl/main/assets/clubEmblems/Burgundy_Brussel.png": [
    "89013",
    1,
    "59926"
  ],
  "./_deziiign/books/core/components/shareButton/index": [
    "83831",
    9,
    "5436"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils": [
    "22125",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/question.svg": [
    "39708",
    1,
    "19053"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/plus.svg": [
    "13427",
    1,
    "58928"
  ],
  "./_kz/dafes/routesList": [
    "56814",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26330"
  ],
  "./_deziiign/booksgallllery/ExtraPage": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/hand.png": [
    "45275",
    1,
    "66472"
  ],
  "./_deziiign/superpuper/styles": [
    "45757",
    9,
    "16398"
  ],
  "./_deziiign/hseanimation/styles.tsx": [
    "37256",
    9,
    "38641"
  ],
  "./_geograffee/academy/app.tsx": [
    "47617",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5370"
  ],
  "./_deziiign/greenaward/utils/index": [
    "96912",
    9,
    "94249"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/JuryAwards2025.tsx": [
    "10505",
    9,
    "94498",
    "51058"
  ],
  "./_deziiign/transfermediiia/routesList": [
    "24253",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88494"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon.tsx": [
    "37305",
    9,
    "610"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/s-cinema/app": [
    "64646",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "363"
  ],
  "./_deziiign/s-geography/app": [
    "84909",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "12670"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/styles": [
    "40148",
    9,
    "57109"
  ],
  "./_deziiign/s-arthistory/app.tsx": [
    "56821",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28927"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/UniversitiesFeatures": [
    "54394",
    9,
    "95992",
    "17486",
    "42023"
  ],
  "./_deziiign/school/utils/index.ts": [
    "89716",
    9,
    "99509"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage": [
    "6664",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar": [
    "89260",
    9,
    "13908",
    "21565"
  ],
  "./_fr/kolkata/app.tsx": [
    "46019",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8576"
  ],
  "./_competition/components/TellingStoriesSuccess": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage.tsx": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/portfolioartz/app.tsx": [
    "51524",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "67653"
  ],
  "./_fr/delhi/routesList.tsx": [
    "60381",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "96046"
  ],
  "./_deziiign/cinemediiia/routesList": [
    "91311",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81188"
  ],
  "./_deziiign/jhonatanet/routesList": [
    "98162",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54319"
  ],
  "./_competition/helpers/preRegistrationAccess.ts": [
    "97999",
    9
  ],
  "./_deziiign/hsespace/app": [
    "46345",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22386"
  ],
  "./_fr/delhi/styles": [
    "13073",
    9,
    "63562"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit": [
    "58466",
    9,
    "97599"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ai.svg": [
    "94285",
    1,
    "76254"
  ],
  "./_ftbl/main/assets/flags/spaFlag.png": [
    "14616",
    1,
    "54721"
  ],
  "./_geograffee/dafes/images/hse_backgroung_img.png": [
    "33626",
    1,
    "93415"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles": [
    "73222",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TeamTable.tsx": [
    "33480",
    9,
    "28561"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/styles": [
    "90902",
    9,
    "49179"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/DafesMainSlider.tsx": [
    "99821",
    9,
    "53317",
    "61214"
  ],
  "./_deziiign/hsecolors/routesList": [
    "54706",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40751"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/PartnersResidents.tsx": [
    "12910",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "56867"
  ],
  "./_fr/kolkata/routesList.tsx": [
    "29878",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "13947"
  ],
  "./_deziiign/sportmediiia/app.tsx": [
    "37223",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "4076"
  ],
  "./_geograffee/main/app.tsx": [
    "95508",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23509"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles": [
    "18476",
    9
  ],
  "./_competition/helpers/getCompetitionDate.ts": [
    "76662",
    9
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner7.svg": [
    "5040",
    1,
    "19337"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage": [
    "65548",
    9
  ],
  "./_geograffee/dafes/icons/TechnologicalBlockIcon": [
    "48592",
    9,
    "68329"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions.ts": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/hsedesign/pages/TagExpertsPage/TagExpertsPage": [
    "12022",
    9,
    "26139"
  ],
  "./_deziiign/lmsmediiia/app.tsx": [
    "39117",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59454"
  ],
  "./_deziiign/s-political-science/app.tsx": [
    "51367",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50188"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArtIcon.tsx": [
    "96271",
    9,
    "44868"
  ],
  "./_geograffee/dafes/images/interior_design_logo.png": [
    "34191",
    1,
    "95332"
  ],
  "./_geograffee/dafes/icons/IntegrationBlockIcon": [
    "37848",
    9,
    "9473"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/styles": [
    "93983",
    9,
    "41460"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/styles": [
    "80724",
    9,
    "57141"
  ],
  "./_deziiign/books/pages/sections/ps-buttons": [
    "56100",
    9,
    "86309"
  ],
  "./_deziiign/prohse/app.tsx": [
    "9256",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23313"
  ],
  "./_geograffee/dafes/images/D1_motion_designEN.jpg": [
    "51736",
    1,
    "77409"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/styles": [
    "88198",
    9,
    "58187"
  ],
  "./_competition/pages/CreateCompetitionPage": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_deziiign/fashionmediiia/app": [
    "96925",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "82734"
  ],
  "./_deziiign/dvadesign/styles": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField.tsx": [
    "70009",
    9,
    "30818"
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult.tsx": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/SeachBar.tsx": [
    "80150",
    9,
    "5894"
  ],
  "./_deziiign/books/core/components/template/book-display-layout.tsx": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/books/pages/BookListView": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/core/components/bookCard/index": [
    "21273",
    9
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/WhiteMainBlock.tsx": [
    "63325",
    9,
    "95992",
    "67566"
  ],
  "./_competition/pages/PreRegistrationResult/": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/dvadesign/app": [
    "31062",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/utils/": [
    "12216",
    9,
    "1953"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner8.svg": [
    "97959",
    1,
    "35596"
  ],
  "./_deziiign/s-production/routesList.tsx": [
    "88157",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11438"
  ],
  "./_fr/mumbai/app.tsx": [
    "13099",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "78840"
  ],
  "./_deziiign/portfolioartz/app": [
    "51524",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "67653"
  ],
  "./_deziiign/iqmedia/app.tsx": [
    "5142",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57563"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/UsersTable": [
    "6105",
    9,
    "5894",
    "52450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star3.svg": [
    "37310",
    1,
    "29587"
  ],
  "./_deziiign/books/routesList": [
    "26760",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/onlines/app": [
    "51476",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "13836"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblCard.tsx": [
    "61365",
    9,
    "34486"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesPageTabPanel": [
    "25859",
    9,
    "46464"
  ],
  "./_deziiign/hsehh/routesList": [
    "11862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40283"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/projectDeziign/styles": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/hsespacecreative/app": [
    "54370",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "26687"
  ],
  "./_deziiign/musicmediiia/app": [
    "62630",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58923"
  ],
  "./_fr/delhi/app.tsx": [
    "38246",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "42443"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/getPartners": [
    "30927",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "60557"
  ],
  "./_competition/pages/CreateCompetitionPage/changebg.svg": [
    "62674",
    1,
    "19919"
  ],
  "./_deziiign/books/constants": [
    "17857",
    9
  ],
  "./_deziiign/s-production/routesList": [
    "88157",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11438"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/id.svg": [
    "5792",
    1,
    "24249"
  ],
  "./_deziiign/online/app": [
    "51165",
    9,
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "41317",
    "97775",
    "38815",
    "53966"
  ],
  "./_fr/kolkata/app": [
    "46019",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8576"
  ],
  "./_ftbl/main/assets/flags/fraFlag.png": [
    "95259",
    1,
    "27464"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/s-hseincomm/app": [
    "30562",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59711"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader.tsx": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/books/core/common": [
    "62913",
    9,
    "82989"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsProfile": [
    "56290",
    9,
    "89567"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/FormsComponent": [
    "98547",
    9,
    "95312"
  ],
  "./_deziiign/booksmediiia/app": [
    "25247",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71668"
  ],
  "./_deziiign/conceptmediiia/app": [
    "19869",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86702"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_deziiign/creativemediiia/routesList": [
    "92375",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "77724"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star4.svg": [
    "54689",
    1,
    "71533"
  ],
  "./_deziiign/continuumsite/styles": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/hseanimation/routesList.tsx": [
    "27072",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "55417"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury": [
    "71795",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/styles.ts": [
    "92847",
    9,
    "77924"
  ],
  "./_deziiign/s-philology/app": [
    "24826",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10887"
  ],
  "./_deziiign/admediiia/routesList": [
    "21959",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "34636"
  ],
  "./_deziiign/s-mediadepartment/routesList": [
    "10868",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56021"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/BlackBlock": [
    "91156",
    9,
    "95992",
    "20565"
  ],
  "./_deziiign/s-digital/routesList.tsx": [
    "22606",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3939"
  ],
  "./_fr/kolkata/routesList": [
    "29878",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "13947"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter": [
    "94043",
    9,
    "87464"
  ],
  "./_competition/components/CompetitionFormSuccess": [
    "2402",
    9,
    "63231"
  ],
  "./_deziiign/school/styles.tsx": [
    "6510",
    9,
    "40355"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_geograffee/dafes/icons/sliderIcons/AIcon": [
    "34036",
    9,
    "6037"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/styles.ts": [
    "95213",
    9,
    "99326"
  ],
  "./_geograffee/dafes/images/awards2026/Icon_container.png": [
    "64004",
    1,
    "19717"
  ],
  "./_kz/pro/routesList": [
    "2265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "92034"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage": [
    "79407",
    9,
    "56900"
  ],
  "./_ftbl/main/pages/AboutFtbl/styles.ts": [
    "45643",
    9,
    "62488"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserInfo": [
    "59935",
    9,
    "90109"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserCards": [
    "18007",
    9,
    "47036"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItem.tsx": [
    "40634",
    9,
    "23943"
  ],
  "./_deziiign/awards/routesList": [
    "80164",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "84709"
  ],
  "./_competition/routesList": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module3.svg": [
    "79202",
    1,
    "35967"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/DafesMainSlider": [
    "99821",
    9,
    "53317",
    "61214"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 131.jpg": [
    "40577",
    1,
    "51866"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/what_is_branding_sm.jpg": [
    "81172",
    1,
    "55637"
  ],
  "./_deziiign/books/core/components/booksSearchBar/": [
    "68671",
    9,
    "3924"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/AdditionalFeatures.tsx": [
    "76509",
    9,
    "17486",
    "82499"
  ],
  "./_fr/main/styles.tsx": [
    "40912",
    9,
    "43369"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-94a50e63889f48fc81c7791f36d30dcd.jpg": [
    "37004",
    1,
    "4093"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField.tsx": [
    "40683",
    9,
    "38776"
  ],
  "./_ftbl/main/assets/leagues/england.png": [
    "13164",
    1,
    "43741"
  ],
  "./_competition/pages/ShortListPage/index.ts": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOneReadymag.svg": [
    "46855",
    1,
    "29356"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/CommunicationAwards2025.tsx": [
    "16555",
    9,
    "40312"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard": [
    "47486",
    9
  ],
  "./_deziiign/lab/app": [
    "14678",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44571"
  ],
  "./_kz/dafes/pages/CountryShowcase.tsx": [
    "73947",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "59816"
  ],
  "./_deziiign/s-cognitive/app.tsx": [
    "94287",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "52100"
  ],
  "./_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions": [
    "63349",
    9
  ],
  "./_deziiign/exams/app.tsx": [
    "78503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57516"
  ],
  "./_fr/dubai/routesList": [
    "94158",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99299"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/styles": [
    "42776",
    9,
    "31854"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderStartupsIcon": [
    "80866",
    9,
    "9439"
  ],
  "./_competition/pages/CompetitionsAdmin/components/TableContent.tsx": [
    "53556",
    9,
    "69301"
  ],
  "./_deziiign/books/core/components/booksSearchBar": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/kiiids/styles.tsx": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/books/core/components/helper/bookEvents.ts": [
    "75209",
    9,
    "73051"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/isCardBlockedForPaidBook": [
    "44387",
    9
  ],
  "./_deziiign/hsedesign/styles.tsx": [
    "91408",
    9,
    "49545"
  ],
  "./_fr/shanghai/styles": [
    "19132",
    9,
    "17293"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutPageBlock.tsx": [
    "76486",
    9,
    "27691"
  ],
  "./_deziiign/monalisatravels/app": [
    "90436",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "77655"
  ],
  "./_deziiign/onlinesdesign/routesList.tsx": [
    "51735",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3813"
  ],
  "./_deziiign/fashion/routesList": [
    "97862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31947"
  ],
  "./_deziiign/aimediiia/routesList": [
    "83870",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42291"
  ],
  "./_deziiign/awards/pages/EmployeesContext": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage.tsx": [
    "22570",
    9,
    "6244"
  ],
  "./_fr/delhi/styles.tsx": [
    "13073",
    9,
    "63562"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PauseIcon.tsx": [
    "7356",
    9,
    "20173"
  ],
  "./_deziiign/hsedesign/routesList": [
    "28344",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54529"
  ],
  "./_deziiign/s-production/app.tsx": [
    "42265",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46699"
  ],
  "./_competition/helpers/getCompetitionStatus.ts": [
    "30100",
    9
  ],
  "./_geograffee/dafes/icons/ButtonArrowIcon": [
    "19980",
    9,
    "61373"
  ],
  "./_competition/app.tsx": [
    "29104",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98441"
  ],
  "./_deziiign/hsespacecreative/app.tsx": [
    "54370",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "26687"
  ],
  "./_deziiign/s-chemistry/routesList": [
    "77800",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "10897"
  ],
  "./_deziiign/s-philosophy/app.tsx": [
    "9222",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50155"
  ],
  "./_competition/pages/AllCompetitionsPage/components/CompetitionCover.tsx": [
    "96300",
    9
  ],
  "./_deziiign/s-media/app.tsx": [
    "46343",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14220"
  ],
  "./_deziiign/books/core/components/template/book-container-layout": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/eventmediiia/routesList": [
    "4152",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "79073"
  ],
  "./_fr/paris/styles": [
    "32720",
    9,
    "71913"
  ],
  "./_geograffee/dafes/images/F1_fashion_design.jpg": [
    "52532",
    1,
    "50316"
  ],
  "./_geograffee/dafes/icons/AddDafesIcon": [
    "35503",
    9,
    "12324"
  ],
  "./_deziiign/onlinesdesign/app.tsx": [
    "61389",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59870"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 126.jpg": [
    "49997",
    1,
    "57438"
  ],
  "./_kz/dafes-education/routesList": [
    "74274",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67007"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage.tsx": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/foodmediiia/routesList": [
    "62124",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53245"
  ],
  "./_geograffee/dafes/app": [
    "76242",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "37071"
  ],
  "./_competition/pages/CreateCompetitionPage/index": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_competition/pages/ProjectsPage/index.ts": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs": [
    "1325",
    9
  ],
  "./_deziiign/conceptmediiia/app.tsx": [
    "19869",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86702"
  ],
  "./_ftbl/main/routesList": [
    "2572",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "637"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/UniversitiesFeatures.tsx": [
    "54394",
    9,
    "95992",
    "17486",
    "42023"
  ],
  "./_deziiign/superpuper/app": [
    "31858",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31887"
  ],
  "./_deziiign/hsespacecreative/routesList": [
    "9137",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "27402"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ZharKnigaIcon.tsx": [
    "85172",
    9,
    "12789"
  ],
  "./_deziiign/booksgallllery/ExtraPage/": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/ranepa/styles": [
    "5465",
    9,
    "62338"
  ],
  "./_deziiign/s-media/app": [
    "46343",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14220"
  ],
  "./_competition/pages/CompetitionsAdmin/components/BottomActionMenu.tsx": [
    "29489",
    9,
    "93706"
  ],
  "./_ftbl/main/pages/AllMatches/styles.ts": [
    "52208",
    9,
    "60425"
  ],
  "./_deziiign/iqmedia/routesList.tsx": [
    "70364",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "96525"
  ],
  "./_geograffee/dafes/images/universitiesTitleImg.png": [
    "81405",
    1,
    "46894"
  ],
  "./_kz/dafes-education/app": [
    "35335",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "30188"
  ],
  "./_deziiign/cgrave/styles": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/s-computer-science-and-engineering/app": [
    "24643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10720"
  ],
  "./_geograffee/main/routesList.tsx": [
    "29087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "18900"
  ],
  "./_ftbl/main/helpers/getInitials.ts": [
    "49335",
    9,
    "45244"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/BigIcon.tsx": [
    "60082",
    9,
    "27567"
  ],
  "./_deziiign/sportmediiia/routesList.tsx": [
    "81858",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "19743"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconRu.tsx": [
    "41738",
    9,
    "79607"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsProfile.tsx": [
    "56290",
    9,
    "89567"
  ],
  "./_kz/dafes-education/app.tsx": [
    "35335",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "30188"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/s-sociology/app.tsx": [
    "67953",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44234"
  ],
  "./_competition/helpers/useShowRatingCompetitionTag": [
    "32511",
    9
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/IrkiIcon.tsx": [
    "64708",
    9,
    "80444"
  ],
  "./_deziiign/dvadesign/styles.ts": [
    "2739",
    9,
    "87120"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconRu": [
    "75477",
    9,
    "35254"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-c81e874146014a78b8eb5c66a8698486.jpg": [
    "16500",
    1,
    "97612"
  ],
  "./_geograffee/dafes/images/technologicalImg.png": [
    "95689",
    1,
    "89682"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-6e63304c030c4c98bbe05fdb5892dd6c.jpg": [
    "86621",
    1,
    "49518"
  ],
  "./_deziiign/cinemediiia/app.tsx": [
    "27588",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50533"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOverviewReadymag.svg": [
    "54856",
    1,
    "61457"
  ],
  "./_deziiign/storiesmediiia/app.tsx": [
    "21600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71865"
  ],
  "./_deziiign/s-hseincomm/routesList": [
    "61265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85322"
  ],
  "./_deziiign/mediiia/app": [
    "94083",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "79904"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles.ts": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_ftbl/main/pages/AboutFtbl/styles": [
    "45643",
    9,
    "62488"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesBigButton.tsx": [
    "38385",
    9,
    "85066"
  ],
  "./_ftbl/main/pages/AllMatches/styles": [
    "52208",
    9,
    "60425"
  ],
  "./_deziiign/s-architect/routesList": [
    "52833",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "74394"
  ],
  "./_deziiign/s-public-administration/app": [
    "21533",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39662"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/resources": [
    "72627",
    9,
    "52272"
  ],
  "./_fr/dubai/styles.tsx": [
    "89222",
    9,
    "43179"
  ],
  "./_deziiign/s-production/app": [
    "42265",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46699"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderEducationIcon": [
    "92946",
    9,
    "98639"
  ],
  "./_deziiign/s-management/routesList.tsx": [
    "86269",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35054"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Greetings.tsx": [
    "73638",
    9,
    "95992",
    "97387"
  ],
  "./_deziiign/exams/routesList": [
    "35170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56031"
  ],
  "./_deziiign/s-architect/app": [
    "30162",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9775"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/styles.ts": [
    "53051",
    9,
    "23867"
  ],
  "./_competition/pages/LongListPage/LongListPage.tsx": [
    "22197",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserCards.tsx": [
    "18007",
    9,
    "47036"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage": [
    "51697",
    9,
    "73706"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index.ts": [
    "71795",
    9
  ],
  "./_deziiign/books/pages/sections/ps-commerce": [
    "21934",
    9,
    "51811"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-f37675243e344cecb404e17b9df2d7d3.jpg": [
    "84734",
    1,
    "36403"
  ],
  "./_geograffee/dafes/images/awards2026/meshcheryakov.png": [
    "88628",
    1,
    "35701"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/style.ts": [
    "39764",
    9,
    "54709"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext": [
    "33981",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "34535"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign": [
    "61848",
    9,
    "45825"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-3cda2e20741e4b1db94ee060d6a57d36.jpg": [
    "5024",
    1,
    "38425"
  ],
  "./_kz/dafes/app.tsx": [
    "5778",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21551"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/styles": [
    "7522",
    9,
    "1343"
  ],
  "./_deziiign/booksgallllery/routesList": [
    "14518",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98363"
  ],
  "./_fr/bengaluru/styles.tsx": [
    "80904",
    9,
    "18705"
  ],
  "./_deziiign/storiesmediiia/app": [
    "21600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71865"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index.ts": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblGrid": [
    "43395",
    9,
    "34486",
    "54400"
  ],
  "./_geograffee/dafes/images/awards2026/lu.png": [
    "7478",
    1,
    "79963"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/styles": [
    "94468",
    9,
    "33861"
  ],
  "./_deziiign/hsedesign/utils": [
    "46106",
    9,
    "87527"
  ],
  "./_geograffee/dafes/images/awards2026/close_menu.svg": [
    "60713",
    1,
    "60050"
  ],
  "./_deziiign/books/pages/BookEdit/index": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/brnd/app": [
    "8109",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23902"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-8c3dd122a36c48efa98a8601b0a19c6e.jpg": [
    "14056",
    1,
    "96913"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/pin1.svg": [
    "60232",
    1,
    "46225"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch": [
    "10268",
    9,
    "42029"
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage": [
    "77159",
    9,
    "6636"
  ],
  "./_ftbl/main/assets/flags/itaFlag.png": [
    "15218",
    1,
    "23663"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableHeaderBlock": [
    "80327",
    9,
    "56748"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles": [
    "63545",
    9,
    "82850"
  ],
  "./_deziiign/books/pages/BookEdit/types.ts": [
    "62704",
    9
  ],
  "./_deziiign/s-biology/routesList": [
    "28257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "73402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit.tsx": [
    "38310",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/pages/ShortListPage/ShortListPage": [
    "37613",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus.tsx": [
    "89004",
    9,
    "52701"
  ],
  "./_deziiign/game/routesList.tsx": [
    "71368",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "75345"
  ],
  "./_geograffee/dafes/images/D1_identity_and_branding.jpg": [
    "25699",
    1,
    "43753"
  ],
  "./_deziiign/s-political-science/app": [
    "51367",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50188"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconRu": [
    "41738",
    9,
    "79607"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 129.jpg": [
    "34990",
    1,
    "70275"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/sections.ts": [
    "97405",
    9,
    "95992",
    "37774"
  ],
  "./_competition/components/CompetitionDropdown": [
    "22878",
    9,
    "42419"
  ],
  "./_fr/marseille/app.tsx": [
    "34718",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14707"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 125.jpg": [
    "20738",
    1,
    "20575"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField.tsx": [
    "14771",
    9,
    "79056"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolAmIcon.tsx": [
    "88622",
    9,
    "8227"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/WhiteTopBlock": [
    "16141",
    9,
    "95992",
    "72446"
  ],
  "./_competition/pages/ShortListPage": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/Search.tsx": [
    "72663",
    9,
    "5894"
  ],
  "./_geograffee/dafes/images/D5_object_design.jpg": [
    "66220",
    1,
    "66333"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/SeachBar": [
    "80150",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/styles": [
    "31255",
    9,
    "52828"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-8bb7da9aca9244d78f72d4d808554f73.jpg": [
    "26868",
    1,
    "85173"
  ],
  "./_kz/dafes/pages/CountryShowcase": [
    "73947",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "59816"
  ],
  "./_deziiign/books/core/components/grid/index": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/booksgallllery/app": [
    "76643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "66688"
  ],
  "./_ftbl/main/assets/icons/TableSortLabelIcon.tsx": [
    "46",
    9,
    "5155"
  ],
  "./_kz/dafes-art/routesList": [
    "72989",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "50670"
  ],
  "./_deziiign/s-mediadepartment/app": [
    "85213",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1006"
  ],
  "./_deziiign/fairartz/routesList": [
    "15737",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8546"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchblack.svg": [
    "15964",
    1,
    "87428"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesButton.tsx": [
    "4203",
    9,
    "95992"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/hooks/useGetStatusesActions": [
    "52485",
    9,
    "5894"
  ],
  "./_geograffee/dafes/images/E1_visual_research.jpg": [
    "34433",
    1,
    "19418"
  ],
  "./_deziiign/books/pages/BookChapterCreate": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/galllleryart/routesList": [
    "43137",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93914"
  ],
  "./_deziiign/designmediiia/routesList.tsx": [
    "17398",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3323"
  ],
  "./_deziiign/aki/routesList": [
    "13233",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23018"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView.tsx": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/superpuper/app.tsx": [
    "31858",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31887"
  ],
  "./_deziiign/s-music/app": [
    "62310",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98411"
  ],
  "./_fr/saopaulo/app.tsx": [
    "10146",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99807"
  ],
  "./_geograffee/dafes/images/A1_best_research_publicationEN.jpg": [
    "24113",
    1,
    "26858"
  ],
  "./_deziiign/s-cognitive/routesList": [
    "92970",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6167"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-3fd8cec4336a4139ac92529fdbef0d8f.jpg": [
    "47231",
    1,
    "6804"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage.tsx": [
    "97566",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-7159820a94224b8cb5492a4bc97815ea.jpg": [
    "47060",
    1,
    "16981"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles": [
    "20509",
    9
  ],
  "./_deziiign/books/core/components/bookCard": [
    "21273",
    9
  ],
  "./_deziiign/superpuper/routesList.tsx": [
    "76673",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23130"
  ],
  "./_kz/dafes-art/routesList.tsx": [
    "72989",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "50670"
  ],
  "./_deziiign/s-sociology/app": [
    "67953",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44234"
  ],
  "./_fr/paris/app": [
    "84249",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53346"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/styles.ts": [
    "36047",
    9,
    "25412"
  ],
  "./_deziiign/s-chemistry/app": [
    "5001",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86130"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/styles.ts": [
    "71002",
    9,
    "39495"
  ],
  "./_deziiign/jhonatanet/styles.ts": [
    "57886",
    9,
    "19987"
  ],
  "./_geograffee/dafes/images/D4_childrens_e-book.jpg": [
    "74606",
    1,
    "71834"
  ],
  "./_deziiign/lpudesign/app.tsx": [
    "34912",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "36921"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/camera.svg": [
    "12413",
    1,
    "93262"
  ],
  "./_deziiign/greenaward/utils/index.ts": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsespace/utils": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms.tsx": [
    "59628",
    9
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook.ts": [
    "82452",
    9
  ],
  "./_kz/dafes-fashion/routesList": [
    "93336",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25857"
  ],
  "./_deziiign/s-urban-development/app": [
    "69291",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "61528"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard.tsx": [
    "21919",
    9
  ],
  "./_deziiign/main/pages/moderHseView/index": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/s-geography/routesList": [
    "10596",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable": [
    "72383",
    9,
    "22056",
    "80140",
    "38708"
  ],
  "./_deziiign/main/pages/moderView/moderView.tsx": [
    "29397",
    9,
    "51382"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/GameItemInfo": [
    "99100",
    9,
    "88493"
  ],
  "./_deziiign/onlines/utils": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/alshibaya/app.tsx": [
    "75337",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "81938"
  ],
  "./_competition/pages/ShortListPage/styles.ts": [
    "42270",
    9
  ],
  "./_kz/dafes-fashion/routesList.tsx": [
    "93336",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25857"
  ],
  "./_deziiign/books/core/components/bookCard/assets/book-more-circle.svg": [
    "84667",
    1,
    "66760"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/GreenIcon.tsx": [
    "91303",
    9,
    "26636"
  ],
  "./_competition/pages/AllCompetitionsPage/styled.ts": [
    "70740",
    9
  ],
  "./_competition/pages/EmptyPage": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useChapterPosts": [
    "67007",
    9
  ],
  "./_competition/helpers/getCompetitionDate": [
    "76662",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud": [
    "40443",
    9,
    "41480"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/styles.ts": [
    "36749",
    9,
    "89854"
  ],
  "./_deziiign/mediiia/app.tsx": [
    "94083",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "79904"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblSortBar.tsx": [
    "34752",
    9,
    "153"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Greetings": [
    "73638",
    9,
    "95992",
    "97387"
  ],
  "./_competition/pages/CreateCompetitionPage/stylesEdit": [
    "42355",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/s-digital/routesList": [
    "22606",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3939"
  ],
  "./_ftbl/main/assets/icons/CheckedIcon": [
    "79495",
    9,
    "10316"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/IntegrationBlock.tsx": [
    "41295",
    9,
    "95992",
    "48548"
  ],
  "./_deziiign/onlines/pages/readymag/images/OnlinesSchedule.pdf": [
    "11664",
    1,
    "45321"
  ],
  "./_deziiign/s-hsetto/app": [
    "97284",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94949"
  ],
  "./_deziiign/s-philology/app.tsx": [
    "24826",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10887"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/styles.ts": [
    "40148",
    9,
    "57109"
  ],
  "./_deziiign/s-physics/app": [
    "76764",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89997"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView": [
    "255",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage.tsx": [
    "6664",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761"
  ],
  "./_competition/pages/ShortListPage/index": [
    "13978",
    9,
    "86439"
  ],
  "./_geograffee/dafes/pages/styles.ts": [
    "27162",
    9,
    "5319"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles": [
    "63011",
    9,
    "58528"
  ],
  "./_competition/components/SendProjectButton": [
    "26709",
    9
  ],
  "./_geograffee/dafes/images/awards2026/kankulov.png": [
    "85742",
    1,
    "7523"
  ],
  "./_ftbl/main/helpers/getFlagUrl.ts": [
    "73847",
    9
  ],
  "./_competition/components/CompetitionTagLine": [
    "23659",
    9
  ],
  "./_deziiign/lab/routesList": [
    "59821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "68990"
  ],
  "./_deziiign/books/pages/sections/ps-commerce.tsx": [
    "21934",
    9,
    "51811"
  ],
  "./_competition/pages/AllCompetitionsPage/components/CompetitionCover": [
    "96300",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCheckbox": [
    "64258",
    9,
    "11679"
  ],
  "./_deziiign/books/pages/sections/assets/alert.svg": [
    "87408",
    1,
    "24681"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/CategoriesIcon": [
    "98064",
    9,
    "8489"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsBigIcon.tsx": [
    "74146",
    9,
    "27551"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/PartnersResidents": [
    "12910",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "56867"
  ],
  "./_competition/pages/CompetitionTable/index.ts": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index.ts": [
    "50376",
    9,
    "86001"
  ],
  "./_competition/votePrevStorage": [
    "79433",
    9
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter.tsx": [
    "94043",
    9,
    "87464"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblGrid.tsx": [
    "43395",
    9,
    "34486",
    "54400"
  ],
  "./_deziiign/fashionmediiia/routesList.tsx": [
    "77396",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7477"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage.tsx": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/s-mathematics/routesList.tsx": [
    "82264",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "15905"
  ],
  "./_deziiign/continuumsite/routesList": [
    "97765",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6886"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index": [
    "25672",
    9,
    "32049"
  ],
  "./_uz/main/routesList": [
    "75937",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2554"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/styles": [
    "23708",
    9,
    "44301"
  ],
  "./_deziiign/s-international-relations/app.tsx": [
    "57715",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "11408"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/styles": [
    "97894",
    9,
    "36107"
  ],
  "./_geograffee/dafes/images/awards2026/burger_menu.svg": [
    "36238",
    1,
    "75459"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader": [
    "33655",
    9,
    "35004"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/styles.ts": [
    "23708",
    9,
    "44301"
  ],
  "./_deziiign/books/core/components/template/book-display-layout": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext.tsx": [
    "33981",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "34535"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ae.svg": [
    "75721",
    1,
    "33106"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 123.jpg": [
    "12596",
    1,
    "37301"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard": [
    "35468",
    9
  ],
  "./_deziiign/ranepa/app": [
    "96030",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83059"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/helpers/preRegistrationAccess": [
    "97999",
    9
  ],
  "./_deziiign/books/pages/BookListView/index.ts": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/sections": [
    "97405",
    9,
    "95992",
    "37774"
  ],
  "./_deziiign/foodmediiia/app.tsx": [
    "86805",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59126"
  ],
  "./_ftbl/main/pages/MainPage/components/GameTabs.tsx": [
    "66007",
    9,
    "65148"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module4.svg": [
    "7725",
    1,
    "96798"
  ],
  "./_deziiign/books/core/book-delegate": [
    "88325",
    9
  ],
  "./_deziiign/eventmediiia/app": [
    "98329",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5890"
  ],
  "./_geograffee/dafes/images/photographer_logo.png": [
    "61349",
    1,
    "95078"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/styles.ts": [
    "90902",
    9,
    "49179"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/UsersTable.tsx": [
    "6105",
    9,
    "5894",
    "52450"
  ],
  "./_deziiign/onlines/utils/index.ts": [
    "12216",
    9,
    "1953"
  ],
  "./_fr/delhi/app": [
    "38246",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "42443"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager.tsx": [
    "85524",
    9
  ],
  "./_ftbl/main/assets/clubEmblems/Tre_Kronor_Gothenburg.png": [
    "35857",
    1,
    "36746"
  ],
  "./_ftbl/main/assets/clubEmblems/Babylon_Berlin_International.png": [
    "37769",
    1,
    "33714"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index.tsx": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_geograffee/dafes/pages/data/nominationsData.tsx": [
    "67760",
    9,
    "77097"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/greenaward/styles": [
    "52890",
    9,
    "32455"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_ftbl/main/assets/leagues/germany.png": [
    "77084",
    1,
    "35341"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/styles.ts": [
    "57803",
    9,
    "51672"
  ],
  "./_deziiign/creativemediiia/routesList.tsx": [
    "92375",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "77724"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage.tsx": [
    "908",
    9,
    "10717"
  ],
  "./_deziiign/books/core/components/tooltips": [
    "40356",
    9
  ],
  "./_deziiign/online/styles.tsx": [
    "10509",
    9,
    "50718"
  ],
  "./_competition/pages/PreRegistrationResult/style.ts": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/hsespace/app.tsx": [
    "46345",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22386"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconRu.tsx": [
    "24290",
    9,
    "29599"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle.tsx": [
    "53341",
    9
  ],
  "./_deziiign/fairmediiia/routesList.tsx": [
    "78294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97243"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles.tsx": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/s-pro/routesList": [
    "41741",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35134"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage.tsx": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_competition/pages/CompetitionTable/": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_deziiign/fashion/routesList.tsx": [
    "97862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31947"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderDesignIcon": [
    "56298",
    9,
    "30039"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/ADCRBlock.tsx": [
    "27635",
    9,
    "33104"
  ],
  "./_deziiign/s-software-engineering/routesList": [
    "45829",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5318"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPageNew.tsx": [
    "51019",
    9,
    "50333",
    "36435",
    "99640"
  ],
  "./_deziiign/s-history/routesList": [
    "74294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58971"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module1.svg": [
    "21920",
    1,
    "80697"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableRowLayout.tsx": [
    "51619",
    9,
    "92832"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton.tsx": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index": [
    "71795",
    9
  ],
  "./_deziiign/hsestart/app": [
    "36503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "85244"
  ],
  "./_deziiign/greenaward/routesList": [
    "29293",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23591"
  ],
  "./_deziiign/lmshse/app": [
    "59755",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "7512"
  ],
  "./_geograffee/main/app": [
    "95508",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23509"
  ],
  "./_competition/pages/web.svg": [
    "79274",
    1,
    "14519"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsCrownIcon": [
    "64309",
    9,
    "19158"
  ],
  "./_deziiign/s-fashion/app.tsx": [
    "40127",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93492"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/getFilteredCompetitionsById.ts": [
    "61669",
    9,
    "35494"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit": [
    "38310",
    9
  ],
  "./_deziiign/awards/app.tsx": [
    "10445",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89054"
  ],
  "./_deziiign/s-mediadepartment/routesList.tsx": [
    "10868",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56021"
  ],
  "./_deziiign/awards/pages/EmployeesContext/": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArrowIcon.tsx": [
    "1731",
    9,
    "52928"
  ],
  "./_competition/pages/JuryPage/styles.ts": [
    "80070",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread": [
    "55855",
    9,
    "20004"
  ],
  "./_geograffee/dafes/images/D1_motion_design.jpg": [
    "46209",
    1,
    "64986"
  ],
  "./_deziiign/kiiids/utils/index.ts": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/ageytomesh/app.tsx": [
    "61045",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "24822"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage.tsx": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_geograffee/dafes/images/D5_object_designEN.jpg": [
    "52321",
    1,
    "78874"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutFtbl": [
    "23928",
    9,
    "21921"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView.tsx": [
    "255",
    9
  ],
  "./_deziiign/hsedesign/app": [
    "66841",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99554"
  ],
  "./_deziiign/books/helpers/copyLink": [
    "77885",
    9
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index.tsx": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_deziiign/online/utils": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/s-software-engineering/app.tsx": [
    "99790",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14115"
  ],
  "./_deziiign/school/styles": [
    "6510",
    9,
    "40355"
  ],
  "./_competition/pages/AllCompetitionsPage/types": [
    "29334",
    9
  ],
  "./_deziiign/conceptmediiia/routesList.tsx": [
    "83700",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "62165"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext": [
    "51106",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "32500"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList.tsx": [
    "33014",
    9
  ],
  "./_deziiign/hsespace/utils/": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField.tsx": [
    "32449",
    9,
    "50042"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/HeadComponent.tsx": [
    "78884",
    9,
    "6757"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-8c3dd122a36c48efa98a8601b0a19c6e.jpg": [
    "91582",
    1,
    "5587"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage.tsx": [
    "65548",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionNominatiosBlock.tsx": [
    "98635",
    9,
    "36184"
  ],
  "./_deziiign/hsehh/styles.tsx": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/AllCompetitionsPage": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/onlines/OnlinesMetaTags.tsx": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/awards/app": [
    "10445",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89054"
  ],
  "./_fr/saopaulo/routesList.tsx": [
    "86257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20138"
  ],
  "./_geograffee/dafes/icons/ADCRBlockIcon.tsx": [
    "27492",
    9,
    "869"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard": [
    "21919",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/edu-54f240ac75a148a2acac41074ac7527f.jpg": [
    "52734",
    1,
    "68275"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags": [
    "22226",
    9,
    "99727"
  ],
  "./_geograffee/dafes/images/awards2026/DAFES25.jpg": [
    "15697",
    1,
    "12714"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/fashion-en-ae99c77bdc6b4a4db8f14b88e662212f.jpg": [
    "26383",
    1,
    "88644"
  ],
  "./_deziiign/main/pages/tagAdmin/index": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts.ts": [
    "40309",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/calendarReadymag.svg": [
    "8324",
    1,
    "99205"
  ],
  "./_competition/pages/CompetitionsAdmin/components/style.ts": [
    "8608",
    9,
    "83321"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesTable": [
    "9707",
    9,
    "5894",
    "86041",
    "69592"
  ],
  "./_deziiign/s-extra/app.tsx": [
    "20657",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21802"
  ],
  "./_competition/pages/CreateCompetitionPage/stylesEdit.tsx": [
    "42355",
    9
  ],
  "./_deziiign/books/pages/sections/ps-image": [
    "9421",
    9
  ],
  "./_deziiign/hsecreative/routesList": [
    "23307",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99416"
  ],
  "./_deziiign/awards/styles.tsx": [
    "37460",
    9,
    "98197"
  ],
  "./_ftbl/main/assets/flags/gerFlag.png": [
    "64288",
    1,
    "18073"
  ],
  "./_deziiign/namesmediiia/app.tsx": [
    "47185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "55402"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/ContactsAwards2025.tsx": [
    "90270",
    9,
    "94498",
    "45715"
  ],
  "./_kz/dafes-fashion/app": [
    "78105",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "90146"
  ],
  "./_kz/dafes/components/SegmentSwitcher.tsx": [
    "6992",
    9,
    "9961"
  ],
  "./_fr/shanghai/app": [
    "59269",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "47046"
  ],
  "./_competition/pages/ShortListPage/": [
    "13978",
    9,
    "86439"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/ContactsAwards2025": [
    "90270",
    9,
    "94498",
    "45715"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/icons/Arrows": [
    "75562",
    9,
    "59639"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/intuitLabImg.png": [
    "65236",
    1,
    "58165"
  ],
  "./_deziiign/hsespacefilm/routesList": [
    "18438",
    9,
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69775",
    "90370",
    "56768",
    "555"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-d5a5c00f112943a48acefac7bd0c53c0.jpg": [
    "17680",
    1,
    "42985"
  ],
  "./_competition/components/Image.jpg": [
    "95503",
    1,
    "44676"
  ],
  "./_deziiign/mymediiia/routesList": [
    "17170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56367"
  ],
  "./_deziiign/school/app": [
    "46931",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44080"
  ],
  "./_ftbl/main/assets/flags/engFlag.png": [
    "43302",
    1,
    "68235"
  ],
  "./_deziiign/main/pages/tagAdmin/": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/TagsComponent.tsx": [
    "40805",
    9,
    "7494"
  ],
  "./_fr/main/app": [
    "77753",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "65954"
  ],
  "./_deziiign/cgrave/app.tsx": [
    "48621",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "63934"
  ],
  "./_deziiign/s-pro/app": [
    "45622",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "18651"
  ],
  "./_deziiign/books/pages/tag/index.ts": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index": [
    "81459",
    9,
    "25872"
  ],
  "./_ftbl/main/assets/leagues/france.png": [
    "90582",
    1,
    "78235"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ChildrensBookIcon.tsx": [
    "33834",
    9,
    "79671"
  ],
  "./_deziiign/booksgallllery/routesList.tsx": [
    "14518",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98363"
  ],
  "./_deziiign/lab/app.tsx": [
    "14678",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44571"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/HeadComponent": [
    "78884",
    9,
    "6757"
  ],
  "./_deziiign/books/pages/sections/ps-buttons.tsx": [
    "56100",
    9,
    "86309"
  ],
  "./_geograffee/dafes/images/awards2026/headerPlace.svg": [
    "30257",
    1,
    "3370"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-94a50e63889f48fc81c7791f36d30dcd.jpg": [
    "98874",
    1,
    "76423"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions": [
    "68",
    9,
    "36069"
  ],
  "./_ftbl/main/pages/AllMatches/AllMatchesPage": [
    "68523",
    9,
    "34486",
    "63800"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutFtbl.tsx": [
    "23928",
    9,
    "21921"
  ],
  "./_deziiign/aki/app": [
    "84085",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9695"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage": [
    "97728",
    9,
    "27769"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableHeaderBlock.tsx": [
    "80327",
    9,
    "56748"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/AdditionalFeatures": [
    "76509",
    9,
    "17486",
    "82499"
  ],
  "./_deziiign/main/routesList.tsx": [
    "67087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles.ts": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationItem": [
    "18729",
    9,
    "29938"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager": [
    "85524",
    9
  ],
  "./_deziiign/books/pages/BookEdit/constants.ts": [
    "16292",
    9
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/CategoryPartner": [
    "5381",
    9,
    "82118"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TeamTable": [
    "33480",
    9,
    "28561"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookEdit": [
    "992",
    9,
    "19833"
  ],
  "./_deziiign/brnd/app.tsx": [
    "8109",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23902"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools.tsx": [
    "19117",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts": [
    "40309",
    9
  ],
  "./_deziiign/kiiidsmediiia/routesList": [
    "47865",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11970"
  ],
  "./_deziiign/mymediiia/routesList.tsx": [
    "17170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56367"
  ],
  "./_fr/main/routesList": [
    "41816",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97281"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsCategory.tsx": [
    "40313",
    9,
    "51042"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread.tsx": [
    "55855",
    9,
    "20004"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/normalizeTabName": [
    "93513",
    9,
    "94130"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/styles.ts": [
    "78462",
    9,
    "90835"
  ],
  "./_geograffee/dafes/app.tsx": [
    "76242",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "37071"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 132.jpg": [
    "50998",
    1,
    "73083"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles.ts": [
    "18626",
    9,
    "59871"
  ],
  "./_competition/routesList.tsx": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/NewsPlayer": [
    "88362",
    9,
    "21591"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout.tsx": [
    "56925",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index.tsx": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/hsedesign/components/IndexTitle.tsx": [
    "91797",
    9
  ],
  "./_deziiign/hsespace/components/IndexTitle": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/EditUser": [
    "68730",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesButton": [
    "4203",
    9,
    "95992"
  ],
  "./_deziiign/alshibaya/routesList.tsx": [
    "76808",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21649"
  ],
  "./_geograffee/dafes/icons/sliderIcons/AIcon.tsx": [
    "34036",
    9,
    "6037"
  ],
  "./_deziiign/onlines/pages/readymag/images/bgReadymag.jpg": [
    "32490",
    1,
    "77559"
  ],
  "./_deziiign/s-hseissek/routesList.tsx": [
    "5391",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76228"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage.tsx": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName": [
    "20936",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/DafesSlider.tsx": [
    "7682",
    9,
    "20959"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection.tsx": [
    "84390",
    9,
    "33131"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/types.ts": [
    "79427",
    9,
    "37568"
  ],
  "./_geograffee/dafes/images/D4_childrens_e-bookEN.jpg": [
    "46040",
    1,
    "42337"
  ],
  "./_geograffee/dafes/images/awards2026/navLogo_upd.svg": [
    "16399",
    1,
    "19076"
  ],
  "./_deziiign/transfermediiia/app": [
    "56774",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "70987"
  ],
  "./_deziiign/s-philosophy/routesList.tsx": [
    "89821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8782"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/blender.svg": [
    "85533",
    1,
    "97038"
  ],
  "./_deziiign/fairartz/app": [
    "76874",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76215"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-f37675243e344cecb404e17b9df2d7d3.jpg": [
    "8616",
    1,
    "76721"
  ],
  "./_deziiign/s-sociology/routesList.tsx": [
    "82256",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26089"
  ],
  "./_deziiign/kiiidsmediiia/app": [
    "30378",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28471"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/books/core/components/shareButton": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/profmediiia/app": [
    "18186",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51031"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/startups-en-4ac9aba7802f4803b36c4c163836bc48.jpg": [
    "37567",
    1,
    "88692"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 128.jpg": [
    "86065",
    1,
    "16472"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookEdit.tsx": [
    "992",
    9,
    "19833"
  ],
  "./_deziiign/hsespacefilm/app": [
    "32499",
    9,
    "24074",
    "83762",
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69775",
    "90370",
    "56768",
    "38256"
  ],
  "./_deziiign/urbanmediiia/routesList": [
    "31300",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58533"
  ],
  "./_ftbl/main/hooks/useGetPeriods": [
    "99170",
    9,
    "99007"
  ],
  "./_deziiign/main/pages/moderHseView": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/hsespacecreative/routesList.tsx": [
    "9137",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "27402"
  ],
  "./_ftbl/main/styles": [
    "5836",
    9,
    "36477"
  ],
  "./_competition/pages/CompetitionsAdmin/components/SearchInput.tsx": [
    "99951",
    9,
    "22116"
  ],
  "./_fr/marseille/styles": [
    "19993",
    9,
    "26050"
  ],
  "./_deziiign/kiiidsmediiia/routesList.tsx": [
    "47865",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11970"
  ],
  "./_ftbl/main/assets/icons/PredictionButtonArrow": [
    "35313",
    9,
    "41130"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/styles.ts": [
    "93983",
    9,
    "41460"
  ],
  "./_deziiign/main/pages/eduTagAdmin/": [
    "25672",
    9,
    "32049"
  ],
  "./_deziiign/kiiids/components/IndexTitle.tsx": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/components/CompetitionFormStart.tsx": [
    "53915",
    9,
    "80328"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/styles.ts": [
    "44479",
    9,
    "69812"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem": [
    "1746",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles.ts": [
    "63011",
    9,
    "58528"
  ],
  "./_deziiign/main/app.tsx": [
    "71236",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "20069"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames": [
    "88358",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField": [
    "70009",
    9,
    "30818"
  ],
  "./_deziiign/s-music/routesList.tsx": [
    "10621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31790"
  ],
  "./_deziiign/s-arthistory/routesList": [
    "7121",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87306"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/styles": [
    "50263",
    9,
    "88988"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 120.jpg": [
    "90723",
    1,
    "31616"
  ],
  "./_deziiign/hsehh/styles": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/CompetitionsAdmin/const": [
    "67035",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/styles.ts": [
    "54038",
    9,
    "94395"
  ],
  "./_geograffee/dafes/images/A1_curators_project.jpg": [
    "84922",
    1,
    "35207"
  ],
  "./_deziiign/musicmediiia/app.tsx": [
    "62630",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58923"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/ProfilesDropdownIcon": [
    "77711",
    9,
    "71300"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 121.jpg": [
    "68550",
    1,
    "3243"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/StartupsBlock.tsx": [
    "94425",
    9,
    "95992",
    "26274"
  ],
  "./_deziiign/s-psychology/routesList.tsx": [
    "81139",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25680"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/const": [
    "93273",
    9,
    "16514"
  ],
  "./_competition/pages/ProjectsPage": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/hseanimation/app.tsx": [
    "36769",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25562"
  ],
  "./_deziiign/hseanimation/routesList": [
    "27072",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "55417"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage": [
    "44676",
    9,
    "645"
  ],
  "./_fr/paris/routesList.tsx": [
    "21048",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "70881"
  ],
  "./_deziiign/lmshsecreative/app": [
    "59520",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64665"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/JoinEcosystemForm": [
    "67138",
    9,
    "95992",
    "54911",
    "46248"
  ],
  "./_deziiign/s-philology/routesList.tsx": [
    "22217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "1490"
  ],
  "./_deziiign/lmshsecreative/routesList": [
    "83811",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "91424"
  ],
  "./_deziiign/jhonatanet/styles": [
    "57886",
    9,
    "19987"
  ],
  "./_geograffee/dafes/icons/awardsNominations/CGRaveIcon.tsx": [
    "77373",
    9,
    "54030"
  ],
  "./_geograffee/dafes/icons/awardsNominations/SberIcon": [
    "25089",
    9,
    "76442"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolIcon.tsx": [
    "87332",
    9,
    "53797"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map.tsx": [
    "72684",
    9,
    "6602",
    "96678",
    "52477",
    "30153"
  ],
  "./_deziiign/main/pages/MainTagAdminPage": [
    "53920",
    9,
    "8985"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueList.tsx": [
    "33420",
    9,
    "99037"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style.ts": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/prev.svg": [
    "89819",
    1,
    "59528"
  ],
  "./_deziiign/jhonatanet/app.tsx": [
    "39063",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "36220"
  ],
  "./_deziiign/main/pages/eduTagAdmin": [
    "25672",
    9,
    "32049"
  ],
  "./_deziiign/school/utils": [
    "89716",
    9,
    "99509"
  ],
  "./_geograffee/dafes/icons/awardsNominations/System108Icon.tsx": [
    "94777",
    9,
    "15874"
  ],
  "./_deziiign/books/core/hook/api/useBook.ts": [
    "97393",
    9,
    "75882"
  ],
  "./_geograffee/dafes/images/university_slider_item_4.png": [
    "97557",
    1,
    "80982"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage.tsx": [
    "94292",
    9,
    "24074",
    "47268",
    "83275",
    "78037"
  ],
  "./_competition/pages/CompetitionsAdmin/style.ts": [
    "31209",
    9,
    "6290"
  ],
  "./_fr/dubai/routesList.tsx": [
    "94158",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99299"
  ],
  "./_fr/shanghai/routesList.tsx": [
    "7100",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88557"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/styles": [
    "54038",
    9,
    "94395"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableComponent": [
    "92736",
    9,
    "71641"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/sliderImages": [
    "58412",
    9,
    "68189"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange.tsx": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_geograffee/dafes/images/globe.png": [
    "90623",
    1,
    "78068"
  ],
  "./_deziiign/hsedesign/pages/TagExpertsPage/TagExpertsPage.tsx": [
    "12022",
    9,
    "26139"
  ],
  "./_geograffee/dafes/icons/ADCRBlockIcon": [
    "27492",
    9,
    "869"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock.tsx": [
    "2850",
    9,
    "58591"
  ],
  "./_deziiign/books/pages/tag/index": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-b1e23c003f964e53b854f41d957276da.jpg": [
    "22485",
    1,
    "21174"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/sportmediiia/app": [
    "37223",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "4076"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.tsx": [
    "99082",
    9
  ],
  "./_deziiign/s-hseissek/routesList": [
    "5391",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76228"
  ],
  "./_deziiign/s-urban-development/routesList.tsx": [
    "14622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "14419"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher.tsx": [
    "51152",
    9
  ],
  "./_geograffee/dafes/pages/CountryShowcase": [
    "62779",
    9,
    "15969",
    "6049",
    "99448",
    "16433"
  ],
  "./_deziiign/newcha/app": [
    "21659",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1544"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader": [
    "6371",
    9,
    "95360"
  ],
  "./_deziiign/booksmediiia/routesList": [
    "69210",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44807"
  ],
  "./_deziiign/continuumsite/img/image_1440.png": [
    "58626",
    1,
    "3167"
  ],
  "./_deziiign/hsecreative/styles": [
    "41431",
    9,
    "7036"
  ],
  "./_deziiign/historymediiia/app": [
    "70761",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd.tsx": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/books/pages/sections/ps-chapters.tsx": [
    "10434",
    9
  ],
  "./_deziiign/s-mathematics/app": [
    "63417",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "3138"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-7159820a94224b8cb5492a4bc97815ea.jpg": [
    "4864",
    1,
    "22585"
  ],
  "./_deziiign/hsehh/app.tsx": [
    "3651",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94624"
  ],
  "./_fr/paris/routesList": [
    "21048",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "70881"
  ],
  "./_geograffee/dafes/images/industry_features.png": [
    "51696",
    1,
    "34505"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip.tsx": [
    "67816",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.css": [
    "86691",
    9,
    "63008"
  ],
  "./_deziiign/hsestart/styles.tsx": [
    "69730",
    9,
    "59551"
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud.tsx": [
    "40443",
    9,
    "41480"
  ],
  "./_deziiign/historymediiia/routesList": [
    "93384",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "24881"
  ],
  "./_deziiign/alshibaya/routesList": [
    "76808",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21649"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsDafesIcon.tsx": [
    "33661",
    9,
    "59502"
  ],
  "./_deziiign/continuumsite/img/image_320.png": [
    "76496",
    1,
    "92841"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconEn.tsx": [
    "50085",
    9,
    "134"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts": [
    "61644",
    9,
    "82173"
  ],
  "./_deziiign/storiesmediiia/routesList.tsx": [
    "88515",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20800"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/styles.ts": [
    "86826",
    9,
    "32375"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flagtop.svg": [
    "57053",
    1,
    "56942"
  ],
  "./_deziiign/fashion/app": [
    "979",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71856"
  ],
  "./_deziiign/s-political-science/routesList.tsx": [
    "7938",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "90783"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PauseIcon": [
    "7356",
    9,
    "20173"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 118.jpg": [
    "35638",
    1,
    "81275"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-3fd8cec4336a4139ac92529fdbef0d8f.jpg": [
    "57611",
    1,
    "57272"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPageNew": [
    "51019",
    9,
    "50333",
    "36435",
    "99640"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/styles.ts": [
    "88198",
    9,
    "58187"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/WhiteTopBlock.tsx": [
    "16141",
    9,
    "95992",
    "72446"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/FormsComponent.tsx": [
    "98547",
    9,
    "95312"
  ],
  "./_competition/pages/CompetitionResultsPage/index": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField": [
    "34897",
    9,
    "40266"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/icons/Arrows.tsx": [
    "75562",
    9,
    "59639"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/jhonatanet/app": [
    "39063",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "36220"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItem": [
    "40634",
    9,
    "23943"
  ],
  "./_competition/pages/AllCompetitionsPage/": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/s-extra/routesList.tsx": [
    "54128",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "60809"
  ],
  "./_deziiign/aimediiia/routesList.tsx": [
    "83870",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42291"
  ],
  "./_deziiign/s-hseincomm/routesList.tsx": [
    "61265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85322"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName.tsx": [
    "20936",
    9
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField.tsx": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/main/pages/moderHseView/index.ts": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_geograffee/dafes/images/university_slider_item_1.png": [
    "7976",
    1,
    "79025"
  ],
  "./_deziiign/cinemediiia/app": [
    "27588",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50533"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage": [
    "22570",
    9,
    "6244"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableLinkSortBlock": [
    "46829",
    9,
    "58599"
  ],
  "./_deziiign/s-history/routesList.tsx": [
    "74294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58971"
  ],
  "./_geograffee/dafes/icons/GoldBlockThreeIcon.tsx": [
    "40394",
    9,
    "88631"
  ],
  "./_geograffee/dafes/pages/DafesOrgPage": [
    "81564",
    9,
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293"
  ],
  "./_deziiign/onlines/routesList.tsx": [
    "68354",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6047"
  ],
  "./_deziiign/ranepa/app.tsx": [
    "96030",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83059"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer": [
    "13411",
    9,
    "41906"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/blocks.svg": [
    "75650",
    1,
    "84127"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner": [
    "8700",
    9,
    "13908",
    "21565",
    "5357"
  ],
  "./_kz/pro/routesList.tsx": [
    "2265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "92034"
  ],
  "./_deziiign/books/pages/sections/assets/link.svg": [
    "12118",
    1,
    "187"
  ],
  "./_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions.ts": [
    "63349",
    9
  ],
  "./_deziiign/automediiia/routesList.tsx": [
    "83561",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54130"
  ],
  "./_deziiign/main/styles": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/namesmediiia/app": [
    "47185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "55402"
  ],
  "./_deziiign/artmediiia/app": [
    "43916",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "6749"
  ],
  "./_deziiign/s-arthistory/routesList.tsx": [
    "7121",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87306"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController.tsx": [
    "90929",
    9,
    "68778"
  ],
  "./_fr/marseille/routesList.tsx": [
    "70005",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81782"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathRight.svg": [
    "31052",
    1,
    "34813"
  ],
  "./_geograffee/dafes/images/A1_curators_projectEN.jpg": [
    "64595",
    1,
    "93328"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/StartupsBlock": [
    "94425",
    9,
    "95992",
    "26274"
  ],
  "./_deziiign/books/core/components/shareButton/": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/s-economy/routesList.tsx": [
    "59950",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8771"
  ],
  "./_deziiign/urbanmediiia/app": [
    "22093",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5214"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ.tsx": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner.tsx": [
    "8700",
    9,
    "13908",
    "21565",
    "5357"
  ],
  "./_geograffee/dafes/images/E1_educational_courseEN.jpg": [
    "52323",
    1,
    "46848"
  ],
  "./_geograffee/dafes/images/S1_brand_year.jpg": [
    "44734",
    1,
    "80051"
  ],
  "./_deziiign/books/core/hook/api/useBook": [
    "97393",
    9,
    "75882"
  ],
  "./_kz/dafes-fashion/app.tsx": [
    "78105",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "90146"
  ],
  "./_deziiign/superpuper/styles.tsx": [
    "45757",
    9,
    "16398"
  ],
  "./_competition/components/CompetitionFormStart": [
    "53915",
    9,
    "80328"
  ],
  "./_geograffee/dafes/images/A1_best_research_publication.jpg": [
    "69180",
    1,
    "93261"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/validateForm": [
    "49918",
    9,
    "97568"
  ],
  "./_deziiign/main/pages/tagAdmin/index.ts": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/admediiia/app.tsx": [
    "9468",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38445"
  ],
  "./_deziiign/brnd/routesList": [
    "59684",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21733"
  ],
  "./_fr/saopaulo/styles.tsx": [
    "78093",
    9,
    "32766"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/s-cinema/routesList.tsx": [
    "18301",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5262"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/automediiia/app": [
    "38106",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99687"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/hsedesign/utils/index.ts": [
    "46106",
    9,
    "87527"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolIcon": [
    "87332",
    9,
    "53797"
  ],
  "./_deziiign/main/routesList": [
    "67087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47108"
  ],
  "./_deziiign/books/pages/sections/ps-chapters": [
    "10434",
    9
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutPageBlock": [
    "76486",
    9,
    "27691"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/styles.ts": [
    "42776",
    9,
    "31854"
  ],
  "./_deziiign/main/pages/projectDeziign": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_kz/dafes/constants/segments.ts": [
    "1953",
    9
  ],
  "./_deziiign/s-biology/routesList.tsx": [
    "28257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "73402"
  ],
  "./_deziiign/onlines/styles.tsx": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/books/app": [
    "52905",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/musicmediiia/routesList.tsx": [
    "17469",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23406"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles": [
    "18626",
    9,
    "59871"
  ],
  "./_deziiign/cgrave/app": [
    "48621",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "63934"
  ],
  "./_competition/components/SendProjectButton.tsx": [
    "26709",
    9
  ],
  "./_deziiign/historymediiia/app.tsx": [
    "70761",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField.tsx": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/pro/app": [
    "31834",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43559"
  ],
  "./_deziiign/books/pages/BookEdit": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/books/pages/BookListView/": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/NewsPlayer.tsx": [
    "88362",
    9,
    "21591"
  ],
  "./_competition/pages/JuryPage/index.ts": [
    "5122",
    9,
    "91967"
  ],
  "./_geograffee/dafes/images/university_features.png": [
    "50754",
    1,
    "16863"
  ],
  "./_deziiign/s-hseissek/app": [
    "10052",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21285"
  ],
  "./_deziiign/galllleryart/routesList.tsx": [
    "43137",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93914"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField.tsx": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/ageytomesh/app": [
    "61045",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "24822"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index.ts": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip": [
    "67816",
    9
  ],
  "./_deziiign/awards/components/IndexTitle": [
    "81233",
    9,
    "96362"
  ],
  "./_geograffee/dafes/images/awards2026/footerLogo.svg": [
    "92143",
    1,
    "38084"
  ],
  "./_ftbl/main/app.tsx": [
    "87614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "63539"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-1f55d88a80954bf18d195d44424e782c.jpg": [
    "40417",
    1,
    "87226"
  ],
  "./_deziiign/dvadesign/routesList": [
    "13069",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53918"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions.ts": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/ranepa/styles.tsx": [
    "5465",
    9,
    "62338"
  ],
  "./_fr/saopaulo/styles": [
    "78093",
    9,
    "32766"
  ],
  "./_deziiign/kiiids/styles": [
    "19025",
    9,
    "99402"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner3.svg": [
    "91900",
    1,
    "29293"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Profiles": [
    "70198",
    9,
    "95992",
    "86811"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage.tsx": [
    "2925",
    9,
    "99358"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/HeaderAwards2025.tsx": [
    "83534",
    9,
    "94498",
    "71779"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/PartnersAwards2025.tsx": [
    "5168",
    9,
    "94498",
    "28809"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustratonFour.svg": [
    "2724",
    1,
    "96069"
  ],
  "./_geograffee/dafes/icons/awardsNominations/HSEArtDesignIcon": [
    "32474",
    9,
    "58087"
  ],
  "./_deziiign/profmediiia/app.tsx": [
    "18186",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51031"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/JuryAwards2025": [
    "10505",
    9,
    "94498",
    "51058"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableComponent.tsx": [
    "92736",
    9,
    "71641"
  ],
  "./_competition/pages/JuryPage/index": [
    "5122",
    9,
    "91967"
  ],
  "./_geograffee/dafes/images/university_slider_item_3.png": [
    "39610",
    1,
    "6599"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DafesIcon": [
    "81116",
    9,
    "83021"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/CouncilBlock.tsx": [
    "26534",
    9,
    "95992",
    "99723"
  ],
  "./_ftbl/main/assets/icons/TableSortArrow": [
    "48776",
    9,
    "76593"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArrowIcon": [
    "1731",
    9,
    "52928"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/DafesFooter": [
    "48618",
    9,
    "55383"
  ],
  "./_competition/pages/CreateCompetitionPage/index.tsx": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/SmallIcon.tsx": [
    "33897",
    9,
    "11666"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign": [
    "16148",
    9,
    "44821"
  ],
  "./_ftbl/main/hooks/useGetResultsTable": [
    "11716",
    9,
    "33381"
  ],
  "./_deziiign/onlines/pages/readymag/images/bg2Readymag.jpg": [
    "54970",
    1,
    "32487"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField.tsx": [
    "38958",
    9,
    "43907"
  ],
  "./_deziiign/school/utils/": [
    "89716",
    9,
    "99509"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/SmallIcon": [
    "33897",
    9,
    "11666"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit": [
    "441",
    9,
    "70530"
  ],
  "./_competition/pages/ProjectsPage/": [
    "31708",
    9,
    "99309"
  ],
  "./_fr/mumbai/app": [
    "13099",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "78840"
  ],
  "./_competition/pages/AllCompetitionsPage/styled": [
    "70740",
    9
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards.tsx": [
    "70067",
    9
  ],
  "./_uz/main/styles.tsx": [
    "99549",
    9,
    "71950"
  ],
  "./_geograffee/dafes/icons/awardsNominations/SberIcon.tsx": [
    "25089",
    9,
    "76442"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem.tsx": [
    "1746",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage.tsx": [
    "77159",
    9,
    "6636"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner11.svg": [
    "55427",
    1,
    "84704"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/ConnectionFormat.tsx": [
    "51706",
    9,
    "60807"
  ],
  "./_deziiign/s-hsetto/routesList.tsx": [
    "54479",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25668"
  ],
  "./_deziiign/onlines/styles": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage": [
    "55002",
    9,
    "53972"
  ],
  "./_deziiign/s-fashion/routesList": [
    "7386",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "80679"
  ],
  "./_deziiign/s-virtualspace/app": [
    "17978",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "41575"
  ],
  "./_ftbl/main/pages/AllMatches/AllMatchesPage.tsx": [
    "68523",
    9,
    "34486",
    "63800"
  ],
  "./_deziiign/alshibaya/app": [
    "75337",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "81938"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/styles": [
    "34966",
    9,
    "63771"
  ],
  "./_competition/pages/CompetitionTable": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_geograffee/dafes/images/awards2026/slavin.png": [
    "84862",
    1,
    "25107"
  ],
  "./_deziiign/onlinesdesign/pages/CoursesPage": [
    "18602",
    9,
    "70583"
  ],
  "./_geograffee/dafes/icons/footerIcons/TelegramIcon.tsx": [
    "3387",
    9,
    "4689"
  ],
  "./_deziiign/awards/utils/index.ts": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/kiiids/utils": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/continuumsite/styles.ts": [
    "5915",
    9,
    "9064"
  ],
  "./_ftbl/main/assets/icons/CheckedIcon.tsx": [
    "79495",
    9,
    "10316"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/styles.ts": [
    "54922",
    9,
    "37143"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/DigitalEcosystem.tsx": [
    "13236",
    9,
    "95992",
    "48949"
  ],
  "./_deziiign/main/pages/moderView/moderView": [
    "29397",
    9,
    "51382"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage": [
    "8078",
    9,
    "53283"
  ],
  "./_geograffee/dafes/images/awards2026/broche.png": [
    "81616",
    1,
    "25737"
  ],
  "./_fr/marseille/app": [
    "34718",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14707"
  ],
  "./_kz/dafes/app": [
    "5778",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21551"
  ],
  "./_deziiign/game/routesList": [
    "71368",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "75345"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/whatsapp.svg": [
    "12962",
    1,
    "33567"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesTableAction.tsx": [
    "32525",
    9,
    "5894",
    "48958"
  ],
  "./_deziiign/books/core/components/helper/bookEvents": [
    "75209",
    9,
    "73051"
  ],
  "./_geograffee/dafes/images/S1_creative_entrepreneurshipEN.jpg": [
    "94295",
    1,
    "75580"
  ],
  "./_deziiign/main/pages/moderView/index": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/main/pages/projectDeziign/index": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/helpers/getDaysToFinish.ts": [
    "20572",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs.tsx": [
    "70789",
    9,
    "27494"
  ],
  "./_deziiign/lmshse/styles.tsx": [
    "98454",
    9,
    "4731"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid.tsx": [
    "1268",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils.ts": [
    "22125",
    9
  ],
  "./_deziiign/hsespacefilm/app.tsx": [
    "32499",
    9,
    "24074",
    "83762",
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69775",
    "90370",
    "56768",
    "38256"
  ],
  "./_deziiign/kiiids/app.tsx": [
    "43814",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5227"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/CategoriesIcon.tsx": [
    "98064",
    9,
    "8489"
  ],
  "./_geograffee/dafes/images/A4_illustrationEN.jpg": [
    "79973",
    1,
    "42342"
  ],
  "./_deziiign/main/pages/admin/AdminPage": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib2.jpg": [
    "69834",
    1,
    "86007"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/CGRaveIcon.tsx": [
    "74188",
    9,
    "20253"
  ],
  "./_deziiign/foodmediiia/routesList.tsx": [
    "62124",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53245"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/LPUIcon.tsx": [
    "83451",
    9,
    "57352"
  ],
  "./_geograffee/dafes/images/E1_educational_course.jpg": [
    "7050",
    1,
    "66423"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/RauIcon.tsx": [
    "20126",
    9,
    "99731"
  ],
  "./_deziiign/pro/routesList": [
    "16598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "46706"
  ],
  "./_deziiign/transfermediiia/routesList.tsx": [
    "24253",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88494"
  ],
  "./_competition/pages/AllCompetitionsPage/index.tsx": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout": [
    "56925",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList": [
    "84852",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39797"
  ],
  "./_deziiign/adcrdafesnet/styles": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/monalisatravels/app.tsx": [
    "90436",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "77655"
  ],
  "./_deziiign/s-physics/routesList": [
    "36487",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39212"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationsAwards2025": [
    "85602",
    9,
    "94498",
    "43807"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderNextButtonIcon": [
    "26191",
    9,
    "25252"
  ],
  "./_deziiign/main/pages/moderHseView/": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_fr/paris/styles.tsx": [
    "32720",
    9,
    "71913"
  ],
  "./_ftbl/main/hooks/useGetPredictionsInfo": [
    "76678",
    9,
    "97675"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults.tsx": [
    "77349",
    9,
    "96678",
    "52071"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionWinnersPage": [
    "26884",
    9,
    "60901",
    "84869"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookChaptersEdit.tsx": [
    "50250",
    9,
    "3063"
  ],
  "./_deziiign/awards/routesList.tsx": [
    "80164",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "84709"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/ADCRBlock": [
    "27635",
    9,
    "33104"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/AwardsTopBlock.tsx": [
    "98386",
    9,
    "95992",
    "97387",
    "21647"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 127.jpg": [
    "49072",
    1,
    "11881"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/DafesSlider": [
    "7682",
    9,
    "20959"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/FooterAwards2025": [
    "12840",
    9,
    "28977"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 133.jpg": [
    "14163",
    1,
    "23824"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index.ts": [
    "81459",
    9,
    "25872"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/CGRaveIcon": [
    "74188",
    9,
    "20253"
  ],
  "./_geograffee/dafes/images/A9_сoncept_artEN.jpg": [
    "27976",
    1,
    "66385"
  ],
  "./_geograffee/dafes/images/architecture_logo.jpeg": [
    "63361",
    1,
    "42723"
  ],
  "./_deziiign/online/routesList.tsx": [
    "51217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2026"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/PlatformFeatures.tsx": [
    "23507",
    9,
    "83504"
  ],
  "./_ftbl/main/hooks/useChamps": [
    "81764",
    9,
    "37701"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags.tsx": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/hsespace/routesList": [
    "82760",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31889"
  ],
  "./_deziiign/s-oriental/app": [
    "43791",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39300"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation.tsx": [
    "36014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign.tsx": [
    "13598",
    9,
    "72339"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesBigButton": [
    "38385",
    9,
    "85066"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/isCardBlockedForPaidBook.ts": [
    "44387",
    9
  ],
  "./_deziiign/urbanmediiia/app.tsx": [
    "22093",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5214"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesSettings": [
    "90368",
    9,
    "5894",
    "86041"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/shouldShowCompetitionWinnersPage": [
    "56273",
    9,
    "85482"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit": [
    "85441",
    9,
    "60901",
    "83162"
  ],
  "./_deziiign/books/pages/BookEdit/providers/bookEditorProvider": [
    "54729",
    9
  ],
  "./_deziiign/s-psychology/app": [
    "32336",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31145"
  ],
  "./_deziiign/hsespace/utils/index.ts": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput": [
    "24471",
    9,
    "76604"
  ],
  "./_competition/pages/CreateCompetitionPage/styles": [
    "31768",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-c81e874146014a78b8eb5c66a8698486.jpg": [
    "24305",
    1,
    "77546"
  ],
  "./_deziiign/s-hseincomm/app.tsx": [
    "30562",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59711"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationsAwards2025.tsx": [
    "85602",
    9,
    "94498",
    "43807"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/flags.png": [
    "19831",
    1,
    "78652"
  ],
  "./_deziiign/prohse/routesList": [
    "20171",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21048"
  ],
  "./_deziiign/books/helpers/copyLink.ts": [
    "77885",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/const": [
    "4293",
    9,
    "34182"
  ],
  "./_deziiign/s-chemistry/app.tsx": [
    "5001",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86130"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSectionContent": [
    "29996",
    9,
    "73917"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/UserTable.tsx": [
    "40174",
    9,
    "32611"
  ],
  "./_geograffee/dafes/images/fotolab_logo.png": [
    "28057",
    1,
    "39202"
  ],
  "./_kz/pro/app": [
    "4989",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76311"
  ],
  "./_deziiign/s-hseissek/app.tsx": [
    "10052",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21285"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information.tsx": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/hsestart/styles": [
    "69730",
    9,
    "59551"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/ProfilesIcon": [
    "91598",
    9,
    "93699"
  ],
  "./_deziiign/continuumsite/app.tsx": [
    "36526",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "85059"
  ],
  "./_deziiign/namesmediiia/routesList.tsx": [
    "89232",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95145"
  ],
  "./_deziiign/school/routesList.tsx": [
    "262",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87723"
  ],
  "./_geograffee/dafes/images/A9_сoncept_art.jpg": [
    "17841",
    1,
    "56970"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/styles.ts": [
    "71583",
    9,
    "30100"
  ],
  "./_deziiign/main/app": [
    "71236",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "20069"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/BigIcon": [
    "60082",
    9,
    "27567"
  ],
  "./_deziiign/awards/styles": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/pro/app.tsx": [
    "31834",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43559"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage.tsx": [
    "166",
    9
  ],
  "./_deziiign/s-advertising-and-pr/app.tsx": [
    "98286",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31267"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/ProfilesDropdownIcon.tsx": [
    "77711",
    9,
    "71300"
  ],
  "./_competition/pages/ShortListPage/components/NominationName": [
    "21214",
    9
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook": [
    "82452",
    9
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 117.jpg": [
    "95749",
    1,
    "85446"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/NominationsList": [
    "73450",
    9,
    "26199"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles.ts": [
    "28565",
    9,
    "72054"
  ],
  "./_geograffee/dafes/icons/IntegrationBlockIcon.tsx": [
    "37848",
    9,
    "9473"
  ],
  "./_deziiign/s-cognitive/app": [
    "94287",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "52100"
  ],
  "./_ftbl/main/types/table": [
    "59446",
    9,
    "81851"
  ],
  "./_deziiign/s-international-relations/routesList": [
    "48390",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99627"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/GreenIcon": [
    "91303",
    9,
    "26636"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_deziiign/continuumsite/app": [
    "36526",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "85059"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/ADCRIcon.tsx": [
    "64702",
    9,
    "62227"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/HSEArtIcon": [
    "34205",
    9,
    "61262"
  ],
  "./_geograffee/dafes/icons/awardsNominations/HSEArtDesignIcon.tsx": [
    "32474",
    9,
    "58087"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField.tsx": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon": [
    "37305",
    9,
    "610"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/IrkiIcon": [
    "64708",
    9,
    "80444"
  ],
  "./_deziiign/books/pages/BookEdit/index.ts": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/books/core/components/shareButton/shareButton.tsx": [
    "88300",
    9,
    "45757"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/NominationsIcon": [
    "54893",
    9,
    "42654"
  ],
  "./_deziiign/galllleryart/styles": [
    "78199",
    9,
    "52700"
  ],
  "./_competition/pages/PreRegistrationResult/style": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/greenaward/components/IndexTitle.tsx": [
    "69371",
    9,
    "88360"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconEn": [
    "9688",
    9,
    "72001"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard.tsx": [
    "47486",
    9
  ],
  "./_deziiign/monalisatravels/routesList": [
    "58745",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "93410"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderFashionIcon": [
    "42216",
    9,
    "43793"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/Search": [
    "72663",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/styles.ts": [
    "80724",
    9,
    "57141"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid": [
    "1268",
    9
  ],
  "./_ftbl/main/assets/clubEmblems/Olympia_Munich.png": [
    "77404",
    1,
    "58637"
  ],
  "./_deziiign/onlinesdesign/pages/CoursesPage.tsx": [
    "18602",
    9,
    "70583"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar.tsx": [
    "89260",
    9,
    "13908",
    "21565"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/TechnologicalBlock": [
    "2303",
    9,
    "95992",
    "44372"
  ],
  "./_deziiign/books/constants.ts": [
    "17857",
    9
  ],
  "./_deziiign/s-biology/app": [
    "72594",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "77743"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/styles": [
    "24222",
    9,
    "96467"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 134.jpg": [
    "43232",
    1,
    "85049"
  ],
  "./_geograffee/dafes/pages/data/nominationsData": [
    "67760",
    9,
    "77097"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useChapterPosts.tsx": [
    "67007",
    9
  ],
  "./_deziiign/s-chemistry/routesList.tsx": [
    "77800",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "10897"
  ],
  "./_deziiign/prohse/routesList.tsx": [
    "20171",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21048"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout.tsx": [
    "80714",
    9,
    "51735"
  ],
  "./_fr/main/app.tsx": [
    "77753",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "65954"
  ],
  "./_deziiign/lpudesign/app": [
    "34912",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title": [
    "20187",
    9,
    "69512"
  ],
  "./_geograffee/dafes/images/awards2026/headerBg.png": [
    "29741",
    1,
    "30910"
  ],
  "./_deziiign/naturemediiia/app": [
    "78614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51835"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/styles": [
    "71002",
    9,
    "39495"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-1f55d88a80954bf18d195d44424e782c.jpg": [
    "59703",
    1,
    "35484"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/s-extra/routesList": [
    "54128",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "60809"
  ],
  "./_deziiign/sciencemediiia/routesList": [
    "38466",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7775"
  ],
  "./_competition/components/CompetitionFormSuccess.tsx": [
    "2402",
    9,
    "63231"
  ],
  "./_competition/pages/CompetitionsAdmin/components/TableContent": [
    "53556",
    9,
    "69301"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/getFilteredCompetitionsById": [
    "61669",
    9,
    "35494"
  ],
  "./_deziiign/newcha/app.tsx": [
    "21659",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1544"
  ],
  "./_competition/pages/AllCompetitionsPage/index": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon": [
    "1113",
    9,
    "86466"
  ],
  "./_fr/bengaluru/styles": [
    "80904",
    9,
    "18705"
  ],
  "./_deziiign/books/core/components/grid/": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/hsecreative/app": [
    "90600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38161"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map": [
    "72684",
    9,
    "6602",
    "96678",
    "52477",
    "30153"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage": [
    "908",
    9,
    "10717"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts.ts": [
    "2696",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/styles.ts": [
    "34966",
    9,
    "63771"
  ],
  "./_competition/pages/ShortListPage/components/NominationName.tsx": [
    "21214",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories.tsx": [
    "93506",
    9
  ],
  "./_ftbl/main/constants/countryIndexes.ts": [
    "33770",
    9
  ],
  "./_deziiign/fairartz/routesList.tsx": [
    "15737",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8546"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index.ts": [
    "68671",
    9,
    "3924"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 119.jpg": [
    "90899",
    1,
    "79376"
  ],
  "./_deziiign/galllleryart/app.tsx": [
    "94354",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "35727"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/pen.svg": [
    "99569",
    1,
    "42218"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit.tsx": [
    "85441",
    9,
    "60901",
    "83162"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon.tsx": [
    "1113",
    9,
    "86466"
  ],
  "./_deziiign/books/routesList.tsx": [
    "26760",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star1.svg": [
    "55036",
    1,
    "19789"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput.ts": [
    "24471",
    9,
    "76604"
  ],
  "./_geograffee/dafes/images/A4_illustration.jpg": [
    "78256",
    1,
    "80937"
  ],
  "./_kz/dafes-art/app": [
    "8294",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22731"
  ],
  "./_deziiign/online/utils/": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/sportmediiia/routesList": [
    "81858",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "19743"
  ],
  "./_deziiign/s-mathematics/app.tsx": [
    "63417",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "3138"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/books/core/common.ts": [
    "62913",
    9,
    "82989"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/specialCompetitionHelpers": [
    "97666",
    9,
    "44735"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsBigIcon": [
    "74146",
    9,
    "27551"
  ],
  "./_deziiign/hsehh/app": [
    "3651",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94624"
  ],
  "./_competition/pages/AllCompetitionsPage/types/types": [
    "49608",
    9
  ],
  "./_deziiign/books/core/hook/api/useBookList": [
    "72617",
    9,
    "96850"
  ],
  "./_geograffee/dafes/pages/data/profilesData": [
    "69221",
    9,
    "89830"
  ],
  "./_competition/pages/PreRegistrationResult/index": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderDesignIcon.tsx": [
    "56298",
    9,
    "30039"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/rm.svg": [
    "87720",
    1,
    "29873"
  ],
  "./_deziiign/hsehh/routesList.tsx": [
    "11862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40283"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PlayIcon": [
    "1764",
    9,
    "60261"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner4.svg": [
    "66531",
    1,
    "36384"
  ],
  "./_fr/dubai/styles": [
    "89222",
    9,
    "43179"
  ],
  "./_competition/components/style.ts": [
    "10301",
    9
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/DafesPartnersBlock": [
    "76263",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "7020"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserInfo.tsx": [
    "59935",
    9,
    "90109"
  ],
  "./_deziiign/school/pages/init": [
    "74957",
    9,
    "48382"
  ],
  "./_deziiign/s-physics/routesList.tsx": [
    "36487",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39212"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/shouldShowCompetitionWinnersPage.ts": [
    "56273",
    9,
    "85482"
  ],
  "./_deziiign/s-hsetto/app.tsx": [
    "97284",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94949"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileReadymag.svg": [
    "65300",
    1,
    "37804"
  ],
  "./_deziiign/hsespace/routesList.tsx": [
    "82760",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31889"
  ],
  "./_geograffee/dafes/icons/footerIcons/FooterLogo": [
    "31086",
    9,
    "68739"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathLeft.svg": [
    "865",
    1,
    "68250"
  ],
  "./_deziiign/greenaward/app.tsx": [
    "39231",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "84116"
  ],
  "./_ftbl/main/helpers/dateFormatting": [
    "85991",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plantbig.svg": [
    "4083",
    1,
    "42736"
  ],
  "./_fr/delhi/routesList": [
    "60381",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "96046"
  ],
  "./_geograffee/dafes/images/F1_fashion_photoEN.jpg": [
    "3548",
    1,
    "15309"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index.ts": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/s-advertising-and-pr/app": [
    "98286",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31267"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconRu.tsx": [
    "26215",
    9,
    "85772"
  ],
  "./_deziiign/hsecreative/routesList.tsx": [
    "23307",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99416"
  ],
  "./_deziiign/greenaward/utils/": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsedesign/utils/index": [
    "46106",
    9,
    "87527"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/s-arthistory/app": [
    "56821",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28927"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_ftbl/main/assets/clubEmblems/Babylon_Berlin_International_2.png": [
    "49202",
    1,
    "43407"
  ],
  "./_deziiign/dvadesign/routesList.tsx": [
    "13069",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53918"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/styles": [
    "36047",
    9,
    "25412"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/fashion-ae99c77bdc6b4a4db8f14b88e662212f.jpg": [
    "1667",
    1,
    "88768"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblTitle": [
    "32877",
    9,
    "49438"
  ],
  "./_deziiign/aki/app.tsx": [
    "84085",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9695"
  ],
  "./_deziiign/onlinesdesign/app": [
    "61389",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59870"
  ],
  "./_deziiign/main/pages/admin/AdminPage.tsx": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/fashionmediiia/app.tsx": [
    "96925",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "82734"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesPageTabPanel.tsx": [
    "25859",
    9,
    "46464"
  ],
  "./_deziiign/books/core/components/tooltips/index.ts": [
    "40356",
    9
  ],
  "./_deziiign/s-history/app.tsx": [
    "25571",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83552"
  ],
  "./_ftbl/main/assets/clubEmblems/Hercules_Barcelona_2.png": [
    "24432",
    1,
    "81321"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/fairmediiia/routesList": [
    "78294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97243"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderStartupsIcon.tsx": [
    "80866",
    9,
    "9439"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs.ts": [
    "1325",
    9
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/kiiidsmediiia/app.tsx": [
    "30378",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28471"
  ],
  "./_geograffee/dafes/images/D1_identity_and_brandingEN.jpg": [
    "29765",
    1,
    "83238"
  ],
  "./_deziiign/adcrdafesnet/app.tsx": [
    "72893",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "68398"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage.tsx": [
    "69662",
    9,
    "87616"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSection": [
    "79835",
    9,
    "2760"
  ],
  "./_competition/pages/AllOpenCalls.tsx": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles.ts": [
    "14954",
    9,
    "94807"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_uz/main/styles": [
    "99549",
    9,
    "71950"
  ],
  "./_uz/main/app.tsx": [
    "4050",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28431"
  ],
  "./_deziiign/hsedesign/components/IndexTitle": [
    "91797",
    9
  ],
  "./_deziiign/kiiids/utils/": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/galllleryart/app": [
    "94354",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "35727"
  ],
  "./_deziiign/booksmediiia/routesList.tsx": [
    "69210",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44807"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/styles": [
    "10145",
    9,
    "538"
  ],
  "./_geograffee/dafes/pages/DafesOrgPage.tsx": [
    "81564",
    9,
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293"
  ],
  "./_fr/mumbai/routesList": [
    "58622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87443"
  ],
  "./_geograffee/dafes/images/F1_jewellery_designEN.jpg": [
    "53715",
    1,
    "53392"
  ],
  "./_geograffee/dafes/images/slide_item_6.png": [
    "50678",
    1,
    "99739"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/const.ts": [
    "4293",
    9,
    "34182"
  ],
  "./_competition/pages/CompetitionsAdmin/style": [
    "31209",
    9,
    "6290"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesTableAction": [
    "32525",
    9,
    "5894",
    "48958"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsDafesIcon": [
    "33661",
    9,
    "59502"
  ],
  "./_competition/helpers/getCompetitionStatus": [
    "30100",
    9
  ],
  "./_deziiign/books/core/components/shareButton/shareButton": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/jhonatanet/routesList.tsx": [
    "98162",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54319"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title.tsx": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/lmshse/routesList.tsx": [
    "89406",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21267"
  ],
  "./_deziiign/awards/components/IndexTitle.tsx": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title": [
    "35075",
    9,
    "95008"
  ],
  "./_ftbl/main/helpers/dateFormatting.ts": [
    "85991",
    9
  ],
  "./_deziiign/sciencemediiia/routesList.tsx": [
    "38466",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7775"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo.tsx": [
    "70085",
    9
  ],
  "./_deziiign/historymediiia/routesList.tsx": [
    "93384",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "24881"
  ],
  "./_competition/components/imageTS.png": [
    "12968",
    1,
    "9489"
  ],
  "./_geograffee/dafes/images/S1_creative_entrepreneurship.jpg": [
    "96270",
    1,
    "16003"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools.tsx": [
    "56695",
    9,
    "76412"
  ],
  "./_deziiign/books/pages/BookEdit/styles.ts": [
    "27552",
    9
  ],
  "./_competition/app": [
    "29104",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98441"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_deziiign/hsedesign/routesList.tsx": [
    "28344",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54529"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_ftbl/main/assets/clubEmblems/Solidarity_Warsaw.png": [
    "10258",
    1,
    "63279"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader.tsx": [
    "6371",
    9,
    "95360"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage": [
    "97566",
    9
  ],
  "./_ftbl/main/constants/tableHeader": [
    "44616",
    9,
    "24712"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth.tsx": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList.tsx": [
    "81206",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "66107"
  ],
  "./_deziiign/s-pro/routesList.tsx": [
    "41741",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35134"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DafesIcon.tsx": [
    "81116",
    9,
    "83021"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/books/pages/tag/tagBookListView": [
    "29236",
    9,
    "13908",
    "21565",
    "57493"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderPrevButtonIcon.tsx": [
    "73059",
    9,
    "86304"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module2.svg": [
    "82931",
    1,
    "65936"
  ],
  "./_geograffee/dafes/images/awards2026/vanders.png": [
    "82244",
    1,
    "72037"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/bgDvaDesign.jpg": [
    "63081",
    1,
    "72658"
  ],
  "./_deziiign/hsestart/routesList.tsx": [
    "94962",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85660"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/BlueBlock.tsx": [
    "16178",
    9,
    "95992",
    "48591"
  ],
  "./_geograffee/dafes/icons/TechnologicalBlockIcon.tsx": [
    "48592",
    9,
    "68329"
  ],
  "./_deziiign/namesmediiia/routesList": [
    "89232",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95145"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_4.png": [
    "79757",
    1,
    "28574"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/ADCRIcon": [
    "64702",
    9,
    "62227"
  ],
  "./_deziiign/s-virtualspace/app.tsx": [
    "17978",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "41575"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/DafesPartnersBlock.tsx": [
    "76263",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "7020"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconRu": [
    "26215",
    9,
    "85772"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage.tsx": [
    "11278",
    9,
    "31120"
  ],
  "./_deziiign/exams/routesList.tsx": [
    "35170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56031"
  ],
  "./_deziiign/lmsmediiia/app": [
    "39117",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59454"
  ],
  "./_deziiign/s-public-administration/routesList": [
    "96916",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "51125"
  ],
  "./_fr/marseille/routesList": [
    "70005",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81782"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SIcon.tsx": [
    "82381",
    9,
    "90951"
  ],
  "./_ftbl/main/hooks/useChamps.ts": [
    "81764",
    9,
    "37701"
  ],
  "./_competition/components/CompetitionDropdown.tsx": [
    "22878",
    9,
    "42419"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/declension": [
    "47607",
    9
  ],
  "./_deziiign/s-geography/app.tsx": [
    "84909",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "12670"
  ],
  "./_geograffee/dafes/images/gold_block_img1.png": [
    "4825",
    1,
    "15362"
  ],
  "./_geograffee/dafes/images/globeWhiteImg.png": [
    "55851",
    1,
    "12920"
  ],
  "./_deziiign/sciencemediiia/app.tsx": [
    "65447",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58028"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField.tsx": [
    "1116",
    9,
    "83917"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/GamesDate.tsx": [
    "42824",
    9,
    "82705"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconEn.tsx": [
    "9688",
    9,
    "72001"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index.ts": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext.tsx": [
    "82310",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "800"
  ],
  "./_deziiign/books/pages/BookListView/index": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles.tsx": [
    "20509",
    9
  ],
  "./_deziiign/online/utils/index": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/hsecreativehub/routesList": [
    "71242",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "57303"
  ],
  "./_deziiign/s-fashion/app": [
    "40127",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93492"
  ],
  "./_deziiign/s-international-relations/app": [
    "57715",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "11408"
  ],
  "./_geograffee/dafes/icons/GoldBlockThreeIcon": [
    "40394",
    9,
    "88631"
  ],
  "./_deziiign/lmshsecreative/app.tsx": [
    "59520",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64665"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderEducationIcon.tsx": [
    "92946",
    9,
    "98639"
  ],
  "./_ftbl/main/pages/MainPage/MainPage": [
    "89526",
    9,
    "17316",
    "71641",
    "60764",
    "46075"
  ],
  "./_kz/dafes/constants/segments": [
    "1953",
    9
  ],
  "./_kz/dafes/routesList.tsx": [
    "56814",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26330"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchsm.svg": [
    "39150",
    1,
    "91907"
  ],
  "./_geograffee/dafes/icons/footerIcons/FooterLogo.tsx": [
    "31086",
    9,
    "68739"
  ],
  "./_deziiign/adcrdafesnet/routesList.tsx": [
    "84852",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39797"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/ConnectionFormat": [
    "51706",
    9,
    "60807"
  ],
  "./_deziiign/greenaward/app": [
    "39231",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "84116"
  ],
  "./_deziiign/newcha/routesList": [
    "3598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58339"
  ],
  "./_competition/pages/JuryPage/": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-media/routesList": [
    "88674",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "89023"
  ],
  "./_competition/const": [
    "19408",
    9
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderNextButtonIcon.tsx": [
    "26191",
    9,
    "25252"
  ],
  "./_deziiign/books/app.tsx": [
    "52905",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/lpudesign/routesList.tsx": [
    "56163",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42368"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/styles": [
    "78462",
    9,
    "90835"
  ],
  "./_deziiign/lpudesign/styles.tsx": [
    "72095",
    9,
    "29364"
  ],
  "./_geograffee/dafes/icons/AddDafesIcon.tsx": [
    "35503",
    9,
    "12324"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image.tsx": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo": [
    "70085",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/StatusesAdminPage": [
    "96596",
    9,
    "5894",
    "86041",
    "95605"
  ],
  "./_deziiign/s-culturology/routesList": [
    "49467",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76872"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 130.jpg": [
    "62532",
    1,
    "86565"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plant.svg": [
    "59903",
    1,
    "7540"
  ],
  "./_deziiign/books/pages/BookEdit/providers/bookEditorProvider.tsx": [
    "54729",
    9
  ],
  "./_deziiign/musicmediiia/routesList": [
    "17469",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23406"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable.tsx": [
    "72383",
    9,
    "22056",
    "80140",
    "38708"
  ],
  "./_deziiign/hsespacefilm/routesList.tsx": [
    "18438",
    9,
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69775",
    "90370",
    "56768",
    "555"
  ],
  "./_competition/pages/ProjectsPage/index": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/s-urban-development/routesList": [
    "14622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "14419"
  ],
  "./_competition/components/CompetitionTagLine.tsx": [
    "23659",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/validateForm.ts": [
    "49918",
    9,
    "97568"
  ],
  "./_deziiign/s-advertising-and-pr/routesList": [
    "2725",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "49510"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/GoldBlock": [
    "85302",
    9,
    "10203"
  ],
  "./_deziiign/onlinesdesign/routesList": [
    "51735",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3813"
  ],
  "./_geograffee/dafes/routesList": [
    "58305",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "43290"
  ],
  "./_deziiign/s-economy/app": [
    "30587",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69032"
  ],
  "./_deziiign/exams/app": [
    "78503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57516"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/styles": [
    "57803",
    9,
    "51672"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/DigitalEcosystem": [
    "13236",
    9,
    "95992",
    "48949"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/s-economy/routesList": [
    "59950",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8771"
  ],
  "./_deziiign/designmediiia/routesList": [
    "17398",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3323"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/styles": [
    "52030",
    9,
    "28051"
  ],
  "./_deziiign/s-jurisprudence/app.tsx": [
    "87039",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64605"
  ],
  "./_deziiign/hsecolors/app.tsx": [
    "19735",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43452"
  ],
  "./_competition/pages/CompetitionResultsPage/": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/s-software-engineering/app": [
    "99790",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14115"
  ],
  "./_deziiign/hsespace/styles.tsx": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/books/core/components/bookCard/style": [
    "94938",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/iqmedia/app": [
    "5142",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57563"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.tsx": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/s-oriental/app.tsx": [
    "43791",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39300"
  ],
  "./_deziiign/s-sociology/routesList": [
    "82256",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26089"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/JoinEcosystemForm.tsx": [
    "67138",
    9,
    "95992",
    "54911",
    "46248"
  ],
  "./_deziiign/s-extra/app": [
    "20657",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21802"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/RauIcon": [
    "20126",
    9,
    "99731"
  ],
  "./_ftbl/main/assets/clubEmblems/Hercules_Barcelona.png": [
    "87591",
    1,
    "10380"
  ],
  "./_kz/pro/app.tsx": [
    "4989",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76311"
  ],
  "./_competition/pages/CreateCompetitionPage/styles.tsx": [
    "31768",
    9
  ],
  "./_deziiign/s-philology/routesList": [
    "22217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "1490"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/styles": [
    "44479",
    9,
    "69812"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/resources.ts": [
    "72627",
    9,
    "52272"
  ],
  "./_competition/components/ImageMob.jpg": [
    "10213",
    1,
    "3782"
  ],
  "./_deziiign/online/app.tsx": [
    "51165",
    9,
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "41317",
    "97775",
    "38815",
    "53966"
  ],
  "./_deziiign/s-fashion/routesList.tsx": [
    "7386",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "80679"
  ],
  "./_competition/helpers/getDaysToFinish": [
    "20572",
    9
  ],
  "./_deziiign/hsedesign/app.tsx": [
    "66841",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99554"
  ],
  "./_ftbl/main/helpers/tableUtils": [
    "75613",
    9,
    "26222"
  ],
  "./_deziiign/awards/utils/": [
    "97022",
    9,
    "7539"
  ],
  "./_fr/shanghai/app.tsx": [
    "59269",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "47046"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSection.tsx": [
    "79835",
    9,
    "2760"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner5.svg": [
    "28594",
    1,
    "38575"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/week.svg": [
    "38988",
    1,
    "55677"
  ],
  "./_deziiign/books/pages/tag/tagBookListView.tsx": [
    "29236",
    9,
    "13908",
    "21565",
    "57493"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage.tsx": [
    "97728",
    9,
    "27769"
  ],
  "./_ftbl/main/routesList.tsx": [
    "2572",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "637"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_1.png": [
    "73760",
    1,
    "24153"
  ],
  "./_deziiign/hsecreative/app.tsx": [
    "90600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38161"
  ],
  "./_geograffee/dafes/images/awards2026/cirkina.png": [
    "70650",
    1,
    "4327"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/style": [
    "39764",
    9,
    "54709"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/types": [
    "79427",
    9,
    "37568"
  ],
  "./_deziiign/hsestart/app.tsx": [
    "36503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "85244"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles.ts": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher": [
    "51152",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionNominatiosBlock": [
    "98635",
    9,
    "36184"
  ],
  "./_ftbl/main/hooks/useGetPredictionsInfo.ts": [
    "76678",
    9,
    "97675"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsNominations.tsx": [
    "60064",
    9,
    "77097",
    "22713",
    "27700"
  ],
  "./_competition/pages/LongListPage/LongListPage": [
    "22197",
    9
  ],
  "./_deziiign/s-architect/app.tsx": [
    "30162",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9775"
  ],
  "./_deziiign/online/utils/index.ts": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/brnd/routesList.tsx": [
    "59684",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21733"
  ],
  "./_ftbl/main/helpers/getInitials": [
    "49335",
    9,
    "45244"
  ],
  "./_fr/saopaulo/app": [
    "10146",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99807"
  ],
  "./_deziiign/s-advertising-and-pr/routesList.tsx": [
    "2725",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "49510"
  ],
  "./_geograffee/dafes/pages/styles": [
    "27162",
    9,
    "5319"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/EducationBlock": [
    "56668",
    9,
    "9348"
  ],
  "./_competition/pages/AllCompetitionsPage/types.ts": [
    "29334",
    9
  ],
  "./_deziiign/main/pages/moderView/": [
    "15597",
    9,
    "70494"
  ],
  "./_ftbl/main/types/table.ts": [
    "59446",
    9,
    "81851"
  ],
  "./_deziiign/lmsmediiia/routesList": [
    "74328",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54209"
  ],
  "./_deziiign/newcha/routesList.tsx": [
    "3598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58339"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_3.png": [
    "49778",
    1,
    "15823"
  ],
  "./_deziiign/books/core/components/bookCard/style.ts": [
    "94938",
    9
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArtIcon": [
    "96271",
    9,
    "44868"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsCrownIcon.tsx": [
    "64309",
    9,
    "19158"
  ],
  "./_deziiign/greenaward/routesList.tsx": [
    "29293",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23591"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/next.svg": [
    "66407",
    1,
    "24780"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/mymediiia/app.tsx": [
    "16439",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94524"
  ],
  "./_deziiign/s-cognitive/routesList.tsx": [
    "92970",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6167"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList": [
    "81206",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "66107"
  ],
  "./_geograffee/dafes/icons/awardsNominations/CGRaveIcon": [
    "77373",
    9,
    "54030"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/styles.ts": [
    "10145",
    9,
    "538"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesComponent.tsx": [
    "33879",
    9,
    "17316",
    "60764"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/specialCompetitionHelpers.tsx": [
    "97666",
    9,
    "44735"
  ],
  "./_kz/dafes-education/routesList.tsx": [
    "74274",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67007"
  ],
  "./_deziiign/school/app.tsx": [
    "46931",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44080"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/UserTable": [
    "40174",
    9,
    "32611"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/PartnersAwards2025": [
    "5168",
    9,
    "94498",
    "28809"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DIcon.tsx": [
    "9737",
    9,
    "34674"
  ],
  "./_deziiign/books/core/components/grid/index.tsx": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/ageytomesh/routesList.tsx": [
    "92044",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67741"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/main/styles.tsx": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/s-music/app.tsx": [
    "62310",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98411"
  ],
  "./_ftbl/main/pages/MainPage/styles": [
    "39174",
    9,
    "95531"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/edu-en-54f240ac75a148a2acac41074ac7527f.jpg": [
    "94106",
    1,
    "99463"
  ],
  "./_competition/pages/CompetitionsAdmin/components/CreateFolderComponent.tsx": [
    "10294",
    9,
    "17275"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/continuumsite/img/image_1920.png": [
    "89373",
    1,
    "48046"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-b1e23c003f964e53b854f41d957276da.jpg": [
    "74065",
    1,
    "79370"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/EditUser.tsx": [
    "68730",
    9,
    "5894"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image": [
    "75542",
    9,
    "13243"
  ],
  "./_ftbl/main/pages/MainPage/styles.ts": [
    "39174",
    9,
    "95531"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer.ts": [
    "13411",
    9,
    "41906"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueItem.tsx": [
    "54921",
    9,
    "46130"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/styles": [
    "97041",
    9,
    "24682"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/styles": [
    "53051",
    9,
    "23867"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "56581",
    9,
    "16646"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/": [
    "71795",
    9
  ],
  "./_geograffee/academy/routesList.tsx": [
    "28768",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71769"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/CouncilBlock": [
    "26534",
    9,
    "95992",
    "99723"
  ],
  "./_deziiign/online/routesList": [
    "51217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2026"
  ],
  "./_deziiign/onlinesdesign/styles.tsx": [
    "60180",
    9,
    "4245"
  ],
  "./_deziiign/onlines/utils/index": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plus.svg": [
    "81440",
    1,
    "40729"
  ],
  "./_deziiign/hsespace/utils/index": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage.tsx": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_competition/pages/ShortListPage/styles": [
    "42270",
    9
  ],
  "./_competition/components/TellingStoriesSuccess.tsx": [
    "43479",
    9,
    "10684"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/ProfilesIcon.tsx": [
    "91598",
    9,
    "93699"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/TagsComponent": [
    "40805",
    9,
    "7494"
  ],
  "./_competition/pages/CompetitionTable/index": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts.ts": [
    "61644",
    9,
    "82173"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation": [
    "36014",
    9
  ],
  "./_deziiign/portfolioartz/routesList": [
    "28207",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45444"
  ],
  "./_fr/mumbai/styles": [
    "26294",
    9,
    "6171"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/vertical_card.svg": [
    "96378",
    1,
    "57159"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblCard": [
    "61365",
    9,
    "34486"
  ],
  "./_deziiign/cgrave/routesList": [
    "7524",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54821"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage.tsx": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage": [
    "166",
    9
  ],
  "./_geograffee/dafes/images/F1_fashion_designEN.jpg": [
    "65130",
    1,
    "31895"
  ],
  "./_deziiign/books/core/components/designerSearch/styles.tsx": [
    "46609",
    9,
    "97450"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/AwardsTopBlock": [
    "98386",
    9,
    "95992",
    "97387",
    "21647"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/declension.ts": [
    "47607",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCheckbox.tsx": [
    "64258",
    9,
    "11679"
  ],
  "./_competition/pages/ShortListPage/ShortListPage.tsx": [
    "37613",
    9
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection": [
    "80194",
    9,
    "59071"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage.tsx": [
    "55002",
    9,
    "53972"
  ],
  "./_deziiign/game/app": [
    "86185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "49170"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField.tsx": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/profmediiia/routesList": [
    "10777",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67810"
  ],
  "./_deziiign/s-software-engineering/routesList.tsx": [
    "45829",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5318"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SIcon": [
    "82381",
    9,
    "90951"
  ],
  "./_deziiign/naturemediiia/routesList": [
    "93869",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97758"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/books/core/components/bookCard/": [
    "21273",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types": [
    "94393",
    9
  ],
  "./_deziiign/naturemediiia/app.tsx": [
    "78614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51835"
  ],
  "./_deziiign/books/pages/BookEdit/": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/ranepa/routesList": [
    "65621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69910"
  ],
  "./_deziiign/lmshsecreative/routesList.tsx": [
    "83811",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "91424"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR.tsx": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage.tsx": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/s-psychology/app.tsx": [
    "32336",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31145"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/HeaderAwards2025": [
    "83534",
    9,
    "94498",
    "71779"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/styles": [
    "95213",
    9,
    "99326"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/GoldBlock.tsx": [
    "85302",
    9,
    "10203"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DIcon": [
    "9737",
    9,
    "34674"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesSmallButton.tsx": [
    "88678",
    9,
    "34603"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit.tsx": [
    "20260",
    9,
    "60901"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock": [
    "2850",
    9,
    "58591"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationThreeReadymag.svg": [
    "6219",
    1,
    "76184"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ.ts": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_fr/dubai/app": [
    "12475",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "72168"
  ],
  "./_deziiign/books/pages/tag/": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_ftbl/main/pages/MainPage/components/GameTabs": [
    "66007",
    9,
    "65148"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-6e63304c030c4c98bbe05fdb5892dd6c.jpg": [
    "8619",
    1,
    "51256"
  ],
  "./_fr/main/routesList.tsx": [
    "41816",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97281"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard.tsx": [
    "35468",
    9
  ],
  "./_deziiign/s-political-science/routesList": [
    "7938",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "90783"
  ],
  "./_deziiign/lmsmediiia/routesList.tsx": [
    "74328",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54209"
  ],
  "./_deziiign/onlinesdesign/styles": [
    "60180",
    9,
    "4245"
  ],
  "./_deziiign/s-management/app.tsx": [
    "46822",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46507"
  ],
  "./_deziiign/s-mathematics/routesList": [
    "82264",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "15905"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner12.svg": [
    "10288",
    1,
    "84009"
  ],
  "./_deziiign/s-urban-development/app.tsx": [
    "69291",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "61528"
  ],
  "./_ftbl/main/helpers/tableUtils.ts": [
    "75613",
    9,
    "26222"
  ],
  "./_deziiign/school/utils/index": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "43782",
    9,
    "33355"
  ],
  "./_geograffee/dafes/images/awards2026/mobileHeaderBgNew.png": [
    "98353",
    1,
    "41354"
  ],
  "./_deziiign/books/core/components/designerSearch/styles": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ps.svg": [
    "48820",
    1,
    "98453"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/styles": [
    "86826",
    9,
    "32375"
  ],
  "./_competition/pages/PreRegistrationResult/index.ts": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/fairmediiia/app": [
    "6467",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "54624"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout.tsx": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate": [
    "52636",
    9,
    "85357"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/slides.tsx": [
    "16420",
    9,
    "53317"
  ],
  "./_geograffee/dafes/images/awards2026/navLogo.svg": [
    "85423",
    1,
    "59108"
  ],
  "./_deziiign/sciencemediiia/app": [
    "65447",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58028"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection": [
    "84390",
    9,
    "33131"
  ],
  "./_fr/bengaluru/routesList": [
    "19488",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3449"
  ],
  "./_deziiign/transfermediiia/app.tsx": [
    "56774",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "70987"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/Timelines": [
    "29534",
    9,
    "36435"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/GamesDate": [
    "42824",
    9,
    "82705"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flag.svg": [
    "58764",
    1,
    "19421"
  ],
  "./_deziiign/s-music/routesList": [
    "10621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31790"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts": [
    "2696",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/styles": [
    "36749",
    9,
    "89854"
  ],
  "./_deziiign/profmediiia/routesList.tsx": [
    "10777",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67810"
  ],
  "./_deziiign/s-cinema/app.tsx": [
    "64646",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "363"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs": [
    "70789",
    9,
    "27494"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblButtons.tsx": [
    "92324",
    9,
    "72133"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconRu.tsx": [
    "75477",
    9,
    "35254"
  ],
  "./_geograffee/dafes/images/F1_fashion_photo.jpg": [
    "14037",
    1,
    "29046"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/startups-4ac9aba7802f4803b36c4c163836bc48.jpg": [
    "15811",
    1,
    "90688"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/slides": [
    "16420",
    9,
    "53317"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage": [
    "21593",
    9,
    "62850"
  ],
  "./_deziiign/books/core/components/bookCard/index.tsx": [
    "21273",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/styles.ts": [
    "24222",
    9,
    "96467"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage": [
    "43455",
    9,
    "54452"
  ],
  "./_ftbl/main/styles.tsx": [
    "5836",
    9,
    "36477"
  ],
  "./_deziiign/artmediiia/app.tsx": [
    "43916",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "6749"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage.tsx": [
    "51697",
    9,
    "73706"
  ],
  "./_deziiign/s-culturology/app.tsx": [
    "9048",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "37729"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/styles.ts": [
    "50263",
    9,
    "88988"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/s-biology/app.tsx": [
    "72594",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "77743"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-3cda2e20741e4b1db94ee060d6a57d36.jpg": [
    "72460",
    1,
    "20701"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner10.svg": [
    "17490",
    1,
    "86895"
  ],
  "./_deziiign/continuumsite/img/image_744.png": [
    "46966",
    1,
    "57627"
  ],
  "./_deziiign/foodmediiia/app": [
    "86805",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59126"
  ],
  "./_deziiign/admediiia/app": [
    "9468",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38445"
  ],
  "./_deziiign/s-culturology/routesList.tsx": [
    "49467",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76872"
  ],
  "./_competition/pages/CompetitionResultsPage/index.tsx": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_fr/main/styles": [
    "40912",
    9,
    "43369"
  ],
  "./_deziiign/s-management/app": [
    "46822",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46507"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/interiorImg.png": [
    "90616",
    1,
    "30689"
  ],
  "./_deziiign/s-virtualspace/routesList.tsx": [
    "22057",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71762"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PlayIcon.tsx": [
    "1764",
    9,
    "60261"
  ],
  "./_deziiign/artmediiia/routesList": [
    "6743",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88156"
  ],
  "./_deziiign/pro/routesList.tsx": [
    "16598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "46706"
  ],
  "./_deziiign/booksgallllery/app.tsx": [
    "76643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "66688"
  ],
  "./_fr/marseille/styles.tsx": [
    "19993",
    9,
    "26050"
  ],
  "./_ftbl/main/types/games.ts": [
    "40701",
    9,
    "84942"
  ],
  "./_fr/kolkata/styles": [
    "6174",
    9,
    "26419"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign.tsx": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage": [
    "11278",
    9,
    "31120"
  ],
  "./_deziiign/greenaward/styles.tsx": [
    "52890",
    9,
    "32455"
  ],
  "./_ftbl/main/app": [
    "87614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "63539"
  ],
  "./_geograffee/academy/routesList": [
    "28768",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71769"
  ],
  "./_deziiign/mymediiia/app": [
    "16439",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94524"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/EducationBlock.tsx": [
    "56668",
    9,
    "9348"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types.ts": [
    "94393",
    9
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationItem.tsx": [
    "18729",
    9,
    "29938"
  ],
  "./_deziiign/hsecreativehub/app.tsx": [
    "44527",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95620"
  ],
  "./_ftbl/main/assets/clubEmblems/Athletic_Moscow.png": [
    "13723",
    1,
    "34792"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage.tsx": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useProjectChapters.tsx": [
    "50502",
    9
  ],
  "./_deziiign/s-jurisprudence/app": [
    "87039",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64605"
  ],
  "./_geograffee/dafes/images/E1_visual_researchEN.jpg": [
    "19435",
    1,
    "62881"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/edu-en-8119c54fba784b5ba27098e025112721.jpg": [
    "7158",
    1,
    "13435"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconEn": [
    "99755",
    9,
    "57336"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage.tsx": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/pages/JuryPage/styles": [
    "80070",
    9
  ],
  "./_uz/main/routesList.tsx": [
    "75937",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2554"
  ],
  "./_deziiign/s-computer-science-and-engineering/app.tsx": [
    "24643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10720"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms": [
    "59628",
    9
  ],
  "./_deziiign/game/app.tsx": [
    "86185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "49170"
  ],
  "./_deziiign/naturemediiia/routesList.tsx": [
    "93869",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97758"
  ],
  "./_competition/helpers/useShowRatingCompetitionTag.ts": [
    "32511",
    9
  ],
  "./_deziiign/s-physics/app.tsx": [
    "76764",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89997"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/NominationsList.tsx": [
    "73450",
    9,
    "26199"
  ],
  "./_kz/dafes/components/SegmentSwitcher": [
    "6992",
    9,
    "9961"
  ],
  "./_deziiign/kiiids/routesList.tsx": [
    "85885",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81038"
  ],
  "./_deziiign/hseanimation/app": [
    "36769",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25562"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs.tsx": [
    "79982",
    9,
    "12035"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolAmIcon": [
    "88622",
    9,
    "8227"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconRu": [
    "24290",
    9,
    "29599"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconEn.tsx": [
    "68643",
    9,
    "37289"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit": [
    "72536",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/styles.ts": [
    "31255",
    9,
    "52828"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/styles": [
    "92847",
    9,
    "77924"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/FooterAwards2025.tsx": [
    "12840",
    9,
    "28977"
  ],
  "./_deziiign/mediiia/routesList": [
    "24864",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45497"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/styles.ts": [
    "7522",
    9,
    "1343"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star2.svg": [
    "57359",
    1,
    "54532"
  ],
  "./_geograffee/dafes/icons/ButtonArrowIcon.tsx": [
    "19980",
    9,
    "61373"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderView": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles.ts": [
    "21768",
    9,
    "89105"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ZharKnigaIcon": [
    "85172",
    9,
    "12789"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_geograffee/dafes/icons/sliderIcons/EIcon.tsx": [
    "56416",
    9,
    "28985"
  ],
  "./_geograffee/dafes/images/awards2026/hse_art_and_design_school_logo_for_site.svg": [
    "90813",
    1,
    "81166"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/BlueBlock": [
    "16178",
    9,
    "95992",
    "48591"
  ],
  "./_deziiign/creativemediiia/app.tsx": [
    "38719",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86621"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus": [
    "89004",
    9,
    "52701"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage.tsx": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer": [
    "29312",
    9,
    "97305"
  ],
  "./_competition/pages/AllCompetitionsPage/styles.css": [
    "30922",
    9,
    "64471"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 122.jpg": [
    "9969",
    1,
    "40170"
  ],
  "./_deziiign/onlines/app.tsx": [
    "51476",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "13836"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblSortBar": [
    "34752",
    9,
    "153"
  ],
  "./_deziiign/s-virtualspace/routesList": [
    "22057",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71762"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSectionContent.tsx": [
    "29996",
    9,
    "73917"
  ],
  "./_deziiign/awards/utils/index": [
    "97022",
    9,
    "7539"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/TitleImg": [
    "63168",
    9,
    "89017"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/hooks/useGetStatusesActions.tsx": [
    "52485",
    9,
    "5894"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext.tsx": [
    "51106",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "32500"
  ],
  "./_deziiign/admediiia/routesList.tsx": [
    "21959",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "34636"
  ],
  "./_deziiign/s-economy/app.tsx": [
    "30587",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69032"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/DesktopReadymag.svg": [
    "11811",
    1,
    "51200"
  ],
  "./_deziiign/s-jurisprudence/routesList.tsx": [
    "35639",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85500"
  ],
  "./_competition/const.ts": [
    "19408",
    9
  ],
  "./_geograffee/main/routesList": [
    "29087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "18900"
  ],
  "./_ftbl/main/assets/icons/TableSortArrow.tsx": [
    "48776",
    9,
    "76593"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/TechnologicalBlock.tsx": [
    "2303",
    9,
    "95992",
    "44372"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames.tsx": [
    "88358",
    9
  ],
  "./_deziiign/awards/utils": [
    "97022",
    9,
    "7539"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard.tsx": [
    "76742",
    9
  ],
  "./_deziiign/books/pages/BookListView/BookListView.tsx": [
    "85406",
    9,
    "13908",
    "21565",
    "5357",
    "96979"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign.tsx": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/hsecolors/styles": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView": [
    "53627",
    9,
    "99272"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 124.jpg": [
    "33407",
    1,
    "11060"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit.tsx": [
    "441",
    9,
    "70530"
  ],
  "./_fr/bengaluru/app": [
    "53377",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46938"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-8bb7da9aca9244d78f72d4d808554f73.jpg": [
    "56184",
    1,
    "28801"
  ],
  "./_deziiign/fashionmediiia/routesList": [
    "77396",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7477"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles": [
    "48516",
    9,
    "73637"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner2.svg": [
    "62525",
    1,
    "48622"
  ],
  "./_deziiign/hsecolors/styles.tsx": [
    "9186",
    9,
    "86719"
  ],
  "./_competition/pages/CompetitionsAdmin/components/CreateFolderComponent": [
    "10294",
    9,
    "17275"
  ],
  "./_deziiign/superpuper/routesList": [
    "76673",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23130"
  ],
  "./_competition/pages/JuryPage": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-architect/routesList.tsx": [
    "52833",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "74394"
  ],
  "./_deziiign/cgrave/routesList.tsx": [
    "7524",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54821"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblButtons": [
    "92324",
    9,
    "72133"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles.ts": [
    "63545",
    9,
    "82850"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_2.png": [
    "54971",
    1,
    "59304"
  ],
  "./_ftbl/main/assets/leagues/spain.png": [
    "71748",
    1,
    "86437"
  ],
  "./_deziiign/eventmediiia/app.tsx": [
    "98329",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5890"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/WhiteMainBlock": [
    "63325",
    9,
    "95992",
    "67566"
  ],
  "./_geograffee/dafes/icons/sliderIcons/EIcon": [
    "56416",
    9,
    "28985"
  ],
  "./_deziiign/aimediiia/app": [
    "49867",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31576"
  ],
  "./_ftbl/main/assets/icons/TableSortLabelIcon": [
    "46",
    9,
    "5155"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput.tsx": [
    "40837",
    9,
    "99142"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueItem": [
    "54921",
    9,
    "46130"
  ],
  "./_deziiign/s-culturology/app": [
    "9048",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "37729"
  ],
  "./_geograffee/dafes/icons/sliderIcons/FIcon.tsx": [
    "53767",
    9,
    "2476"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesInfoComponent.tsx": [
    "69615",
    9,
    "17316"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/HSEArtIcon.tsx": [
    "34205",
    9,
    "61262"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "56581",
    9,
    "16646"
  ],
  "./_competition/pages/AllOpenCalls": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/eventmediiia/routesList.tsx": [
    "4152",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "79073"
  ],
  "./_competition/pages/EmptyPage.tsx": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/lmshse/app.tsx": [
    "59755",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "7512"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookChaptersEdit": [
    "50250",
    9,
    "3063"
  ],
  "./_ftbl/main/hooks/useGetResultsTable.ts": [
    "11716",
    9,
    "33381"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/AboutAwards2025": [
    "44807",
    9,
    "12725"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsNominations": [
    "60064",
    9,
    "77097",
    "22713",
    "27700"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner9.svg": [
    "94486",
    1,
    "57659"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/const.ts": [
    "93273",
    9,
    "16514"
  ],
  "./_deziiign/dvadesign/app.tsx": [
    "31062",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay.tsx": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/urbanmediiia/routesList.tsx": [
    "31300",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58533"
  ],
  "./_geograffee/dafes/pages/data/profilesData.ts": [
    "69221",
    9,
    "89830"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles.ts": [
    "73222",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/DafesFooter.tsx": [
    "48618",
    9,
    "55383"
  ],
  "./_deziiign/hsedesign/utils/": [
    "46106",
    9,
    "87527"
  ],
  "./_deziiign/fashion/app.tsx": [
    "979",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71856"
  ],
  "./_deziiign/books/core/components/tooltips/index": [
    "40356",
    9
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64979;
module.exports = webpackAsyncContext;
var map = {
  "./_deziiign/s-jurisprudence/routesList": [
    "35639",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85500"
  ],
  "./_deziiign/lpudesign/styles": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/adcrdafesnet/app": [
    "72893",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "68398"
  ],
  "./_deziiign/main/pages/moderView/index.ts": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/books/core/components/grid": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles.ts": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/s-geography/routesList.tsx": [
    "10596",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionsAdmin/components/BottomActionMenu": [
    "29489",
    9,
    "93706"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles.ts": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/main/pages/tagAdmin": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_geograffee/dafes/icons/sliderIcons/FIcon": [
    "53767",
    9,
    "2476"
  ],
  "./_ftbl/main/assets/leagues/italy.png": [
    "62782",
    1,
    "59283"
  ],
  "./_geograffee/dafes/icons/awardsNominations/System108Icon": [
    "94777",
    9,
    "15874"
  ],
  "./_competition/pages/PreRegistrationResult": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/onlines/routesList": [
    "68354",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6047"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign.tsx": [
    "61848",
    9,
    "45825"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles.ts": [
    "93487",
    9,
    "77316"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilDafesIcon.tsx": [
    "31174",
    9,
    "45579"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsCategory": [
    "40313",
    9,
    "51042"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/PlatformFeatures": [
    "23507",
    9,
    "83504"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationTwo.svg": [
    "53123",
    1,
    "28832"
  ],
  "./_geograffee/dafes/pages/CountryShowcase.tsx": [
    "62779",
    9,
    "15969",
    "6049",
    "99448",
    "16433"
  ],
  "./_geograffee/dafes/icons/footerIcons/TelegramIcon": [
    "3387",
    9,
    "4689"
  ],
  "./_ftbl/main/assets/icons/WorldIcon": [
    "76684",
    9
  ],
  "./_deziiign/monalisatravels/routesList.tsx": [
    "58745",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "93410"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview.tsx": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/main/pages/projectDeziign/styles.tsx": [
    "16478",
    9,
    "13043"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconEn.tsx": [
    "99755",
    9,
    "57336"
  ],
  "./_deziiign/greenaward/components/IndexTitle": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection.tsx": [
    "80194",
    9,
    "59071"
  ],
  "./_deziiign/s-public-administration/routesList.tsx": [
    "96916",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "51125"
  ],
  "./_ftbl/main/assets/icons/WorldIcon.tsx": [
    "76684",
    9
  ],
  "./_deziiign/ageytomesh/routesList": [
    "92044",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67741"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/styles.ts": [
    "52030",
    9,
    "28051"
  ],
  "./_deziiign/s-cinema/routesList": [
    "18301",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5262"
  ],
  "./_deziiign/s-mediadepartment/app.tsx": [
    "85213",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1006"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage.tsx": [
    "21593",
    9,
    "62850"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/ColorfulBlocks.tsx": [
    "96835",
    9,
    "95992",
    "20565",
    "72768"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/Timelines.tsx": [
    "29534",
    9,
    "36435"
  ],
  "./_competition/pages/AllCompetitionsPage/types/types.ts": [
    "49608",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage.tsx": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/designmediiia/app": [
    "72483",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25760"
  ],
  "./_deziiign/books/core/book-delegate.ts": [
    "88325",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools": [
    "19117",
    9
  ],
  "./_deziiign/lab/routesList.tsx": [
    "59821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "68990"
  ],
  "./_deziiign/online/styles": [
    "10509",
    9,
    "50718"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderFashionIcon.tsx": [
    "42216",
    9,
    "43793"
  ],
  "./_geograffee/dafes/pages/data/awards2025Data": [
    "11673",
    9,
    "94498"
  ],
  "./_competition/pages/CompetitionResultsPage": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/kiiids/components/IndexTitle": [
    "58818",
    9,
    "53023"
  ],
  "./_deziiign/books/core/components/shareButton/index.ts": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles.ts": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/school/routesList": [
    "262",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87723"
  ],
  "./_deziiign/fairmediiia/app.tsx": [
    "6467",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "54624"
  ],
  "./_deziiign/kiiids/routesList": [
    "85885",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81038"
  ],
  "./_deziiign/books/core/components/tooltips/": [
    "40356",
    9
  ],
  "./_deziiign/s-oriental/routesList.tsx": [
    "27850",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "9367"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer.tsx": [
    "29312",
    9,
    "97305"
  ],
  "./_deziiign/greenaward/utils": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/books/core/hook/api/useBookList.ts": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/s-international-relations/routesList.tsx": [
    "48390",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99627"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage.tsx": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/styles.ts": [
    "97041",
    9,
    "24682"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/NominationsIcon.tsx": [
    "54893",
    9,
    "42654"
  ],
  "./_deziiign/hsecreative/styles.tsx": [
    "41431",
    9,
    "7036"
  ],
  "./_geograffee/dafes/images/F1_jewellery_design.jpg": [
    "60858",
    1,
    "12935"
  ],
  "./_deziiign/s-philosophy/routesList": [
    "89821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/tag": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index.ts": [
    "25672",
    9,
    "32049"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/styles.tsx": [
    "94468",
    9,
    "33861"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useProjectChapters": [
    "50502",
    9
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/LPUIcon": [
    "83451",
    9,
    "57352"
  ],
  "./_fr/mumbai/styles.tsx": [
    "26294",
    9,
    "6171"
  ],
  "./_deziiign/automediiia/routesList": [
    "83561",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54130"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableLinkSortBlock.tsx": [
    "46829",
    9,
    "58599"
  ],
  "./_geograffee/academy/app": [
    "47617",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5370"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField": [
    "38958",
    9,
    "43907"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/AboutAwards2025.tsx": [
    "44807",
    9,
    "12725"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 135.jpg": [
    "82461",
    1,
    "73358"
  ],
  "./_deziiign/creativemediiia/app": [
    "38719",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86621"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesInfoComponent": [
    "69615",
    9,
    "17316"
  ],
  "./_ftbl/main/assets/clubEmblems/Forza_Milano.png": [
    "48501",
    1,
    "6230"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner6.svg": [
    "17281",
    1,
    "51610"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib1.jpg": [
    "20821",
    1,
    "91606"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/sliderImages.ts": [
    "58412",
    9,
    "68189"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 116.jpg": [
    "68136",
    1,
    "48689"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueList": [
    "33420",
    9,
    "99037"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/styles.ts": [
    "97894",
    9,
    "36107"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/normalizeTabName.ts": [
    "93513",
    9,
    "94130"
  ],
  "./_competition/components/style": [
    "10301",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition.tsx": [
    "94880",
    9,
    "17433"
  ],
  "./_uz/main/app": [
    "4050",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28431"
  ],
  "./_deziiign/kiiids/app": [
    "43814",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5227"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/CategoryPartner.tsx": [
    "5381",
    9,
    "82118"
  ],
  "./_ftbl/main/assets/icons/PredictionButtonArrow.tsx": [
    "35313",
    9,
    "41130"
  ],
  "./_deziiign/lpudesign/routesList": [
    "56163",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42368"
  ],
  "./_deziiign/hsedesign/styles": [
    "91408",
    9,
    "49545"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/hsespace/components/IndexTitle.tsx": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles": [
    "14954",
    9,
    "94807"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle": [
    "53341",
    9
  ],
  "./_geograffee/dafes/images/student_features.png": [
    "49615",
    1,
    "94052"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/interior.png": [
    "80421",
    1,
    "16294"
  ],
  "./_deziiign/cinemediiia/routesList.tsx": [
    "91311",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81188"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_deziiign/onlines/OnlinesMetaTags": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/books/pages/BookChapterCreate/": [
    "45234",
    9,
    "95855"
  ],
  "./_ftbl/main/types/games": [
    "40701",
    9,
    "84942"
  ],
  "./_deziiign/portfolioartz/routesList.tsx": [
    "28207",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45444"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList": [
    "33014",
    9
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/search.svg": [
    "93686",
    1,
    "51163"
  ],
  "./_deziiign/continuumsite/routesList.tsx": [
    "97765",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6886"
  ],
  "./_competition/pages/CompetitionsAdmin/const.ts": [
    "67035",
    9
  ],
  "./_fr/shanghai/routesList": [
    "7100",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88557"
  ],
  "./_deziiign/iqmedia/routesList": [
    "70364",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "96525"
  ],
  "./_fr/shanghai/styles.tsx": [
    "19132",
    9,
    "17293"
  ],
  "./_ftbl/main/pages/MainPage/MainPage.tsx": [
    "89526",
    9,
    "17316",
    "71641",
    "60764",
    "46075"
  ],
  "./_deziiign/s-oriental/routesList": [
    "27850",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "9367"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconEn": [
    "50085",
    9,
    "134"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionWinnersPage.tsx": [
    "26884",
    9,
    "60901",
    "84869"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage.tsx": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories": [
    "93506",
    9
  ],
  "./_fr/bengaluru/routesList.tsx": [
    "19488",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3449"
  ],
  "./_fr/kolkata/styles.tsx": [
    "6174",
    9,
    "26419"
  ],
  "./_deziiign/s-history/app": [
    "25571",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83552"
  ],
  "./_deziiign/books/pages/BookEdit/styles": [
    "27552",
    9
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_deziiign/s-philosophy/app": [
    "9222",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50155"
  ],
  "./_deziiign/s-psychology/routesList": [
    "81139",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25680"
  ],
  "./_fr/bengaluru/app.tsx": [
    "53377",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46938"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblTitle.tsx": [
    "32877",
    9,
    "49438"
  ],
  "./_deziiign/s-public-administration/app.tsx": [
    "21533",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39662"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/edu-8119c54fba784b5ba27098e025112721.jpg": [
    "18058",
    1,
    "33783"
  ],
  "./_deziiign/books/pages/BookListView/BookListView": [
    "85406",
    9,
    "13908",
    "21565",
    "5357",
    "96979"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/IntegrationBlock": [
    "41295",
    9,
    "95992",
    "48548"
  ],
  "./_deziiign/hsecolors/app": [
    "19735",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43452"
  ],
  "./_deziiign/booksmediiia/app.tsx": [
    "25247",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71668"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableRowLayout": [
    "51619",
    9,
    "92832"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage": [
    "14449",
    9
  ],
  "./_competition/votePrevStorage.ts": [
    "79433",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit.tsx": [
    "58466",
    9,
    "97599"
  ],
  "./_deziiign/lmshse/routesList": [
    "89406",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21267"
  ],
  "./_geograffee/dafes/images/awards2026/headerLogo.svg": [
    "92466",
    1,
    "38150"
  ],
  "./_fr/saopaulo/routesList": [
    "86257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20138"
  ],
  "./_ftbl/main/constants/tableHeader.ts": [
    "44616",
    9,
    "24712"
  ],
  "./_fr/dubai/app.tsx": [
    "12475",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "72168"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/BlackBlock.tsx": [
    "91156",
    9,
    "95992",
    "20565"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/TitleImg.tsx": [
    "63168",
    9,
    "89017"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage": [
    "69662",
    9,
    "87616"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileGlow.svg": [
    "27318",
    1,
    "74203"
  ],
  "./_deziiign/s-hsetto/routesList": [
    "54479",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25668"
  ],
  "./_deziiign/hsestart/routesList": [
    "94962",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85660"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderPrevButtonIcon": [
    "73059",
    9,
    "86304"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/artmediiia/routesList.tsx": [
    "6743",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88156"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/s-pro/app.tsx": [
    "45622",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "18651"
  ],
  "./_ftbl/main/helpers/getFlagUrl": [
    "73847",
    9
  ],
  "./_geograffee/dafes/images/awards2026/rivchun.png": [
    "43092",
    1,
    "35637"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesComponent": [
    "33879",
    9,
    "17316",
    "60764"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults": [
    "77349",
    9,
    "96678",
    "52071"
  ],
  "./_fr/paris/app.tsx": [
    "84249",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53346"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner1.svg": [
    "8350",
    1,
    "34643"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesTable.tsx": [
    "9707",
    9,
    "5894",
    "86041",
    "69592"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles.ts": [
    "18476",
    9
  ],
  "./_deziiign/s-digital/app": [
    "94875",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53032"
  ],
  "./_ftbl/main/hooks/useGetPeriods.ts": [
    "99170",
    9,
    "99007"
  ],
  "./_geograffee/dafes/images/awards2026/mobileHeaderBg.png": [
    "79355",
    1,
    "40"
  ],
  "./_deziiign/books/pages/BookEdit/constants": [
    "16292",
    9
  ],
  "./_deziiign/prohse/app": [
    "9256",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23313"
  ],
  "./_deziiign/hseanimation/styles": [
    "37256",
    9,
    "38641"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter": [
    "60313",
    9,
    "79298"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit": [
    "20260",
    9,
    "60901"
  ],
  "./_deziiign/galllleryart/styles.ts": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch.tsx": [
    "10268",
    9,
    "42029"
  ],
  "./_deziiign/aimediiia/app.tsx": [
    "49867",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31576"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards": [
    "70067",
    9
  ],
  "./_deziiign/school/pages/init.tsx": [
    "74957",
    9,
    "48382"
  ],
  "./_geograffee/dafes/routesList.tsx": [
    "58305",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "43290"
  ],
  "./_kz/dafes-art/app.tsx": [
    "8294",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22731"
  ],
  "./_deziiign/designmediiia/app.tsx": [
    "72483",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25760"
  ],
  "./_deziiign/mediiia/routesList.tsx": [
    "24864",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45497"
  ],
  "./_deziiign/books/pages/sections/ps-image.tsx": [
    "9421",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title.tsx": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/hsecreativehub/routesList.tsx": [
    "71242",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "57303"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/ColorfulBlocks": [
    "96835",
    9,
    "95992",
    "20565",
    "72768"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/getPartners.tsx": [
    "30927",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "60557"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit.tsx": [
    "72536",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497"
  ],
  "./_deziiign/conceptmediiia/routesList": [
    "83700",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "62165"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage": [
    "94292",
    9,
    "24074",
    "47268",
    "83275",
    "78037"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesSettings.tsx": [
    "90368",
    9,
    "5894",
    "86041"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom.tsx": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/ranepa/routesList.tsx": [
    "65621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69910"
  ],
  "./_deziiign/s-media/routesList.tsx": [
    "88674",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "89023"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ChildrensBookIcon": [
    "33834",
    9,
    "79671"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Profiles.tsx": [
    "70198",
    9,
    "95992",
    "86811"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-d5a5c00f112943a48acefac7bd0c53c0.jpg": [
    "34676",
    1,
    "32885"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext": [
    "82310",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "800"
  ],
  "./_deziiign/main/pages/projectDeziign/index.tsx": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/dafes/pages/data/awards2025Data.ts": [
    "11673",
    9,
    "94498"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/styles": [
    "54922",
    9,
    "37143"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/GameItemInfo.tsx": [
    "99100",
    9,
    "88493"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage.tsx": [
    "14449",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationFive.svg": [
    "66863",
    1,
    "13892"
  ],
  "./_ftbl/main/constants/countryIndexes": [
    "33770",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesSmallButton": [
    "88678",
    9,
    "34603"
  ],
  "./_deziiign/cgrave/styles.ts": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/adcrdafesnet/styles.ts": [
    "14100",
    9,
    "25653"
  ],
  "./_geograffee/dafes/images/university_slider_item_2.png": [
    "44835",
    1,
    "36416"
  ],
  "./_competition/pages/CompetitionsAdmin/components/SearchInput": [
    "99951",
    9,
    "22116"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/StatusesAdminPage.tsx": [
    "96596",
    9,
    "5894",
    "86041",
    "95605"
  ],
  "./_deziiign/kiiids/utils/index": [
    "80417",
    9,
    "14824"
  ],
  "./_geograffee/dafes/images/S1_brand_yearEN.jpg": [
    "1639",
    1,
    "40332"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilDafesIcon": [
    "31174",
    9,
    "45579"
  ],
  "./_deziiign/fairartz/app.tsx": [
    "76874",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76215"
  ],
  "./_deziiign/books/pages/BookEdit/types": [
    "62704",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/styles": [
    "71583",
    9,
    "30100"
  ],
  "./_deziiign/hsecolors/routesList.tsx": [
    "54706",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40751"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs": [
    "79982",
    9,
    "12035"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/eligibility.svg": [
    "41699",
    1,
    "65120"
  ],
  "./_deziiign/s-digital/app.tsx": [
    "94875",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53032"
  ],
  "./_deziiign/automediiia/app.tsx": [
    "38106",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99687"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave.tsx": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout": [
    "99082",
    9
  ],
  "./_competition/pages/CompetitionsAdmin/components/style": [
    "8608",
    9,
    "83321"
  ],
  "./_deziiign/aki/routesList.tsx": [
    "13233",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23018"
  ],
  "./_fr/mumbai/routesList.tsx": [
    "58622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87443"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate.tsx": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreativehub/app": [
    "44527",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95620"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools": [
    "56695",
    9,
    "76412"
  ],
  "./_deziiign/lmshse/styles": [
    "98454",
    9,
    "4731"
  ],
  "./_deziiign/s-management/routesList": [
    "86269",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35054"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/CommunicationAwards2025": [
    "16555",
    9,
    "40312"
  ],
  "./_deziiign/storiesmediiia/routesList": [
    "88515",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20800"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard": [
    "76742",
    9
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconEn": [
    "68643",
    9,
    "37289"
  ],
  "./_ftbl/main/assets/clubEmblems/Burgundy_Brussel.png": [
    "89013",
    1,
    "59926"
  ],
  "./_deziiign/books/core/components/shareButton/index": [
    "83831",
    9,
    "5436"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils": [
    "22125",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/question.svg": [
    "39708",
    1,
    "19053"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/plus.svg": [
    "13427",
    1,
    "58928"
  ],
  "./_kz/dafes/routesList": [
    "56814",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26330"
  ],
  "./_deziiign/booksgallllery/ExtraPage": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/hand.png": [
    "45275",
    1,
    "66472"
  ],
  "./_deziiign/superpuper/styles": [
    "45757",
    9,
    "16398"
  ],
  "./_deziiign/hseanimation/styles.tsx": [
    "37256",
    9,
    "38641"
  ],
  "./_geograffee/academy/app.tsx": [
    "47617",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5370"
  ],
  "./_deziiign/greenaward/utils/index": [
    "96912",
    9,
    "94249"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/JuryAwards2025.tsx": [
    "10505",
    9,
    "94498",
    "51058"
  ],
  "./_deziiign/transfermediiia/routesList": [
    "24253",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88494"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon.tsx": [
    "37305",
    9,
    "610"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/s-cinema/app": [
    "64646",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "363"
  ],
  "./_deziiign/s-geography/app": [
    "84909",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "12670"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/styles": [
    "40148",
    9,
    "57109"
  ],
  "./_deziiign/s-arthistory/app.tsx": [
    "56821",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28927"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/UniversitiesFeatures": [
    "54394",
    9,
    "95992",
    "17486",
    "42023"
  ],
  "./_deziiign/school/utils/index.ts": [
    "89716",
    9,
    "99509"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage": [
    "6664",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar": [
    "89260",
    9,
    "13908",
    "21565"
  ],
  "./_fr/kolkata/app.tsx": [
    "46019",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8576"
  ],
  "./_competition/components/TellingStoriesSuccess": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage.tsx": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/portfolioartz/app.tsx": [
    "51524",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "67653"
  ],
  "./_fr/delhi/routesList.tsx": [
    "60381",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "96046"
  ],
  "./_deziiign/cinemediiia/routesList": [
    "91311",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81188"
  ],
  "./_deziiign/jhonatanet/routesList": [
    "98162",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54319"
  ],
  "./_competition/helpers/preRegistrationAccess.ts": [
    "97999",
    9
  ],
  "./_deziiign/hsespace/app": [
    "46345",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22386"
  ],
  "./_fr/delhi/styles": [
    "13073",
    9,
    "63562"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit": [
    "58466",
    9,
    "97599"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ai.svg": [
    "94285",
    1,
    "76254"
  ],
  "./_ftbl/main/assets/flags/spaFlag.png": [
    "14616",
    1,
    "54721"
  ],
  "./_geograffee/dafes/images/hse_backgroung_img.png": [
    "33626",
    1,
    "93415"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles": [
    "73222",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TeamTable.tsx": [
    "33480",
    9,
    "28561"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/styles": [
    "90902",
    9,
    "49179"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/DafesMainSlider.tsx": [
    "99821",
    9,
    "53317",
    "61214"
  ],
  "./_deziiign/hsecolors/routesList": [
    "54706",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40751"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/PartnersResidents.tsx": [
    "12910",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "56867"
  ],
  "./_fr/kolkata/routesList.tsx": [
    "29878",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "13947"
  ],
  "./_deziiign/sportmediiia/app.tsx": [
    "37223",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "4076"
  ],
  "./_geograffee/main/app.tsx": [
    "95508",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23509"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles": [
    "18476",
    9
  ],
  "./_competition/helpers/getCompetitionDate.ts": [
    "76662",
    9
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner7.svg": [
    "5040",
    1,
    "19337"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage": [
    "65548",
    9
  ],
  "./_geograffee/dafes/icons/TechnologicalBlockIcon": [
    "48592",
    9,
    "68329"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions.ts": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/hsedesign/pages/TagExpertsPage/TagExpertsPage": [
    "12022",
    9,
    "26139"
  ],
  "./_deziiign/lmsmediiia/app.tsx": [
    "39117",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59454"
  ],
  "./_deziiign/s-political-science/app.tsx": [
    "51367",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50188"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArtIcon.tsx": [
    "96271",
    9,
    "44868"
  ],
  "./_geograffee/dafes/images/interior_design_logo.png": [
    "34191",
    1,
    "95332"
  ],
  "./_geograffee/dafes/icons/IntegrationBlockIcon": [
    "37848",
    9,
    "9473"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/styles": [
    "93983",
    9,
    "41460"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/styles": [
    "80724",
    9,
    "57141"
  ],
  "./_deziiign/books/pages/sections/ps-buttons": [
    "56100",
    9,
    "86309"
  ],
  "./_deziiign/prohse/app.tsx": [
    "9256",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23313"
  ],
  "./_geograffee/dafes/images/D1_motion_designEN.jpg": [
    "51736",
    1,
    "77409"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/styles": [
    "88198",
    9,
    "58187"
  ],
  "./_competition/pages/CreateCompetitionPage": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_deziiign/fashionmediiia/app": [
    "96925",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "82734"
  ],
  "./_deziiign/dvadesign/styles": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField.tsx": [
    "70009",
    9,
    "30818"
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult.tsx": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/SeachBar.tsx": [
    "80150",
    9,
    "5894"
  ],
  "./_deziiign/books/core/components/template/book-display-layout.tsx": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/books/pages/BookListView": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/core/components/bookCard/index": [
    "21273",
    9
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/WhiteMainBlock.tsx": [
    "63325",
    9,
    "95992",
    "67566"
  ],
  "./_competition/pages/PreRegistrationResult/": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/dvadesign/app": [
    "31062",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/utils/": [
    "12216",
    9,
    "1953"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner8.svg": [
    "97959",
    1,
    "35596"
  ],
  "./_deziiign/s-production/routesList.tsx": [
    "88157",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11438"
  ],
  "./_fr/mumbai/app.tsx": [
    "13099",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "78840"
  ],
  "./_deziiign/portfolioartz/app": [
    "51524",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "67653"
  ],
  "./_deziiign/iqmedia/app.tsx": [
    "5142",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57563"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/UsersTable": [
    "6105",
    9,
    "5894",
    "52450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star3.svg": [
    "37310",
    1,
    "29587"
  ],
  "./_deziiign/books/routesList": [
    "26760",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/onlines/app": [
    "51476",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "13836"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblCard.tsx": [
    "61365",
    9,
    "34486"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesPageTabPanel": [
    "25859",
    9,
    "46464"
  ],
  "./_deziiign/hsehh/routesList": [
    "11862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40283"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/projectDeziign/styles": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/hsespacecreative/app": [
    "54370",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "26687"
  ],
  "./_deziiign/musicmediiia/app": [
    "62630",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58923"
  ],
  "./_fr/delhi/app.tsx": [
    "38246",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "42443"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/getPartners": [
    "30927",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "60557"
  ],
  "./_competition/pages/CreateCompetitionPage/changebg.svg": [
    "62674",
    1,
    "19919"
  ],
  "./_deziiign/books/constants": [
    "17857",
    9
  ],
  "./_deziiign/s-production/routesList": [
    "88157",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11438"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/id.svg": [
    "5792",
    1,
    "24249"
  ],
  "./_deziiign/online/app": [
    "51165",
    9,
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "41317",
    "97775",
    "38815",
    "53966"
  ],
  "./_fr/kolkata/app": [
    "46019",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8576"
  ],
  "./_ftbl/main/assets/flags/fraFlag.png": [
    "95259",
    1,
    "27464"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/s-hseincomm/app": [
    "30562",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59711"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader.tsx": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/books/core/common": [
    "62913",
    9,
    "82989"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsProfile": [
    "56290",
    9,
    "89567"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/FormsComponent": [
    "98547",
    9,
    "95312"
  ],
  "./_deziiign/booksmediiia/app": [
    "25247",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71668"
  ],
  "./_deziiign/conceptmediiia/app": [
    "19869",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86702"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_deziiign/creativemediiia/routesList": [
    "92375",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "77724"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star4.svg": [
    "54689",
    1,
    "71533"
  ],
  "./_deziiign/continuumsite/styles": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/hseanimation/routesList.tsx": [
    "27072",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "55417"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury": [
    "71795",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/styles.ts": [
    "92847",
    9,
    "77924"
  ],
  "./_deziiign/s-philology/app": [
    "24826",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10887"
  ],
  "./_deziiign/admediiia/routesList": [
    "21959",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "34636"
  ],
  "./_deziiign/s-mediadepartment/routesList": [
    "10868",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56021"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/BlackBlock": [
    "91156",
    9,
    "95992",
    "20565"
  ],
  "./_deziiign/s-digital/routesList.tsx": [
    "22606",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3939"
  ],
  "./_fr/kolkata/routesList": [
    "29878",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "13947"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter": [
    "94043",
    9,
    "87464"
  ],
  "./_competition/components/CompetitionFormSuccess": [
    "2402",
    9,
    "63231"
  ],
  "./_deziiign/school/styles.tsx": [
    "6510",
    9,
    "40355"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_geograffee/dafes/icons/sliderIcons/AIcon": [
    "34036",
    9,
    "6037"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/styles.ts": [
    "95213",
    9,
    "99326"
  ],
  "./_geograffee/dafes/images/awards2026/Icon_container.png": [
    "64004",
    1,
    "19717"
  ],
  "./_kz/pro/routesList": [
    "2265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "92034"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage": [
    "79407",
    9,
    "56900"
  ],
  "./_ftbl/main/pages/AboutFtbl/styles.ts": [
    "45643",
    9,
    "62488"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserInfo": [
    "59935",
    9,
    "90109"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserCards": [
    "18007",
    9,
    "47036"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItem.tsx": [
    "40634",
    9,
    "23943"
  ],
  "./_deziiign/awards/routesList": [
    "80164",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "84709"
  ],
  "./_competition/routesList": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module3.svg": [
    "79202",
    1,
    "35967"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/DafesMainSlider": [
    "99821",
    9,
    "53317",
    "61214"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 131.jpg": [
    "40577",
    1,
    "51866"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/what_is_branding_sm.jpg": [
    "81172",
    1,
    "55637"
  ],
  "./_deziiign/books/core/components/booksSearchBar/": [
    "68671",
    9,
    "3924"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/AdditionalFeatures.tsx": [
    "76509",
    9,
    "17486",
    "82499"
  ],
  "./_fr/main/styles.tsx": [
    "40912",
    9,
    "43369"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-94a50e63889f48fc81c7791f36d30dcd.jpg": [
    "37004",
    1,
    "4093"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField.tsx": [
    "40683",
    9,
    "38776"
  ],
  "./_ftbl/main/assets/leagues/england.png": [
    "13164",
    1,
    "43741"
  ],
  "./_competition/pages/ShortListPage/index.ts": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOneReadymag.svg": [
    "46855",
    1,
    "29356"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/CommunicationAwards2025.tsx": [
    "16555",
    9,
    "40312"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard": [
    "47486",
    9
  ],
  "./_deziiign/lab/app": [
    "14678",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44571"
  ],
  "./_kz/dafes/pages/CountryShowcase.tsx": [
    "73947",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "59816"
  ],
  "./_deziiign/s-cognitive/app.tsx": [
    "94287",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "52100"
  ],
  "./_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions": [
    "63349",
    9
  ],
  "./_deziiign/exams/app.tsx": [
    "78503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57516"
  ],
  "./_fr/dubai/routesList": [
    "94158",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99299"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/styles": [
    "42776",
    9,
    "31854"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderStartupsIcon": [
    "80866",
    9,
    "9439"
  ],
  "./_competition/pages/CompetitionsAdmin/components/TableContent.tsx": [
    "53556",
    9,
    "69301"
  ],
  "./_deziiign/books/core/components/booksSearchBar": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/kiiids/styles.tsx": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/books/core/components/helper/bookEvents.ts": [
    "75209",
    9,
    "73051"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/isCardBlockedForPaidBook": [
    "44387",
    9
  ],
  "./_deziiign/hsedesign/styles.tsx": [
    "91408",
    9,
    "49545"
  ],
  "./_fr/shanghai/styles": [
    "19132",
    9,
    "17293"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutPageBlock.tsx": [
    "76486",
    9,
    "27691"
  ],
  "./_deziiign/monalisatravels/app": [
    "90436",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "77655"
  ],
  "./_deziiign/onlinesdesign/routesList.tsx": [
    "51735",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3813"
  ],
  "./_deziiign/fashion/routesList": [
    "97862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31947"
  ],
  "./_deziiign/aimediiia/routesList": [
    "83870",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42291"
  ],
  "./_deziiign/awards/pages/EmployeesContext": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage.tsx": [
    "22570",
    9,
    "6244"
  ],
  "./_fr/delhi/styles.tsx": [
    "13073",
    9,
    "63562"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PauseIcon.tsx": [
    "7356",
    9,
    "20173"
  ],
  "./_deziiign/hsedesign/routesList": [
    "28344",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54529"
  ],
  "./_deziiign/s-production/app.tsx": [
    "42265",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46699"
  ],
  "./_competition/helpers/getCompetitionStatus.ts": [
    "30100",
    9
  ],
  "./_geograffee/dafes/icons/ButtonArrowIcon": [
    "19980",
    9,
    "61373"
  ],
  "./_competition/app.tsx": [
    "29104",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98441"
  ],
  "./_deziiign/hsespacecreative/app.tsx": [
    "54370",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "26687"
  ],
  "./_deziiign/s-chemistry/routesList": [
    "77800",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "10897"
  ],
  "./_deziiign/s-philosophy/app.tsx": [
    "9222",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50155"
  ],
  "./_competition/pages/AllCompetitionsPage/components/CompetitionCover.tsx": [
    "96300",
    9
  ],
  "./_deziiign/s-media/app.tsx": [
    "46343",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14220"
  ],
  "./_deziiign/books/core/components/template/book-container-layout": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/eventmediiia/routesList": [
    "4152",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "79073"
  ],
  "./_fr/paris/styles": [
    "32720",
    9,
    "71913"
  ],
  "./_geograffee/dafes/images/F1_fashion_design.jpg": [
    "52532",
    1,
    "50316"
  ],
  "./_geograffee/dafes/icons/AddDafesIcon": [
    "35503",
    9,
    "12324"
  ],
  "./_deziiign/onlinesdesign/app.tsx": [
    "61389",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59870"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 126.jpg": [
    "49997",
    1,
    "57438"
  ],
  "./_kz/dafes-education/routesList": [
    "74274",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67007"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage.tsx": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/foodmediiia/routesList": [
    "62124",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53245"
  ],
  "./_geograffee/dafes/app": [
    "76242",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "37071"
  ],
  "./_competition/pages/CreateCompetitionPage/index": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_competition/pages/ProjectsPage/index.ts": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs": [
    "1325",
    9
  ],
  "./_deziiign/conceptmediiia/app.tsx": [
    "19869",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86702"
  ],
  "./_ftbl/main/routesList": [
    "2572",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "637"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/UniversitiesFeatures.tsx": [
    "54394",
    9,
    "95992",
    "17486",
    "42023"
  ],
  "./_deziiign/superpuper/app": [
    "31858",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31887"
  ],
  "./_deziiign/hsespacecreative/routesList": [
    "9137",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "27402"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ZharKnigaIcon.tsx": [
    "85172",
    9,
    "12789"
  ],
  "./_deziiign/booksgallllery/ExtraPage/": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/ranepa/styles": [
    "5465",
    9,
    "62338"
  ],
  "./_deziiign/s-media/app": [
    "46343",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14220"
  ],
  "./_competition/pages/CompetitionsAdmin/components/BottomActionMenu.tsx": [
    "29489",
    9,
    "93706"
  ],
  "./_ftbl/main/pages/AllMatches/styles.ts": [
    "52208",
    9,
    "60425"
  ],
  "./_deziiign/iqmedia/routesList.tsx": [
    "70364",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "96525"
  ],
  "./_geograffee/dafes/images/universitiesTitleImg.png": [
    "81405",
    1,
    "46894"
  ],
  "./_kz/dafes-education/app": [
    "35335",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "30188"
  ],
  "./_deziiign/cgrave/styles": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/s-computer-science-and-engineering/app": [
    "24643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10720"
  ],
  "./_geograffee/main/routesList.tsx": [
    "29087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "18900"
  ],
  "./_ftbl/main/helpers/getInitials.ts": [
    "49335",
    9,
    "45244"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/BigIcon.tsx": [
    "60082",
    9,
    "27567"
  ],
  "./_deziiign/sportmediiia/routesList.tsx": [
    "81858",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "19743"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconRu.tsx": [
    "41738",
    9,
    "79607"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsProfile.tsx": [
    "56290",
    9,
    "89567"
  ],
  "./_kz/dafes-education/app.tsx": [
    "35335",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "30188"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/s-sociology/app.tsx": [
    "67953",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44234"
  ],
  "./_competition/helpers/useShowRatingCompetitionTag": [
    "32511",
    9
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/IrkiIcon.tsx": [
    "64708",
    9,
    "80444"
  ],
  "./_deziiign/dvadesign/styles.ts": [
    "2739",
    9,
    "87120"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconRu": [
    "75477",
    9,
    "35254"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-c81e874146014a78b8eb5c66a8698486.jpg": [
    "16500",
    1,
    "97612"
  ],
  "./_geograffee/dafes/images/technologicalImg.png": [
    "95689",
    1,
    "89682"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-6e63304c030c4c98bbe05fdb5892dd6c.jpg": [
    "86621",
    1,
    "49518"
  ],
  "./_deziiign/cinemediiia/app.tsx": [
    "27588",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50533"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOverviewReadymag.svg": [
    "54856",
    1,
    "61457"
  ],
  "./_deziiign/storiesmediiia/app.tsx": [
    "21600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71865"
  ],
  "./_deziiign/s-hseincomm/routesList": [
    "61265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85322"
  ],
  "./_deziiign/mediiia/app": [
    "94083",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "79904"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles.ts": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_ftbl/main/pages/AboutFtbl/styles": [
    "45643",
    9,
    "62488"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesBigButton.tsx": [
    "38385",
    9,
    "85066"
  ],
  "./_ftbl/main/pages/AllMatches/styles": [
    "52208",
    9,
    "60425"
  ],
  "./_deziiign/s-architect/routesList": [
    "52833",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "74394"
  ],
  "./_deziiign/s-public-administration/app": [
    "21533",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39662"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/resources": [
    "72627",
    9,
    "52272"
  ],
  "./_fr/dubai/styles.tsx": [
    "89222",
    9,
    "43179"
  ],
  "./_deziiign/s-production/app": [
    "42265",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46699"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderEducationIcon": [
    "92946",
    9,
    "98639"
  ],
  "./_deziiign/s-management/routesList.tsx": [
    "86269",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35054"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Greetings.tsx": [
    "73638",
    9,
    "95992",
    "97387"
  ],
  "./_deziiign/exams/routesList": [
    "35170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56031"
  ],
  "./_deziiign/s-architect/app": [
    "30162",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9775"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/styles.ts": [
    "53051",
    9,
    "23867"
  ],
  "./_competition/pages/LongListPage/LongListPage.tsx": [
    "22197",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserCards.tsx": [
    "18007",
    9,
    "47036"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage": [
    "51697",
    9,
    "73706"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index.ts": [
    "71795",
    9
  ],
  "./_deziiign/books/pages/sections/ps-commerce": [
    "21934",
    9,
    "51811"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-f37675243e344cecb404e17b9df2d7d3.jpg": [
    "84734",
    1,
    "36403"
  ],
  "./_geograffee/dafes/images/awards2026/meshcheryakov.png": [
    "88628",
    1,
    "35701"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/style.ts": [
    "39764",
    9,
    "54709"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext": [
    "33981",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "34535"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign": [
    "61848",
    9,
    "45825"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-3cda2e20741e4b1db94ee060d6a57d36.jpg": [
    "5024",
    1,
    "38425"
  ],
  "./_kz/dafes/app.tsx": [
    "5778",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21551"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/styles": [
    "7522",
    9,
    "1343"
  ],
  "./_deziiign/booksgallllery/routesList": [
    "14518",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98363"
  ],
  "./_fr/bengaluru/styles.tsx": [
    "80904",
    9,
    "18705"
  ],
  "./_deziiign/storiesmediiia/app": [
    "21600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71865"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index.ts": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblGrid": [
    "43395",
    9,
    "34486",
    "54400"
  ],
  "./_geograffee/dafes/images/awards2026/lu.png": [
    "7478",
    1,
    "79963"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/styles": [
    "94468",
    9,
    "33861"
  ],
  "./_deziiign/hsedesign/utils": [
    "46106",
    9,
    "87527"
  ],
  "./_geograffee/dafes/images/awards2026/close_menu.svg": [
    "60713",
    1,
    "60050"
  ],
  "./_deziiign/books/pages/BookEdit/index": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/brnd/app": [
    "8109",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23902"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-8c3dd122a36c48efa98a8601b0a19c6e.jpg": [
    "14056",
    1,
    "96913"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/pin1.svg": [
    "60232",
    1,
    "46225"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch": [
    "10268",
    9,
    "42029"
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage": [
    "77159",
    9,
    "6636"
  ],
  "./_ftbl/main/assets/flags/itaFlag.png": [
    "15218",
    1,
    "23663"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableHeaderBlock": [
    "80327",
    9,
    "56748"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles": [
    "63545",
    9,
    "82850"
  ],
  "./_deziiign/books/pages/BookEdit/types.ts": [
    "62704",
    9
  ],
  "./_deziiign/s-biology/routesList": [
    "28257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "73402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit.tsx": [
    "38310",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/pages/ShortListPage/ShortListPage": [
    "37613",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus.tsx": [
    "89004",
    9,
    "52701"
  ],
  "./_deziiign/game/routesList.tsx": [
    "71368",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "75345"
  ],
  "./_geograffee/dafes/images/D1_identity_and_branding.jpg": [
    "25699",
    1,
    "43753"
  ],
  "./_deziiign/s-political-science/app": [
    "51367",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50188"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconRu": [
    "41738",
    9,
    "79607"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 129.jpg": [
    "34990",
    1,
    "70275"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/sections.ts": [
    "97405",
    9,
    "95992",
    "37774"
  ],
  "./_competition/components/CompetitionDropdown": [
    "22878",
    9,
    "42419"
  ],
  "./_fr/marseille/app.tsx": [
    "34718",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14707"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 125.jpg": [
    "20738",
    1,
    "20575"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField.tsx": [
    "14771",
    9,
    "79056"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolAmIcon.tsx": [
    "88622",
    9,
    "8227"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/WhiteTopBlock": [
    "16141",
    9,
    "95992",
    "72446"
  ],
  "./_competition/pages/ShortListPage": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/Search.tsx": [
    "72663",
    9,
    "5894"
  ],
  "./_geograffee/dafes/images/D5_object_design.jpg": [
    "66220",
    1,
    "66333"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/SeachBar": [
    "80150",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/styles": [
    "31255",
    9,
    "52828"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-8bb7da9aca9244d78f72d4d808554f73.jpg": [
    "26868",
    1,
    "85173"
  ],
  "./_kz/dafes/pages/CountryShowcase": [
    "73947",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "59816"
  ],
  "./_deziiign/books/core/components/grid/index": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/booksgallllery/app": [
    "76643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "66688"
  ],
  "./_ftbl/main/assets/icons/TableSortLabelIcon.tsx": [
    "46",
    9,
    "5155"
  ],
  "./_kz/dafes-art/routesList": [
    "72989",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "50670"
  ],
  "./_deziiign/s-mediadepartment/app": [
    "85213",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1006"
  ],
  "./_deziiign/fairartz/routesList": [
    "15737",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8546"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchblack.svg": [
    "15964",
    1,
    "87428"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesButton.tsx": [
    "4203",
    9,
    "95992"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/hooks/useGetStatusesActions": [
    "52485",
    9,
    "5894"
  ],
  "./_geograffee/dafes/images/E1_visual_research.jpg": [
    "34433",
    1,
    "19418"
  ],
  "./_deziiign/books/pages/BookChapterCreate": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/galllleryart/routesList": [
    "43137",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93914"
  ],
  "./_deziiign/designmediiia/routesList.tsx": [
    "17398",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3323"
  ],
  "./_deziiign/aki/routesList": [
    "13233",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23018"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView.tsx": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/superpuper/app.tsx": [
    "31858",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31887"
  ],
  "./_deziiign/s-music/app": [
    "62310",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98411"
  ],
  "./_fr/saopaulo/app.tsx": [
    "10146",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99807"
  ],
  "./_geograffee/dafes/images/A1_best_research_publicationEN.jpg": [
    "24113",
    1,
    "26858"
  ],
  "./_deziiign/s-cognitive/routesList": [
    "92970",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6167"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-3fd8cec4336a4139ac92529fdbef0d8f.jpg": [
    "47231",
    1,
    "6804"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage.tsx": [
    "97566",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-7159820a94224b8cb5492a4bc97815ea.jpg": [
    "47060",
    1,
    "16981"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles": [
    "20509",
    9
  ],
  "./_deziiign/books/core/components/bookCard": [
    "21273",
    9
  ],
  "./_deziiign/superpuper/routesList.tsx": [
    "76673",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23130"
  ],
  "./_kz/dafes-art/routesList.tsx": [
    "72989",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "50670"
  ],
  "./_deziiign/s-sociology/app": [
    "67953",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44234"
  ],
  "./_fr/paris/app": [
    "84249",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "53346"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/styles.ts": [
    "36047",
    9,
    "25412"
  ],
  "./_deziiign/s-chemistry/app": [
    "5001",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86130"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/styles.ts": [
    "71002",
    9,
    "39495"
  ],
  "./_deziiign/jhonatanet/styles.ts": [
    "57886",
    9,
    "19987"
  ],
  "./_geograffee/dafes/images/D4_childrens_e-book.jpg": [
    "74606",
    1,
    "71834"
  ],
  "./_deziiign/lpudesign/app.tsx": [
    "34912",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "36921"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/camera.svg": [
    "12413",
    1,
    "93262"
  ],
  "./_deziiign/greenaward/utils/index.ts": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsespace/utils": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms.tsx": [
    "59628",
    9
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook.ts": [
    "82452",
    9
  ],
  "./_kz/dafes-fashion/routesList": [
    "93336",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25857"
  ],
  "./_deziiign/s-urban-development/app": [
    "69291",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "61528"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard.tsx": [
    "21919",
    9
  ],
  "./_deziiign/main/pages/moderHseView/index": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/s-geography/routesList": [
    "10596",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable": [
    "72383",
    9,
    "22056",
    "80140",
    "38708"
  ],
  "./_deziiign/main/pages/moderView/moderView.tsx": [
    "29397",
    9,
    "51382"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/GameItemInfo": [
    "99100",
    9,
    "88493"
  ],
  "./_deziiign/onlines/utils": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/alshibaya/app.tsx": [
    "75337",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "81938"
  ],
  "./_competition/pages/ShortListPage/styles.ts": [
    "42270",
    9
  ],
  "./_kz/dafes-fashion/routesList.tsx": [
    "93336",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25857"
  ],
  "./_deziiign/books/core/components/bookCard/assets/book-more-circle.svg": [
    "84667",
    1,
    "66760"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/GreenIcon.tsx": [
    "91303",
    9,
    "26636"
  ],
  "./_competition/pages/AllCompetitionsPage/styled.ts": [
    "70740",
    9
  ],
  "./_competition/pages/EmptyPage": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useChapterPosts": [
    "67007",
    9
  ],
  "./_competition/helpers/getCompetitionDate": [
    "76662",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud": [
    "40443",
    9,
    "41480"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/styles.ts": [
    "36749",
    9,
    "89854"
  ],
  "./_deziiign/mediiia/app.tsx": [
    "94083",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "79904"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblSortBar.tsx": [
    "34752",
    9,
    "153"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Greetings": [
    "73638",
    9,
    "95992",
    "97387"
  ],
  "./_competition/pages/CreateCompetitionPage/stylesEdit": [
    "42355",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/s-digital/routesList": [
    "22606",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3939"
  ],
  "./_ftbl/main/assets/icons/CheckedIcon": [
    "79495",
    9,
    "10316"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/IntegrationBlock.tsx": [
    "41295",
    9,
    "95992",
    "48548"
  ],
  "./_deziiign/onlines/pages/readymag/images/OnlinesSchedule.pdf": [
    "11664",
    1,
    "45321"
  ],
  "./_deziiign/s-hsetto/app": [
    "97284",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94949"
  ],
  "./_deziiign/s-philology/app.tsx": [
    "24826",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10887"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/styles.ts": [
    "40148",
    9,
    "57109"
  ],
  "./_deziiign/s-physics/app": [
    "76764",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89997"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView": [
    "255",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage.tsx": [
    "6664",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761"
  ],
  "./_competition/pages/ShortListPage/index": [
    "13978",
    9,
    "86439"
  ],
  "./_geograffee/dafes/pages/styles.ts": [
    "27162",
    9,
    "5319"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles": [
    "63011",
    9,
    "58528"
  ],
  "./_competition/components/SendProjectButton": [
    "26709",
    9
  ],
  "./_geograffee/dafes/images/awards2026/kankulov.png": [
    "85742",
    1,
    "7523"
  ],
  "./_ftbl/main/helpers/getFlagUrl.ts": [
    "73847",
    9
  ],
  "./_competition/components/CompetitionTagLine": [
    "23659",
    9
  ],
  "./_deziiign/lab/routesList": [
    "59821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "68990"
  ],
  "./_deziiign/books/pages/sections/ps-commerce.tsx": [
    "21934",
    9,
    "51811"
  ],
  "./_competition/pages/AllCompetitionsPage/components/CompetitionCover": [
    "96300",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCheckbox": [
    "64258",
    9,
    "11679"
  ],
  "./_deziiign/books/pages/sections/assets/alert.svg": [
    "87408",
    1,
    "24681"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/CategoriesIcon": [
    "98064",
    9,
    "8489"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsBigIcon.tsx": [
    "74146",
    9,
    "27551"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/PartnersResidents": [
    "12910",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "56867"
  ],
  "./_competition/pages/CompetitionTable/index.ts": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index.ts": [
    "50376",
    9,
    "86001"
  ],
  "./_competition/votePrevStorage": [
    "79433",
    9
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter.tsx": [
    "94043",
    9,
    "87464"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblGrid.tsx": [
    "43395",
    9,
    "34486",
    "54400"
  ],
  "./_deziiign/fashionmediiia/routesList.tsx": [
    "77396",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7477"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage.tsx": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/s-mathematics/routesList.tsx": [
    "82264",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "15905"
  ],
  "./_deziiign/continuumsite/routesList": [
    "97765",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6886"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index": [
    "25672",
    9,
    "32049"
  ],
  "./_uz/main/routesList": [
    "75937",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2554"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/styles": [
    "23708",
    9,
    "44301"
  ],
  "./_deziiign/s-international-relations/app.tsx": [
    "57715",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "11408"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlackBlock/styles": [
    "97894",
    9,
    "36107"
  ],
  "./_geograffee/dafes/images/awards2026/burger_menu.svg": [
    "36238",
    1,
    "75459"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader": [
    "33655",
    9,
    "35004"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/styles.ts": [
    "23708",
    9,
    "44301"
  ],
  "./_deziiign/books/core/components/template/book-display-layout": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext.tsx": [
    "33981",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "34535"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ae.svg": [
    "75721",
    1,
    "33106"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 123.jpg": [
    "12596",
    1,
    "37301"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard": [
    "35468",
    9
  ],
  "./_deziiign/ranepa/app": [
    "96030",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83059"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/helpers/preRegistrationAccess": [
    "97999",
    9
  ],
  "./_deziiign/books/pages/BookListView/index.ts": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/sections": [
    "97405",
    9,
    "95992",
    "37774"
  ],
  "./_deziiign/foodmediiia/app.tsx": [
    "86805",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59126"
  ],
  "./_ftbl/main/pages/MainPage/components/GameTabs.tsx": [
    "66007",
    9,
    "65148"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module4.svg": [
    "7725",
    1,
    "96798"
  ],
  "./_deziiign/books/core/book-delegate": [
    "88325",
    9
  ],
  "./_deziiign/eventmediiia/app": [
    "98329",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5890"
  ],
  "./_geograffee/dafes/images/photographer_logo.png": [
    "61349",
    1,
    "95078"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/styles.ts": [
    "90902",
    9,
    "49179"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/UsersTable.tsx": [
    "6105",
    9,
    "5894",
    "52450"
  ],
  "./_deziiign/onlines/utils/index.ts": [
    "12216",
    9,
    "1953"
  ],
  "./_fr/delhi/app": [
    "38246",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "42443"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager.tsx": [
    "85524",
    9
  ],
  "./_ftbl/main/assets/clubEmblems/Tre_Kronor_Gothenburg.png": [
    "35857",
    1,
    "36746"
  ],
  "./_ftbl/main/assets/clubEmblems/Babylon_Berlin_International.png": [
    "37769",
    1,
    "33714"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index.tsx": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_geograffee/dafes/pages/data/nominationsData.tsx": [
    "67760",
    9,
    "77097"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/greenaward/styles": [
    "52890",
    9,
    "32455"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_ftbl/main/assets/leagues/germany.png": [
    "77084",
    1,
    "35341"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/styles.ts": [
    "57803",
    9,
    "51672"
  ],
  "./_deziiign/creativemediiia/routesList.tsx": [
    "92375",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "77724"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage.tsx": [
    "908",
    9,
    "10717"
  ],
  "./_deziiign/books/core/components/tooltips": [
    "40356",
    9
  ],
  "./_deziiign/online/styles.tsx": [
    "10509",
    9,
    "50718"
  ],
  "./_competition/pages/PreRegistrationResult/style.ts": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/hsespace/app.tsx": [
    "46345",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22386"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconRu.tsx": [
    "24290",
    9,
    "29599"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle.tsx": [
    "53341",
    9
  ],
  "./_deziiign/fairmediiia/routesList.tsx": [
    "78294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97243"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles.tsx": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/s-pro/routesList": [
    "41741",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35134"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage.tsx": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_competition/pages/CompetitionTable/": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_deziiign/fashion/routesList.tsx": [
    "97862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31947"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderDesignIcon": [
    "56298",
    9,
    "30039"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/ADCRBlock.tsx": [
    "27635",
    9,
    "33104"
  ],
  "./_deziiign/s-software-engineering/routesList": [
    "45829",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5318"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPageNew.tsx": [
    "51019",
    9,
    "50333",
    "36435",
    "99640"
  ],
  "./_deziiign/s-history/routesList": [
    "74294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58971"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module1.svg": [
    "21920",
    1,
    "80697"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableRowLayout.tsx": [
    "51619",
    9,
    "92832"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton.tsx": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index": [
    "71795",
    9
  ],
  "./_deziiign/hsestart/app": [
    "36503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "85244"
  ],
  "./_deziiign/greenaward/routesList": [
    "29293",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23591"
  ],
  "./_deziiign/lmshse/app": [
    "59755",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "7512"
  ],
  "./_geograffee/main/app": [
    "95508",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23509"
  ],
  "./_competition/pages/web.svg": [
    "79274",
    1,
    "14519"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsCrownIcon": [
    "64309",
    9,
    "19158"
  ],
  "./_deziiign/s-fashion/app.tsx": [
    "40127",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93492"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/getFilteredCompetitionsById.ts": [
    "61669",
    9,
    "35494"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit": [
    "38310",
    9
  ],
  "./_deziiign/awards/app.tsx": [
    "10445",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89054"
  ],
  "./_deziiign/s-mediadepartment/routesList.tsx": [
    "10868",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56021"
  ],
  "./_deziiign/awards/pages/EmployeesContext/": [
    "31656",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "45438"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArrowIcon.tsx": [
    "1731",
    9,
    "52928"
  ],
  "./_competition/pages/JuryPage/styles.ts": [
    "80070",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread": [
    "55855",
    9,
    "20004"
  ],
  "./_geograffee/dafes/images/D1_motion_design.jpg": [
    "46209",
    1,
    "64986"
  ],
  "./_deziiign/kiiids/utils/index.ts": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/ageytomesh/app.tsx": [
    "61045",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "24822"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage.tsx": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_geograffee/dafes/images/D5_object_designEN.jpg": [
    "52321",
    1,
    "78874"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutFtbl": [
    "23928",
    9,
    "21921"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView.tsx": [
    "255",
    9
  ],
  "./_deziiign/hsedesign/app": [
    "66841",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99554"
  ],
  "./_deziiign/books/helpers/copyLink": [
    "77885",
    9
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index.tsx": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_deziiign/online/utils": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/s-software-engineering/app.tsx": [
    "99790",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14115"
  ],
  "./_deziiign/school/styles": [
    "6510",
    9,
    "40355"
  ],
  "./_competition/pages/AllCompetitionsPage/types": [
    "29334",
    9
  ],
  "./_deziiign/conceptmediiia/routesList.tsx": [
    "83700",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "62165"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext": [
    "51106",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "32500"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList.tsx": [
    "33014",
    9
  ],
  "./_deziiign/hsespace/utils/": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField.tsx": [
    "32449",
    9,
    "50042"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/HeadComponent.tsx": [
    "78884",
    9,
    "6757"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-8c3dd122a36c48efa98a8601b0a19c6e.jpg": [
    "91582",
    1,
    "5587"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage.tsx": [
    "65548",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionNominatiosBlock.tsx": [
    "98635",
    9,
    "36184"
  ],
  "./_deziiign/hsehh/styles.tsx": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/AllCompetitionsPage": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/onlines/OnlinesMetaTags.tsx": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/awards/app": [
    "10445",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89054"
  ],
  "./_fr/saopaulo/routesList.tsx": [
    "86257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20138"
  ],
  "./_geograffee/dafes/icons/ADCRBlockIcon.tsx": [
    "27492",
    9,
    "869"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard": [
    "21919",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/edu-54f240ac75a148a2acac41074ac7527f.jpg": [
    "52734",
    1,
    "68275"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags": [
    "22226",
    9,
    "99727"
  ],
  "./_geograffee/dafes/images/awards2026/DAFES25.jpg": [
    "15697",
    1,
    "12714"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/fashion-en-ae99c77bdc6b4a4db8f14b88e662212f.jpg": [
    "26383",
    1,
    "88644"
  ],
  "./_deziiign/main/pages/tagAdmin/index": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts.ts": [
    "40309",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/calendarReadymag.svg": [
    "8324",
    1,
    "99205"
  ],
  "./_competition/pages/CompetitionsAdmin/components/style.ts": [
    "8608",
    9,
    "83321"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesTable": [
    "9707",
    9,
    "5894",
    "86041",
    "69592"
  ],
  "./_deziiign/s-extra/app.tsx": [
    "20657",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21802"
  ],
  "./_competition/pages/CreateCompetitionPage/stylesEdit.tsx": [
    "42355",
    9
  ],
  "./_deziiign/books/pages/sections/ps-image": [
    "9421",
    9
  ],
  "./_deziiign/hsecreative/routesList": [
    "23307",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99416"
  ],
  "./_deziiign/awards/styles.tsx": [
    "37460",
    9,
    "98197"
  ],
  "./_ftbl/main/assets/flags/gerFlag.png": [
    "64288",
    1,
    "18073"
  ],
  "./_deziiign/namesmediiia/app.tsx": [
    "47185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "55402"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/ContactsAwards2025.tsx": [
    "90270",
    9,
    "94498",
    "45715"
  ],
  "./_kz/dafes-fashion/app": [
    "78105",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "90146"
  ],
  "./_kz/dafes/components/SegmentSwitcher.tsx": [
    "6992",
    9,
    "9961"
  ],
  "./_fr/shanghai/app": [
    "59269",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "47046"
  ],
  "./_competition/pages/ShortListPage/": [
    "13978",
    9,
    "86439"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/ContactsAwards2025": [
    "90270",
    9,
    "94498",
    "45715"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/icons/Arrows": [
    "75562",
    9,
    "59639"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/intuitLabImg.png": [
    "65236",
    1,
    "58165"
  ],
  "./_deziiign/hsespacefilm/routesList": [
    "18438",
    9,
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69775",
    "90370",
    "56768",
    "555"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-d5a5c00f112943a48acefac7bd0c53c0.jpg": [
    "17680",
    1,
    "42985"
  ],
  "./_competition/components/Image.jpg": [
    "95503",
    1,
    "44676"
  ],
  "./_deziiign/mymediiia/routesList": [
    "17170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56367"
  ],
  "./_deziiign/school/app": [
    "46931",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44080"
  ],
  "./_ftbl/main/assets/flags/engFlag.png": [
    "43302",
    1,
    "68235"
  ],
  "./_deziiign/main/pages/tagAdmin/": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/TagsComponent.tsx": [
    "40805",
    9,
    "7494"
  ],
  "./_fr/main/app": [
    "77753",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "65954"
  ],
  "./_deziiign/cgrave/app.tsx": [
    "48621",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "63934"
  ],
  "./_deziiign/s-pro/app": [
    "45622",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "18651"
  ],
  "./_deziiign/books/pages/tag/index.ts": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index": [
    "81459",
    9,
    "25872"
  ],
  "./_ftbl/main/assets/leagues/france.png": [
    "90582",
    1,
    "78235"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ChildrensBookIcon.tsx": [
    "33834",
    9,
    "79671"
  ],
  "./_deziiign/booksgallllery/routesList.tsx": [
    "14518",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98363"
  ],
  "./_deziiign/lab/app.tsx": [
    "14678",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44571"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/HeadComponent": [
    "78884",
    9,
    "6757"
  ],
  "./_deziiign/books/pages/sections/ps-buttons.tsx": [
    "56100",
    9,
    "86309"
  ],
  "./_geograffee/dafes/images/awards2026/headerPlace.svg": [
    "30257",
    1,
    "3370"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-94a50e63889f48fc81c7791f36d30dcd.jpg": [
    "98874",
    1,
    "76423"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions": [
    "68",
    9,
    "36069"
  ],
  "./_ftbl/main/pages/AllMatches/AllMatchesPage": [
    "68523",
    9,
    "34486",
    "63800"
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutFtbl.tsx": [
    "23928",
    9,
    "21921"
  ],
  "./_deziiign/aki/app": [
    "84085",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9695"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage": [
    "97728",
    9,
    "27769"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableHeaderBlock.tsx": [
    "80327",
    9,
    "56748"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/AdditionalFeatures": [
    "76509",
    9,
    "17486",
    "82499"
  ],
  "./_deziiign/main/routesList.tsx": [
    "67087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles.ts": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationItem": [
    "18729",
    9,
    "29938"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager": [
    "85524",
    9
  ],
  "./_deziiign/books/pages/BookEdit/constants.ts": [
    "16292",
    9
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/CategoryPartner": [
    "5381",
    9,
    "82118"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TeamTable": [
    "33480",
    9,
    "28561"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookEdit": [
    "992",
    9,
    "19833"
  ],
  "./_deziiign/brnd/app.tsx": [
    "8109",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "23902"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools.tsx": [
    "19117",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts": [
    "40309",
    9
  ],
  "./_deziiign/kiiidsmediiia/routesList": [
    "47865",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11970"
  ],
  "./_deziiign/mymediiia/routesList.tsx": [
    "17170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56367"
  ],
  "./_fr/main/routesList": [
    "41816",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97281"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsCategory.tsx": [
    "40313",
    9,
    "51042"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread.tsx": [
    "55855",
    9,
    "20004"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/normalizeTabName": [
    "93513",
    9,
    "94130"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/styles.ts": [
    "78462",
    9,
    "90835"
  ],
  "./_geograffee/dafes/app.tsx": [
    "76242",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "37071"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 132.jpg": [
    "50998",
    1,
    "73083"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles.ts": [
    "18626",
    9,
    "59871"
  ],
  "./_competition/routesList.tsx": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/NewsPlayer": [
    "88362",
    9,
    "21591"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout.tsx": [
    "56925",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index.tsx": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/hsedesign/components/IndexTitle.tsx": [
    "91797",
    9
  ],
  "./_deziiign/hsespace/components/IndexTitle": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/EditUser": [
    "68730",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesButton": [
    "4203",
    9,
    "95992"
  ],
  "./_deziiign/alshibaya/routesList.tsx": [
    "76808",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21649"
  ],
  "./_geograffee/dafes/icons/sliderIcons/AIcon.tsx": [
    "34036",
    9,
    "6037"
  ],
  "./_deziiign/onlines/pages/readymag/images/bgReadymag.jpg": [
    "32490",
    1,
    "77559"
  ],
  "./_deziiign/s-hseissek/routesList.tsx": [
    "5391",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76228"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage.tsx": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName": [
    "20936",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/DafesSlider.tsx": [
    "7682",
    9,
    "20959"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection.tsx": [
    "84390",
    9,
    "33131"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/types.ts": [
    "79427",
    9,
    "37568"
  ],
  "./_geograffee/dafes/images/D4_childrens_e-bookEN.jpg": [
    "46040",
    1,
    "42337"
  ],
  "./_geograffee/dafes/images/awards2026/navLogo_upd.svg": [
    "16399",
    1,
    "19076"
  ],
  "./_deziiign/transfermediiia/app": [
    "56774",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "70987"
  ],
  "./_deziiign/s-philosophy/routesList.tsx": [
    "89821",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8782"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/blender.svg": [
    "85533",
    1,
    "97038"
  ],
  "./_deziiign/fairartz/app": [
    "76874",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76215"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-f37675243e344cecb404e17b9df2d7d3.jpg": [
    "8616",
    1,
    "76721"
  ],
  "./_deziiign/s-sociology/routesList.tsx": [
    "82256",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26089"
  ],
  "./_deziiign/kiiidsmediiia/app": [
    "30378",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28471"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/books/core/components/shareButton": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/profmediiia/app": [
    "18186",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51031"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/startups-en-4ac9aba7802f4803b36c4c163836bc48.jpg": [
    "37567",
    1,
    "88692"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 128.jpg": [
    "86065",
    1,
    "16472"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookEdit.tsx": [
    "992",
    9,
    "19833"
  ],
  "./_deziiign/hsespacefilm/app": [
    "32499",
    9,
    "24074",
    "83762",
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69775",
    "90370",
    "56768",
    "38256"
  ],
  "./_deziiign/urbanmediiia/routesList": [
    "31300",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58533"
  ],
  "./_ftbl/main/hooks/useGetPeriods": [
    "99170",
    9,
    "99007"
  ],
  "./_deziiign/main/pages/moderHseView": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/hsespacecreative/routesList.tsx": [
    "9137",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "27402"
  ],
  "./_ftbl/main/styles": [
    "5836",
    9,
    "36477"
  ],
  "./_competition/pages/CompetitionsAdmin/components/SearchInput.tsx": [
    "99951",
    9,
    "22116"
  ],
  "./_fr/marseille/styles": [
    "19993",
    9,
    "26050"
  ],
  "./_deziiign/kiiidsmediiia/routesList.tsx": [
    "47865",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "11970"
  ],
  "./_ftbl/main/assets/icons/PredictionButtonArrow": [
    "35313",
    9,
    "41130"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItemInfo/styles.ts": [
    "93983",
    9,
    "41460"
  ],
  "./_deziiign/main/pages/eduTagAdmin/": [
    "25672",
    9,
    "32049"
  ],
  "./_deziiign/kiiids/components/IndexTitle.tsx": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/components/CompetitionFormStart.tsx": [
    "53915",
    9,
    "80328"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/styles.ts": [
    "44479",
    9,
    "69812"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem": [
    "1746",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles.ts": [
    "63011",
    9,
    "58528"
  ],
  "./_deziiign/main/app.tsx": [
    "71236",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "20069"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames": [
    "88358",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField": [
    "70009",
    9,
    "30818"
  ],
  "./_deziiign/s-music/routesList.tsx": [
    "10621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31790"
  ],
  "./_deziiign/s-arthistory/routesList": [
    "7121",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87306"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/styles": [
    "50263",
    9,
    "88988"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 120.jpg": [
    "90723",
    1,
    "31616"
  ],
  "./_deziiign/hsehh/styles": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/CompetitionsAdmin/const": [
    "67035",
    9
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/styles.ts": [
    "54038",
    9,
    "94395"
  ],
  "./_geograffee/dafes/images/A1_curators_project.jpg": [
    "84922",
    1,
    "35207"
  ],
  "./_deziiign/musicmediiia/app.tsx": [
    "62630",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58923"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/ProfilesDropdownIcon": [
    "77711",
    9,
    "71300"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 121.jpg": [
    "68550",
    1,
    "3243"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/StartupsBlock.tsx": [
    "94425",
    9,
    "95992",
    "26274"
  ],
  "./_deziiign/s-psychology/routesList.tsx": [
    "81139",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25680"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/const": [
    "93273",
    9,
    "16514"
  ],
  "./_competition/pages/ProjectsPage": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/hseanimation/app.tsx": [
    "36769",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25562"
  ],
  "./_deziiign/hseanimation/routesList": [
    "27072",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "55417"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage": [
    "44676",
    9,
    "645"
  ],
  "./_fr/paris/routesList.tsx": [
    "21048",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "70881"
  ],
  "./_deziiign/lmshsecreative/app": [
    "59520",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64665"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/JoinEcosystemForm": [
    "67138",
    9,
    "95992",
    "54911",
    "46248"
  ],
  "./_deziiign/s-philology/routesList.tsx": [
    "22217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "1490"
  ],
  "./_deziiign/lmshsecreative/routesList": [
    "83811",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "91424"
  ],
  "./_deziiign/jhonatanet/styles": [
    "57886",
    9,
    "19987"
  ],
  "./_geograffee/dafes/icons/awardsNominations/CGRaveIcon.tsx": [
    "77373",
    9,
    "54030"
  ],
  "./_geograffee/dafes/icons/awardsNominations/SberIcon": [
    "25089",
    9,
    "76442"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolIcon.tsx": [
    "87332",
    9,
    "53797"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map.tsx": [
    "72684",
    9,
    "6602",
    "96678",
    "52477",
    "30153"
  ],
  "./_deziiign/main/pages/MainTagAdminPage": [
    "53920",
    9,
    "8985"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueList.tsx": [
    "33420",
    9,
    "99037"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style.ts": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/prev.svg": [
    "89819",
    1,
    "59528"
  ],
  "./_deziiign/jhonatanet/app.tsx": [
    "39063",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "36220"
  ],
  "./_deziiign/main/pages/eduTagAdmin": [
    "25672",
    9,
    "32049"
  ],
  "./_deziiign/school/utils": [
    "89716",
    9,
    "99509"
  ],
  "./_geograffee/dafes/icons/awardsNominations/System108Icon.tsx": [
    "94777",
    9,
    "15874"
  ],
  "./_deziiign/books/core/hook/api/useBook.ts": [
    "97393",
    9,
    "75882"
  ],
  "./_geograffee/dafes/images/university_slider_item_4.png": [
    "97557",
    1,
    "80982"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage.tsx": [
    "94292",
    9,
    "24074",
    "47268",
    "83275",
    "78037"
  ],
  "./_competition/pages/CompetitionsAdmin/style.ts": [
    "31209",
    9,
    "6290"
  ],
  "./_fr/dubai/routesList.tsx": [
    "94158",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99299"
  ],
  "./_fr/shanghai/routesList.tsx": [
    "7100",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88557"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/styles": [
    "54038",
    9,
    "94395"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableComponent": [
    "92736",
    9,
    "71641"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/sliderImages": [
    "58412",
    9,
    "68189"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange.tsx": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_geograffee/dafes/images/globe.png": [
    "90623",
    1,
    "78068"
  ],
  "./_deziiign/hsedesign/pages/TagExpertsPage/TagExpertsPage.tsx": [
    "12022",
    9,
    "26139"
  ],
  "./_geograffee/dafes/icons/ADCRBlockIcon": [
    "27492",
    9,
    "869"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock.tsx": [
    "2850",
    9,
    "58591"
  ],
  "./_deziiign/books/pages/tag/index": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-b1e23c003f964e53b854f41d957276da.jpg": [
    "22485",
    1,
    "21174"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/sportmediiia/app": [
    "37223",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "4076"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.tsx": [
    "99082",
    9
  ],
  "./_deziiign/s-hseissek/routesList": [
    "5391",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76228"
  ],
  "./_deziiign/s-urban-development/routesList.tsx": [
    "14622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "14419"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher.tsx": [
    "51152",
    9
  ],
  "./_geograffee/dafes/pages/CountryShowcase": [
    "62779",
    9,
    "15969",
    "6049",
    "99448",
    "16433"
  ],
  "./_deziiign/newcha/app": [
    "21659",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1544"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader": [
    "6371",
    9,
    "95360"
  ],
  "./_deziiign/booksmediiia/routesList": [
    "69210",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44807"
  ],
  "./_deziiign/continuumsite/img/image_1440.png": [
    "58626",
    1,
    "3167"
  ],
  "./_deziiign/hsecreative/styles": [
    "41431",
    9,
    "7036"
  ],
  "./_deziiign/historymediiia/app": [
    "70761",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd.tsx": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/books/pages/sections/ps-chapters.tsx": [
    "10434",
    9
  ],
  "./_deziiign/s-mathematics/app": [
    "63417",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "3138"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-7159820a94224b8cb5492a4bc97815ea.jpg": [
    "4864",
    1,
    "22585"
  ],
  "./_deziiign/hsehh/app.tsx": [
    "3651",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94624"
  ],
  "./_fr/paris/routesList": [
    "21048",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "70881"
  ],
  "./_geograffee/dafes/images/industry_features.png": [
    "51696",
    1,
    "34505"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip.tsx": [
    "67816",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.css": [
    "86691",
    9,
    "63008"
  ],
  "./_deziiign/hsestart/styles.tsx": [
    "69730",
    9,
    "59551"
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud.tsx": [
    "40443",
    9,
    "41480"
  ],
  "./_deziiign/historymediiia/routesList": [
    "93384",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "24881"
  ],
  "./_deziiign/alshibaya/routesList": [
    "76808",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21649"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsDafesIcon.tsx": [
    "33661",
    9,
    "59502"
  ],
  "./_deziiign/continuumsite/img/image_320.png": [
    "76496",
    1,
    "92841"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconEn.tsx": [
    "50085",
    9,
    "134"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts": [
    "61644",
    9,
    "82173"
  ],
  "./_deziiign/storiesmediiia/routesList.tsx": [
    "88515",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "20800"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/styles.ts": [
    "86826",
    9,
    "32375"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flagtop.svg": [
    "57053",
    1,
    "56942"
  ],
  "./_deziiign/fashion/app": [
    "979",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71856"
  ],
  "./_deziiign/s-political-science/routesList.tsx": [
    "7938",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "90783"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PauseIcon": [
    "7356",
    9,
    "20173"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 118.jpg": [
    "35638",
    1,
    "81275"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-3fd8cec4336a4139ac92529fdbef0d8f.jpg": [
    "57611",
    1,
    "57272"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPageNew": [
    "51019",
    9,
    "50333",
    "36435",
    "99640"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/styles.ts": [
    "88198",
    9,
    "58187"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/WhiteTopBlock.tsx": [
    "16141",
    9,
    "95992",
    "72446"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/FormsComponent.tsx": [
    "98547",
    9,
    "95312"
  ],
  "./_competition/pages/CompetitionResultsPage/index": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField": [
    "34897",
    9,
    "40266"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/icons/Arrows.tsx": [
    "75562",
    9,
    "59639"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/jhonatanet/app": [
    "39063",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "36220"
  ],
  "./_ftbl/main/pages/MainPage/components/GameItem": [
    "40634",
    9,
    "23943"
  ],
  "./_competition/pages/AllCompetitionsPage/": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/s-extra/routesList.tsx": [
    "54128",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "60809"
  ],
  "./_deziiign/aimediiia/routesList.tsx": [
    "83870",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42291"
  ],
  "./_deziiign/s-hseincomm/routesList.tsx": [
    "61265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85322"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName.tsx": [
    "20936",
    9
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField.tsx": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/main/pages/moderHseView/index.ts": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_geograffee/dafes/images/university_slider_item_1.png": [
    "7976",
    1,
    "79025"
  ],
  "./_deziiign/cinemediiia/app": [
    "27588",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "50533"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage": [
    "22570",
    9,
    "6244"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableLinkSortBlock": [
    "46829",
    9,
    "58599"
  ],
  "./_deziiign/s-history/routesList.tsx": [
    "74294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58971"
  ],
  "./_geograffee/dafes/icons/GoldBlockThreeIcon.tsx": [
    "40394",
    9,
    "88631"
  ],
  "./_geograffee/dafes/pages/DafesOrgPage": [
    "81564",
    9,
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293"
  ],
  "./_deziiign/onlines/routesList.tsx": [
    "68354",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6047"
  ],
  "./_deziiign/ranepa/app.tsx": [
    "96030",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83059"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer": [
    "13411",
    9,
    "41906"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/blocks.svg": [
    "75650",
    1,
    "84127"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner": [
    "8700",
    9,
    "13908",
    "21565",
    "5357"
  ],
  "./_kz/pro/routesList.tsx": [
    "2265",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "92034"
  ],
  "./_deziiign/books/pages/sections/assets/link.svg": [
    "12118",
    1,
    "187"
  ],
  "./_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions.ts": [
    "63349",
    9
  ],
  "./_deziiign/automediiia/routesList.tsx": [
    "83561",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54130"
  ],
  "./_deziiign/main/styles": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/namesmediiia/app": [
    "47185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "55402"
  ],
  "./_deziiign/artmediiia/app": [
    "43916",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "6749"
  ],
  "./_deziiign/s-arthistory/routesList.tsx": [
    "7121",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87306"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController.tsx": [
    "90929",
    9,
    "68778"
  ],
  "./_fr/marseille/routesList.tsx": [
    "70005",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81782"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathRight.svg": [
    "31052",
    1,
    "34813"
  ],
  "./_geograffee/dafes/images/A1_curators_projectEN.jpg": [
    "64595",
    1,
    "93328"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/StartupsBlock": [
    "94425",
    9,
    "95992",
    "26274"
  ],
  "./_deziiign/books/core/components/shareButton/": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/s-economy/routesList.tsx": [
    "59950",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8771"
  ],
  "./_deziiign/urbanmediiia/app": [
    "22093",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5214"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ.tsx": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner.tsx": [
    "8700",
    9,
    "13908",
    "21565",
    "5357"
  ],
  "./_geograffee/dafes/images/E1_educational_courseEN.jpg": [
    "52323",
    1,
    "46848"
  ],
  "./_geograffee/dafes/images/S1_brand_year.jpg": [
    "44734",
    1,
    "80051"
  ],
  "./_deziiign/books/core/hook/api/useBook": [
    "97393",
    9,
    "75882"
  ],
  "./_kz/dafes-fashion/app.tsx": [
    "78105",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "90146"
  ],
  "./_deziiign/superpuper/styles.tsx": [
    "45757",
    9,
    "16398"
  ],
  "./_competition/components/CompetitionFormStart": [
    "53915",
    9,
    "80328"
  ],
  "./_geograffee/dafes/images/A1_best_research_publication.jpg": [
    "69180",
    1,
    "93261"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/validateForm": [
    "49918",
    9,
    "97568"
  ],
  "./_deziiign/main/pages/tagAdmin/index.ts": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/admediiia/app.tsx": [
    "9468",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38445"
  ],
  "./_deziiign/brnd/routesList": [
    "59684",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21733"
  ],
  "./_fr/saopaulo/styles.tsx": [
    "78093",
    9,
    "32766"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/s-cinema/routesList.tsx": [
    "18301",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5262"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/automediiia/app": [
    "38106",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99687"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/hsedesign/utils/index.ts": [
    "46106",
    9,
    "87527"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolIcon": [
    "87332",
    9,
    "53797"
  ],
  "./_deziiign/main/routesList": [
    "67087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47108"
  ],
  "./_deziiign/books/pages/sections/ps-chapters": [
    "10434",
    9
  ],
  "./_ftbl/main/pages/AboutFtbl/AboutPageBlock": [
    "76486",
    9,
    "27691"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/styles.ts": [
    "42776",
    9,
    "31854"
  ],
  "./_deziiign/main/pages/projectDeziign": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_kz/dafes/constants/segments.ts": [
    "1953",
    9
  ],
  "./_deziiign/s-biology/routesList.tsx": [
    "28257",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "73402"
  ],
  "./_deziiign/onlines/styles.tsx": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/books/app": [
    "52905",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/musicmediiia/routesList.tsx": [
    "17469",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23406"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles": [
    "18626",
    9,
    "59871"
  ],
  "./_deziiign/cgrave/app": [
    "48621",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "63934"
  ],
  "./_competition/components/SendProjectButton.tsx": [
    "26709",
    9
  ],
  "./_deziiign/historymediiia/app.tsx": [
    "70761",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField.tsx": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/pro/app": [
    "31834",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43559"
  ],
  "./_deziiign/books/pages/BookEdit": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/books/pages/BookListView/": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/NewsPlayer.tsx": [
    "88362",
    9,
    "21591"
  ],
  "./_competition/pages/JuryPage/index.ts": [
    "5122",
    9,
    "91967"
  ],
  "./_geograffee/dafes/images/university_features.png": [
    "50754",
    1,
    "16863"
  ],
  "./_deziiign/s-hseissek/app": [
    "10052",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21285"
  ],
  "./_deziiign/galllleryart/routesList.tsx": [
    "43137",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93914"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField.tsx": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/ageytomesh/app": [
    "61045",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "24822"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index.ts": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip": [
    "67816",
    9
  ],
  "./_deziiign/awards/components/IndexTitle": [
    "81233",
    9,
    "96362"
  ],
  "./_geograffee/dafes/images/awards2026/footerLogo.svg": [
    "92143",
    1,
    "38084"
  ],
  "./_ftbl/main/app.tsx": [
    "87614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "63539"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-1f55d88a80954bf18d195d44424e782c.jpg": [
    "40417",
    1,
    "87226"
  ],
  "./_deziiign/dvadesign/routesList": [
    "13069",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53918"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions.ts": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/ranepa/styles.tsx": [
    "5465",
    9,
    "62338"
  ],
  "./_fr/saopaulo/styles": [
    "78093",
    9,
    "32766"
  ],
  "./_deziiign/kiiids/styles": [
    "19025",
    9,
    "99402"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner3.svg": [
    "91900",
    1,
    "29293"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/Profiles": [
    "70198",
    9,
    "95992",
    "86811"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage.tsx": [
    "2925",
    9,
    "99358"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/HeaderAwards2025.tsx": [
    "83534",
    9,
    "94498",
    "71779"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/PartnersAwards2025.tsx": [
    "5168",
    9,
    "94498",
    "28809"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustratonFour.svg": [
    "2724",
    1,
    "96069"
  ],
  "./_geograffee/dafes/icons/awardsNominations/HSEArtDesignIcon": [
    "32474",
    9,
    "58087"
  ],
  "./_deziiign/profmediiia/app.tsx": [
    "18186",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51031"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/JuryAwards2025": [
    "10505",
    9,
    "94498",
    "51058"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/TableComponent.tsx": [
    "92736",
    9,
    "71641"
  ],
  "./_competition/pages/JuryPage/index": [
    "5122",
    9,
    "91967"
  ],
  "./_geograffee/dafes/images/university_slider_item_3.png": [
    "39610",
    1,
    "6599"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DafesIcon": [
    "81116",
    9,
    "83021"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/CouncilBlock.tsx": [
    "26534",
    9,
    "95992",
    "99723"
  ],
  "./_ftbl/main/assets/icons/TableSortArrow": [
    "48776",
    9,
    "76593"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArrowIcon": [
    "1731",
    9,
    "52928"
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/DafesFooter": [
    "48618",
    9,
    "55383"
  ],
  "./_competition/pages/CreateCompetitionPage/index.tsx": [
    "40565",
    9,
    "24074",
    "47268",
    "83275",
    "41996",
    "60901",
    "84869",
    "55761",
    "23126"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/SmallIcon.tsx": [
    "33897",
    9,
    "11666"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign": [
    "16148",
    9,
    "44821"
  ],
  "./_ftbl/main/hooks/useGetResultsTable": [
    "11716",
    9,
    "33381"
  ],
  "./_deziiign/onlines/pages/readymag/images/bg2Readymag.jpg": [
    "54970",
    1,
    "32487"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField.tsx": [
    "38958",
    9,
    "43907"
  ],
  "./_deziiign/school/utils/": [
    "89716",
    9,
    "99509"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/SmallIcon": [
    "33897",
    9,
    "11666"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit": [
    "441",
    9,
    "70530"
  ],
  "./_competition/pages/ProjectsPage/": [
    "31708",
    9,
    "99309"
  ],
  "./_fr/mumbai/app": [
    "13099",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "78840"
  ],
  "./_competition/pages/AllCompetitionsPage/styled": [
    "70740",
    9
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards.tsx": [
    "70067",
    9
  ],
  "./_uz/main/styles.tsx": [
    "99549",
    9,
    "71950"
  ],
  "./_geograffee/dafes/icons/awardsNominations/SberIcon.tsx": [
    "25089",
    9,
    "76442"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem.tsx": [
    "1746",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage.tsx": [
    "77159",
    9,
    "6636"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner11.svg": [
    "55427",
    1,
    "84704"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/ConnectionFormat.tsx": [
    "51706",
    9,
    "60807"
  ],
  "./_deziiign/s-hsetto/routesList.tsx": [
    "54479",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "25668"
  ],
  "./_deziiign/onlines/styles": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage": [
    "55002",
    9,
    "53972"
  ],
  "./_deziiign/s-fashion/routesList": [
    "7386",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "80679"
  ],
  "./_deziiign/s-virtualspace/app": [
    "17978",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "41575"
  ],
  "./_ftbl/main/pages/AllMatches/AllMatchesPage.tsx": [
    "68523",
    9,
    "34486",
    "63800"
  ],
  "./_deziiign/alshibaya/app": [
    "75337",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "81938"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/styles": [
    "34966",
    9,
    "63771"
  ],
  "./_competition/pages/CompetitionTable": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_geograffee/dafes/images/awards2026/slavin.png": [
    "84862",
    1,
    "25107"
  ],
  "./_deziiign/onlinesdesign/pages/CoursesPage": [
    "18602",
    9,
    "70583"
  ],
  "./_geograffee/dafes/icons/footerIcons/TelegramIcon.tsx": [
    "3387",
    9,
    "4689"
  ],
  "./_deziiign/awards/utils/index.ts": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/kiiids/utils": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/continuumsite/styles.ts": [
    "5915",
    9,
    "9064"
  ],
  "./_ftbl/main/assets/icons/CheckedIcon.tsx": [
    "79495",
    9,
    "10316"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/styles.ts": [
    "54922",
    9,
    "37143"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/DigitalEcosystem.tsx": [
    "13236",
    9,
    "95992",
    "48949"
  ],
  "./_deziiign/main/pages/moderView/moderView": [
    "29397",
    9,
    "51382"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage": [
    "8078",
    9,
    "53283"
  ],
  "./_geograffee/dafes/images/awards2026/broche.png": [
    "81616",
    1,
    "25737"
  ],
  "./_fr/marseille/app": [
    "34718",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14707"
  ],
  "./_kz/dafes/app": [
    "5778",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21551"
  ],
  "./_deziiign/game/routesList": [
    "71368",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "75345"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/whatsapp.svg": [
    "12962",
    1,
    "33567"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesTableAction.tsx": [
    "32525",
    9,
    "5894",
    "48958"
  ],
  "./_deziiign/books/core/components/helper/bookEvents": [
    "75209",
    9,
    "73051"
  ],
  "./_geograffee/dafes/images/S1_creative_entrepreneurshipEN.jpg": [
    "94295",
    1,
    "75580"
  ],
  "./_deziiign/main/pages/moderView/index": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/main/pages/projectDeziign/index": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/helpers/getDaysToFinish.ts": [
    "20572",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs.tsx": [
    "70789",
    9,
    "27494"
  ],
  "./_deziiign/lmshse/styles.tsx": [
    "98454",
    9,
    "4731"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid.tsx": [
    "1268",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils.ts": [
    "22125",
    9
  ],
  "./_deziiign/hsespacefilm/app.tsx": [
    "32499",
    9,
    "24074",
    "83762",
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69775",
    "90370",
    "56768",
    "38256"
  ],
  "./_deziiign/kiiids/app.tsx": [
    "43814",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5227"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/CategoriesIcon.tsx": [
    "98064",
    9,
    "8489"
  ],
  "./_geograffee/dafes/images/A4_illustrationEN.jpg": [
    "79973",
    1,
    "42342"
  ],
  "./_deziiign/main/pages/admin/AdminPage": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib2.jpg": [
    "69834",
    1,
    "86007"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/CGRaveIcon.tsx": [
    "74188",
    9,
    "20253"
  ],
  "./_deziiign/foodmediiia/routesList.tsx": [
    "62124",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53245"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/LPUIcon.tsx": [
    "83451",
    9,
    "57352"
  ],
  "./_geograffee/dafes/images/E1_educational_course.jpg": [
    "7050",
    1,
    "66423"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/RauIcon.tsx": [
    "20126",
    9,
    "99731"
  ],
  "./_deziiign/pro/routesList": [
    "16598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "46706"
  ],
  "./_deziiign/transfermediiia/routesList.tsx": [
    "24253",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88494"
  ],
  "./_competition/pages/AllCompetitionsPage/index.tsx": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout": [
    "56925",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList": [
    "84852",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39797"
  ],
  "./_deziiign/adcrdafesnet/styles": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/monalisatravels/app.tsx": [
    "90436",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "77655"
  ],
  "./_deziiign/s-physics/routesList": [
    "36487",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39212"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationsAwards2025": [
    "85602",
    9,
    "94498",
    "43807"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderNextButtonIcon": [
    "26191",
    9,
    "25252"
  ],
  "./_deziiign/main/pages/moderHseView/": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_fr/paris/styles.tsx": [
    "32720",
    9,
    "71913"
  ],
  "./_ftbl/main/hooks/useGetPredictionsInfo": [
    "76678",
    9,
    "97675"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults.tsx": [
    "77349",
    9,
    "96678",
    "52071"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionWinnersPage": [
    "26884",
    9,
    "60901",
    "84869"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookChaptersEdit.tsx": [
    "50250",
    9,
    "3063"
  ],
  "./_deziiign/awards/routesList.tsx": [
    "80164",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "84709"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/ADCRBlock": [
    "27635",
    9,
    "33104"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/AwardsTopBlock.tsx": [
    "98386",
    9,
    "95992",
    "97387",
    "21647"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 127.jpg": [
    "49072",
    1,
    "11881"
  ],
  "./_geograffee/dafes/pages/ui/DafesSlider/DafesSlider": [
    "7682",
    9,
    "20959"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/FooterAwards2025": [
    "12840",
    9,
    "28977"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 133.jpg": [
    "14163",
    1,
    "23824"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index.ts": [
    "81459",
    9,
    "25872"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/CGRaveIcon": [
    "74188",
    9,
    "20253"
  ],
  "./_geograffee/dafes/images/A9_сoncept_artEN.jpg": [
    "27976",
    1,
    "66385"
  ],
  "./_geograffee/dafes/images/architecture_logo.jpeg": [
    "63361",
    1,
    "42723"
  ],
  "./_deziiign/online/routesList.tsx": [
    "51217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2026"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/PlatformFeatures.tsx": [
    "23507",
    9,
    "83504"
  ],
  "./_ftbl/main/hooks/useChamps": [
    "81764",
    9,
    "37701"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags.tsx": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/hsespace/routesList": [
    "82760",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31889"
  ],
  "./_deziiign/s-oriental/app": [
    "43791",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39300"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation.tsx": [
    "36014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign.tsx": [
    "13598",
    9,
    "72339"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesBigButton": [
    "38385",
    9,
    "85066"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/isCardBlockedForPaidBook.ts": [
    "44387",
    9
  ],
  "./_deziiign/urbanmediiia/app.tsx": [
    "22093",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5214"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/sections/StatusesSettings": [
    "90368",
    9,
    "5894",
    "86041"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/shouldShowCompetitionWinnersPage": [
    "56273",
    9,
    "85482"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit": [
    "85441",
    9,
    "60901",
    "83162"
  ],
  "./_deziiign/books/pages/BookEdit/providers/bookEditorProvider": [
    "54729",
    9
  ],
  "./_deziiign/s-psychology/app": [
    "32336",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31145"
  ],
  "./_deziiign/hsespace/utils/index.ts": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput": [
    "24471",
    9,
    "76604"
  ],
  "./_competition/pages/CreateCompetitionPage/styles": [
    "31768",
    9
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/art-en-c81e874146014a78b8eb5c66a8698486.jpg": [
    "24305",
    1,
    "77546"
  ],
  "./_deziiign/s-hseincomm/app.tsx": [
    "30562",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59711"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationsAwards2025.tsx": [
    "85602",
    9,
    "94498",
    "43807"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/flags.png": [
    "19831",
    1,
    "78652"
  ],
  "./_deziiign/prohse/routesList": [
    "20171",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21048"
  ],
  "./_deziiign/books/helpers/copyLink.ts": [
    "77885",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/const": [
    "4293",
    9,
    "34182"
  ],
  "./_deziiign/s-chemistry/app.tsx": [
    "5001",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86130"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSectionContent": [
    "29996",
    9,
    "73917"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/UserTable.tsx": [
    "40174",
    9,
    "32611"
  ],
  "./_geograffee/dafes/images/fotolab_logo.png": [
    "28057",
    1,
    "39202"
  ],
  "./_kz/pro/app": [
    "4989",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76311"
  ],
  "./_deziiign/s-hseissek/app.tsx": [
    "10052",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21285"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information.tsx": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/hsestart/styles": [
    "69730",
    9,
    "59551"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/ProfilesIcon": [
    "91598",
    9,
    "93699"
  ],
  "./_deziiign/continuumsite/app.tsx": [
    "36526",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "85059"
  ],
  "./_deziiign/namesmediiia/routesList.tsx": [
    "89232",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95145"
  ],
  "./_deziiign/school/routesList.tsx": [
    "262",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87723"
  ],
  "./_geograffee/dafes/images/A9_сoncept_art.jpg": [
    "17841",
    1,
    "56970"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/styles.ts": [
    "71583",
    9,
    "30100"
  ],
  "./_deziiign/main/app": [
    "71236",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "20069"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/BigIcon": [
    "60082",
    9,
    "27567"
  ],
  "./_deziiign/awards/styles": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/pro/app.tsx": [
    "31834",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43559"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage.tsx": [
    "166",
    9
  ],
  "./_deziiign/s-advertising-and-pr/app.tsx": [
    "98286",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31267"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/ProfilesDropdownIcon.tsx": [
    "77711",
    9,
    "71300"
  ],
  "./_competition/pages/ShortListPage/components/NominationName": [
    "21214",
    9
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook": [
    "82452",
    9
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 117.jpg": [
    "95749",
    1,
    "85446"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/NominationsList": [
    "73450",
    9,
    "26199"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles.ts": [
    "28565",
    9,
    "72054"
  ],
  "./_geograffee/dafes/icons/IntegrationBlockIcon.tsx": [
    "37848",
    9,
    "9473"
  ],
  "./_deziiign/s-cognitive/app": [
    "94287",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "52100"
  ],
  "./_ftbl/main/types/table": [
    "59446",
    9,
    "81851"
  ],
  "./_deziiign/s-international-relations/routesList": [
    "48390",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99627"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/GreenIcon": [
    "91303",
    9,
    "26636"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_deziiign/continuumsite/app": [
    "36526",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "85059"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/ADCRIcon.tsx": [
    "64702",
    9,
    "62227"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/HSEArtIcon": [
    "34205",
    9,
    "61262"
  ],
  "./_geograffee/dafes/icons/awardsNominations/HSEArtDesignIcon.tsx": [
    "32474",
    9,
    "58087"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField.tsx": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon": [
    "37305",
    9,
    "610"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/IrkiIcon": [
    "64708",
    9,
    "80444"
  ],
  "./_deziiign/books/pages/BookEdit/index.ts": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/books/core/components/shareButton/shareButton.tsx": [
    "88300",
    9,
    "45757"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/NominationsIcon": [
    "54893",
    9,
    "42654"
  ],
  "./_deziiign/galllleryart/styles": [
    "78199",
    9,
    "52700"
  ],
  "./_competition/pages/PreRegistrationResult/style": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/greenaward/components/IndexTitle.tsx": [
    "69371",
    9,
    "88360"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconEn": [
    "9688",
    9,
    "72001"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard.tsx": [
    "47486",
    9
  ],
  "./_deziiign/monalisatravels/routesList": [
    "58745",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "93410"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderFashionIcon": [
    "42216",
    9,
    "43793"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/Search": [
    "72663",
    9,
    "5894"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/styles.ts": [
    "80724",
    9,
    "57141"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid": [
    "1268",
    9
  ],
  "./_ftbl/main/assets/clubEmblems/Olympia_Munich.png": [
    "77404",
    1,
    "58637"
  ],
  "./_deziiign/onlinesdesign/pages/CoursesPage.tsx": [
    "18602",
    9,
    "70583"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar.tsx": [
    "89260",
    9,
    "13908",
    "21565"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/TechnologicalBlock": [
    "2303",
    9,
    "95992",
    "44372"
  ],
  "./_deziiign/books/constants.ts": [
    "17857",
    9
  ],
  "./_deziiign/s-biology/app": [
    "72594",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "77743"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/styles": [
    "24222",
    9,
    "96467"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 134.jpg": [
    "43232",
    1,
    "85049"
  ],
  "./_geograffee/dafes/pages/data/nominationsData": [
    "67760",
    9,
    "77097"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useChapterPosts.tsx": [
    "67007",
    9
  ],
  "./_deziiign/s-chemistry/routesList.tsx": [
    "77800",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "10897"
  ],
  "./_deziiign/prohse/routesList.tsx": [
    "20171",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21048"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout.tsx": [
    "80714",
    9,
    "51735"
  ],
  "./_fr/main/app.tsx": [
    "77753",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "65954"
  ],
  "./_deziiign/lpudesign/app": [
    "34912",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title": [
    "20187",
    9,
    "69512"
  ],
  "./_geograffee/dafes/images/awards2026/headerBg.png": [
    "29741",
    1,
    "30910"
  ],
  "./_deziiign/naturemediiia/app": [
    "78614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51835"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/styles": [
    "71002",
    9,
    "39495"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-1f55d88a80954bf18d195d44424e782c.jpg": [
    "59703",
    1,
    "35484"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/s-extra/routesList": [
    "54128",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "60809"
  ],
  "./_deziiign/sciencemediiia/routesList": [
    "38466",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7775"
  ],
  "./_competition/components/CompetitionFormSuccess.tsx": [
    "2402",
    9,
    "63231"
  ],
  "./_competition/pages/CompetitionsAdmin/components/TableContent": [
    "53556",
    9,
    "69301"
  ],
  "./_competition/pages/CompetitionsAdmin/helpers/getFilteredCompetitionsById": [
    "61669",
    9,
    "35494"
  ],
  "./_deziiign/newcha/app.tsx": [
    "21659",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "1544"
  ],
  "./_competition/pages/AllCompetitionsPage/index": [
    "60929",
    9,
    "62850",
    "14618"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon": [
    "1113",
    9,
    "86466"
  ],
  "./_fr/bengaluru/styles": [
    "80904",
    9,
    "18705"
  ],
  "./_deziiign/books/core/components/grid/": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/hsecreative/app": [
    "90600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38161"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map": [
    "72684",
    9,
    "6602",
    "96678",
    "52477",
    "30153"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage": [
    "908",
    9,
    "10717"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts.ts": [
    "2696",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/styles.ts": [
    "34966",
    9,
    "63771"
  ],
  "./_competition/pages/ShortListPage/components/NominationName.tsx": [
    "21214",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories.tsx": [
    "93506",
    9
  ],
  "./_ftbl/main/constants/countryIndexes.ts": [
    "33770",
    9
  ],
  "./_deziiign/fairartz/routesList.tsx": [
    "15737",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "8546"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index.ts": [
    "68671",
    9,
    "3924"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 119.jpg": [
    "90899",
    1,
    "79376"
  ],
  "./_deziiign/galllleryart/app.tsx": [
    "94354",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "35727"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/pen.svg": [
    "99569",
    1,
    "42218"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit.tsx": [
    "85441",
    9,
    "60901",
    "83162"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon.tsx": [
    "1113",
    9,
    "86466"
  ],
  "./_deziiign/books/routesList.tsx": [
    "26760",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star1.svg": [
    "55036",
    1,
    "19789"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput.ts": [
    "24471",
    9,
    "76604"
  ],
  "./_geograffee/dafes/images/A4_illustration.jpg": [
    "78256",
    1,
    "80937"
  ],
  "./_kz/dafes-art/app": [
    "8294",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "22731"
  ],
  "./_deziiign/online/utils/": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/sportmediiia/routesList": [
    "81858",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "19743"
  ],
  "./_deziiign/s-mathematics/app.tsx": [
    "63417",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "3138"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/books/core/common.ts": [
    "62913",
    9,
    "82989"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/specialCompetitionHelpers": [
    "97666",
    9,
    "44735"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsBigIcon": [
    "74146",
    9,
    "27551"
  ],
  "./_deziiign/hsehh/app": [
    "3651",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94624"
  ],
  "./_competition/pages/AllCompetitionsPage/types/types": [
    "49608",
    9
  ],
  "./_deziiign/books/core/hook/api/useBookList": [
    "72617",
    9,
    "96850"
  ],
  "./_geograffee/dafes/pages/data/profilesData": [
    "69221",
    9,
    "89830"
  ],
  "./_competition/pages/PreRegistrationResult/index": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderDesignIcon.tsx": [
    "56298",
    9,
    "30039"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/rm.svg": [
    "87720",
    1,
    "29873"
  ],
  "./_deziiign/hsehh/routesList.tsx": [
    "11862",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "40283"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PlayIcon": [
    "1764",
    9,
    "60261"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner4.svg": [
    "66531",
    1,
    "36384"
  ],
  "./_fr/dubai/styles": [
    "89222",
    9,
    "43179"
  ],
  "./_competition/components/style.ts": [
    "10301",
    9
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/DafesPartnersBlock": [
    "76263",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "7020"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/UserInfo.tsx": [
    "59935",
    9,
    "90109"
  ],
  "./_deziiign/school/pages/init": [
    "74957",
    9,
    "48382"
  ],
  "./_deziiign/s-physics/routesList.tsx": [
    "36487",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39212"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/shouldShowCompetitionWinnersPage.ts": [
    "56273",
    9,
    "85482"
  ],
  "./_deziiign/s-hsetto/app.tsx": [
    "97284",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94949"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileReadymag.svg": [
    "65300",
    1,
    "37804"
  ],
  "./_deziiign/hsespace/routesList.tsx": [
    "82760",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31889"
  ],
  "./_geograffee/dafes/icons/footerIcons/FooterLogo": [
    "31086",
    9,
    "68739"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathLeft.svg": [
    "865",
    1,
    "68250"
  ],
  "./_deziiign/greenaward/app.tsx": [
    "39231",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "84116"
  ],
  "./_ftbl/main/helpers/dateFormatting": [
    "85991",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plantbig.svg": [
    "4083",
    1,
    "42736"
  ],
  "./_fr/delhi/routesList": [
    "60381",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "96046"
  ],
  "./_geograffee/dafes/images/F1_fashion_photoEN.jpg": [
    "3548",
    1,
    "15309"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index.ts": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/s-advertising-and-pr/app": [
    "98286",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31267"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconRu.tsx": [
    "26215",
    9,
    "85772"
  ],
  "./_deziiign/hsecreative/routesList.tsx": [
    "23307",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "99416"
  ],
  "./_deziiign/greenaward/utils/": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsedesign/utils/index": [
    "46106",
    9,
    "87527"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/s-arthistory/app": [
    "56821",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28927"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_ftbl/main/assets/clubEmblems/Babylon_Berlin_International_2.png": [
    "49202",
    1,
    "43407"
  ],
  "./_deziiign/dvadesign/routesList.tsx": [
    "13069",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "53918"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/styles": [
    "36047",
    9,
    "25412"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/fashion-ae99c77bdc6b4a4db8f14b88e662212f.jpg": [
    "1667",
    1,
    "88768"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblTitle": [
    "32877",
    9,
    "49438"
  ],
  "./_deziiign/aki/app.tsx": [
    "84085",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9695"
  ],
  "./_deziiign/onlinesdesign/app": [
    "61389",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59870"
  ],
  "./_deziiign/main/pages/admin/AdminPage.tsx": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/fashionmediiia/app.tsx": [
    "96925",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "82734"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesPageTabPanel.tsx": [
    "25859",
    9,
    "46464"
  ],
  "./_deziiign/books/core/components/tooltips/index.ts": [
    "40356",
    9
  ],
  "./_deziiign/s-history/app.tsx": [
    "25571",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83552"
  ],
  "./_ftbl/main/assets/clubEmblems/Hercules_Barcelona_2.png": [
    "24432",
    1,
    "81321"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/fairmediiia/routesList": [
    "78294",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97243"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderStartupsIcon.tsx": [
    "80866",
    9,
    "9439"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs.ts": [
    "1325",
    9
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/kiiidsmediiia/app.tsx": [
    "30378",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28471"
  ],
  "./_geograffee/dafes/images/D1_identity_and_brandingEN.jpg": [
    "29765",
    1,
    "83238"
  ],
  "./_deziiign/adcrdafesnet/app.tsx": [
    "72893",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "68398"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage.tsx": [
    "69662",
    9,
    "87616"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSection": [
    "79835",
    9,
    "2760"
  ],
  "./_competition/pages/AllOpenCalls.tsx": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles.ts": [
    "14954",
    9,
    "94807"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_uz/main/styles": [
    "99549",
    9,
    "71950"
  ],
  "./_uz/main/app.tsx": [
    "4050",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "28431"
  ],
  "./_deziiign/hsedesign/components/IndexTitle": [
    "91797",
    9
  ],
  "./_deziiign/kiiids/utils/": [
    "80417",
    9,
    "14824"
  ],
  "./_deziiign/galllleryart/app": [
    "94354",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "35727"
  ],
  "./_deziiign/booksmediiia/routesList.tsx": [
    "69210",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44807"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/styles": [
    "10145",
    9,
    "538"
  ],
  "./_geograffee/dafes/pages/DafesOrgPage.tsx": [
    "81564",
    9,
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293"
  ],
  "./_fr/mumbai/routesList": [
    "58622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "87443"
  ],
  "./_geograffee/dafes/images/F1_jewellery_designEN.jpg": [
    "53715",
    1,
    "53392"
  ],
  "./_geograffee/dafes/images/slide_item_6.png": [
    "50678",
    1,
    "99739"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/const.ts": [
    "4293",
    9,
    "34182"
  ],
  "./_competition/pages/CompetitionsAdmin/style": [
    "31209",
    9,
    "6290"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/StatusesTableAction": [
    "32525",
    9,
    "5894",
    "48958"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsDafesIcon": [
    "33661",
    9,
    "59502"
  ],
  "./_competition/helpers/getCompetitionStatus": [
    "30100",
    9
  ],
  "./_deziiign/books/core/components/shareButton/shareButton": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/jhonatanet/routesList.tsx": [
    "98162",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54319"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title.tsx": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/lmshse/routesList.tsx": [
    "89406",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21267"
  ],
  "./_deziiign/awards/components/IndexTitle.tsx": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title": [
    "35075",
    9,
    "95008"
  ],
  "./_ftbl/main/helpers/dateFormatting.ts": [
    "85991",
    9
  ],
  "./_deziiign/sciencemediiia/routesList.tsx": [
    "38466",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7775"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo.tsx": [
    "70085",
    9
  ],
  "./_deziiign/historymediiia/routesList.tsx": [
    "93384",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "24881"
  ],
  "./_competition/components/imageTS.png": [
    "12968",
    1,
    "9489"
  ],
  "./_geograffee/dafes/images/S1_creative_entrepreneurship.jpg": [
    "96270",
    1,
    "16003"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools.tsx": [
    "56695",
    9,
    "76412"
  ],
  "./_deziiign/books/pages/BookEdit/styles.ts": [
    "27552",
    9
  ],
  "./_competition/app": [
    "29104",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98441"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_deziiign/hsedesign/routesList.tsx": [
    "28344",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54529"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_ftbl/main/assets/clubEmblems/Solidarity_Warsaw.png": [
    "10258",
    1,
    "63279"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader.tsx": [
    "6371",
    9,
    "95360"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage": [
    "97566",
    9
  ],
  "./_ftbl/main/constants/tableHeader": [
    "44616",
    9,
    "24712"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth.tsx": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList.tsx": [
    "81206",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "66107"
  ],
  "./_deziiign/s-pro/routesList.tsx": [
    "41741",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "35134"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DafesIcon.tsx": [
    "81116",
    9,
    "83021"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/books/pages/tag/tagBookListView": [
    "29236",
    9,
    "13908",
    "21565",
    "57493"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderPrevButtonIcon.tsx": [
    "73059",
    9,
    "86304"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module2.svg": [
    "82931",
    1,
    "65936"
  ],
  "./_geograffee/dafes/images/awards2026/vanders.png": [
    "82244",
    1,
    "72037"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/bgDvaDesign.jpg": [
    "63081",
    1,
    "72658"
  ],
  "./_deziiign/hsestart/routesList.tsx": [
    "94962",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85660"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/BlueBlock.tsx": [
    "16178",
    9,
    "95992",
    "48591"
  ],
  "./_geograffee/dafes/icons/TechnologicalBlockIcon.tsx": [
    "48592",
    9,
    "68329"
  ],
  "./_deziiign/namesmediiia/routesList": [
    "89232",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95145"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_4.png": [
    "79757",
    1,
    "28574"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/ADCRIcon": [
    "64702",
    9,
    "62227"
  ],
  "./_deziiign/s-virtualspace/app.tsx": [
    "17978",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "41575"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/DafesPartnersBlock.tsx": [
    "76263",
    9,
    "57352",
    "62227",
    "80444",
    "8772",
    "7020"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesMobIconRu": [
    "26215",
    9,
    "85772"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage.tsx": [
    "11278",
    9,
    "31120"
  ],
  "./_deziiign/exams/routesList.tsx": [
    "35170",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "56031"
  ],
  "./_deziiign/lmsmediiia/app": [
    "39117",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59454"
  ],
  "./_deziiign/s-public-administration/routesList": [
    "96916",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "51125"
  ],
  "./_fr/marseille/routesList": [
    "70005",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81782"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SIcon.tsx": [
    "82381",
    9,
    "90951"
  ],
  "./_ftbl/main/hooks/useChamps.ts": [
    "81764",
    9,
    "37701"
  ],
  "./_competition/components/CompetitionDropdown.tsx": [
    "22878",
    9,
    "42419"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/declension": [
    "47607",
    9
  ],
  "./_deziiign/s-geography/app.tsx": [
    "84909",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "12670"
  ],
  "./_geograffee/dafes/images/gold_block_img1.png": [
    "4825",
    1,
    "15362"
  ],
  "./_geograffee/dafes/images/globeWhiteImg.png": [
    "55851",
    1,
    "12920"
  ],
  "./_deziiign/sciencemediiia/app.tsx": [
    "65447",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58028"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField.tsx": [
    "1116",
    9,
    "83917"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/GamesDate.tsx": [
    "42824",
    9,
    "82705"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconEn.tsx": [
    "9688",
    9,
    "72001"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index.ts": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext.tsx": [
    "82310",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "800"
  ],
  "./_deziiign/books/pages/BookListView/index": [
    "76584",
    9,
    "13908",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles.tsx": [
    "20509",
    9
  ],
  "./_deziiign/online/utils/index": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/hsecreativehub/routesList": [
    "71242",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "57303"
  ],
  "./_deziiign/s-fashion/app": [
    "40127",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "93492"
  ],
  "./_deziiign/s-international-relations/app": [
    "57715",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "11408"
  ],
  "./_geograffee/dafes/icons/GoldBlockThreeIcon": [
    "40394",
    9,
    "88631"
  ],
  "./_deziiign/lmshsecreative/app.tsx": [
    "59520",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64665"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderEducationIcon.tsx": [
    "92946",
    9,
    "98639"
  ],
  "./_ftbl/main/pages/MainPage/MainPage": [
    "89526",
    9,
    "17316",
    "71641",
    "60764",
    "46075"
  ],
  "./_kz/dafes/constants/segments": [
    "1953",
    9
  ],
  "./_kz/dafes/routesList.tsx": [
    "56814",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26330"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchsm.svg": [
    "39150",
    1,
    "91907"
  ],
  "./_geograffee/dafes/icons/footerIcons/FooterLogo.tsx": [
    "31086",
    9,
    "68739"
  ],
  "./_deziiign/adcrdafesnet/routesList.tsx": [
    "84852",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "39797"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/ConnectionFormat/ConnectionFormat": [
    "51706",
    9,
    "60807"
  ],
  "./_deziiign/greenaward/app": [
    "39231",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "84116"
  ],
  "./_deziiign/newcha/routesList": [
    "3598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58339"
  ],
  "./_competition/pages/JuryPage/": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-media/routesList": [
    "88674",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "89023"
  ],
  "./_competition/const": [
    "19408",
    9
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderNextButtonIcon.tsx": [
    "26191",
    9,
    "25252"
  ],
  "./_deziiign/books/app.tsx": [
    "52905",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64585"
  ],
  "./_deziiign/lpudesign/routesList.tsx": [
    "56163",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "42368"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/styles": [
    "78462",
    9,
    "90835"
  ],
  "./_deziiign/lpudesign/styles.tsx": [
    "72095",
    9,
    "29364"
  ],
  "./_geograffee/dafes/icons/AddDafesIcon.tsx": [
    "35503",
    9,
    "12324"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image.tsx": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo": [
    "70085",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/StatusesAdminPage": [
    "96596",
    9,
    "5894",
    "86041",
    "95605"
  ],
  "./_deziiign/s-culturology/routesList": [
    "49467",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76872"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 130.jpg": [
    "62532",
    1,
    "86565"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plant.svg": [
    "59903",
    1,
    "7540"
  ],
  "./_deziiign/books/pages/BookEdit/providers/bookEditorProvider.tsx": [
    "54729",
    9
  ],
  "./_deziiign/musicmediiia/routesList": [
    "17469",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23406"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable.tsx": [
    "72383",
    9,
    "22056",
    "80140",
    "38708"
  ],
  "./_deziiign/hsespacefilm/routesList.tsx": [
    "18438",
    9,
    "50323",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69775",
    "90370",
    "56768",
    "555"
  ],
  "./_competition/pages/ProjectsPage/index": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/s-urban-development/routesList": [
    "14622",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "14419"
  ],
  "./_competition/components/CompetitionTagLine.tsx": [
    "23659",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/validateForm.ts": [
    "49918",
    9,
    "97568"
  ],
  "./_deziiign/s-advertising-and-pr/routesList": [
    "2725",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "49510"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/GoldBlock": [
    "85302",
    9,
    "10203"
  ],
  "./_deziiign/onlinesdesign/routesList": [
    "51735",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3813"
  ],
  "./_geograffee/dafes/routesList": [
    "58305",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "95992",
    "94498",
    "57352",
    "62227",
    "80444",
    "8772",
    "77097",
    "17486",
    "53317",
    "20565",
    "97387",
    "67566",
    "28977",
    "54911",
    "22713",
    "65293",
    "43290"
  ],
  "./_deziiign/s-economy/app": [
    "30587",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69032"
  ],
  "./_deziiign/exams/app": [
    "78503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57516"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/styles": [
    "57803",
    9,
    "51672"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/DigitalEcosystem": [
    "13236",
    9,
    "95992",
    "48949"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/s-economy/routesList": [
    "59950",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "8771"
  ],
  "./_deziiign/designmediiia/routesList": [
    "17398",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3323"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index": [
    "51397",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "98703"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/DigitalEcosystem/styles": [
    "52030",
    9,
    "28051"
  ],
  "./_deziiign/s-jurisprudence/app.tsx": [
    "87039",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64605"
  ],
  "./_deziiign/hsecolors/app.tsx": [
    "19735",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "43452"
  ],
  "./_competition/pages/CompetitionResultsPage/": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/s-software-engineering/app": [
    "99790",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "14115"
  ],
  "./_deziiign/hsespace/styles.tsx": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/books/core/components/bookCard/style": [
    "94938",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/iqmedia/app": [
    "5142",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "57563"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.tsx": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/s-oriental/app.tsx": [
    "43791",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "39300"
  ],
  "./_deziiign/s-sociology/routesList": [
    "82256",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "26089"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/JoinEcosystemForm/JoinEcosystemForm.tsx": [
    "67138",
    9,
    "95992",
    "54911",
    "46248"
  ],
  "./_deziiign/s-extra/app": [
    "20657",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "21802"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/RauIcon": [
    "20126",
    9,
    "99731"
  ],
  "./_ftbl/main/assets/clubEmblems/Hercules_Barcelona.png": [
    "87591",
    1,
    "10380"
  ],
  "./_kz/pro/app.tsx": [
    "4989",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "76311"
  ],
  "./_competition/pages/CreateCompetitionPage/styles.tsx": [
    "31768",
    9
  ],
  "./_deziiign/s-philology/routesList": [
    "22217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "1490"
  ],
  "./_ftbl/main/pages/MainPage/components/HeadComponent/styles": [
    "44479",
    9,
    "69812"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteTopBlock/resources.ts": [
    "72627",
    9,
    "52272"
  ],
  "./_competition/components/ImageMob.jpg": [
    "10213",
    1,
    "3782"
  ],
  "./_deziiign/online/app.tsx": [
    "51165",
    9,
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "41317",
    "97775",
    "38815",
    "53966"
  ],
  "./_deziiign/s-fashion/routesList.tsx": [
    "7386",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "80679"
  ],
  "./_competition/helpers/getDaysToFinish": [
    "20572",
    9
  ],
  "./_deziiign/hsedesign/app.tsx": [
    "66841",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99554"
  ],
  "./_ftbl/main/helpers/tableUtils": [
    "75613",
    9,
    "26222"
  ],
  "./_deziiign/awards/utils/": [
    "97022",
    9,
    "7539"
  ],
  "./_fr/shanghai/app.tsx": [
    "59269",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "47046"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSection.tsx": [
    "79835",
    9,
    "2760"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner5.svg": [
    "28594",
    1,
    "38575"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/week.svg": [
    "38988",
    1,
    "55677"
  ],
  "./_deziiign/books/pages/tag/tagBookListView.tsx": [
    "29236",
    9,
    "13908",
    "21565",
    "57493"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage.tsx": [
    "97728",
    9,
    "27769"
  ],
  "./_ftbl/main/routesList.tsx": [
    "2572",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "637"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_1.png": [
    "73760",
    1,
    "24153"
  ],
  "./_deziiign/hsecreative/app.tsx": [
    "90600",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38161"
  ],
  "./_geograffee/dafes/images/awards2026/cirkina.png": [
    "70650",
    1,
    "4327"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/style": [
    "39764",
    9,
    "54709"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/types": [
    "79427",
    9,
    "37568"
  ],
  "./_deziiign/hsestart/app.tsx": [
    "36503",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "85244"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles.ts": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher": [
    "51152",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionNominatiosBlock": [
    "98635",
    9,
    "36184"
  ],
  "./_ftbl/main/hooks/useGetPredictionsInfo.ts": [
    "76678",
    9,
    "97675"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsNominations.tsx": [
    "60064",
    9,
    "77097",
    "22713",
    "27700"
  ],
  "./_competition/pages/LongListPage/LongListPage": [
    "22197",
    9
  ],
  "./_deziiign/s-architect/app.tsx": [
    "30162",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "9775"
  ],
  "./_deziiign/online/utils/index.ts": [
    "97367",
    9,
    "80252"
  ],
  "./_deziiign/brnd/routesList.tsx": [
    "59684",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "21733"
  ],
  "./_ftbl/main/helpers/getInitials": [
    "49335",
    9,
    "45244"
  ],
  "./_fr/saopaulo/app": [
    "10146",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "99807"
  ],
  "./_deziiign/s-advertising-and-pr/routesList.tsx": [
    "2725",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "49510"
  ],
  "./_geograffee/dafes/pages/styles": [
    "27162",
    9,
    "5319"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/EducationBlock": [
    "56668",
    9,
    "9348"
  ],
  "./_competition/pages/AllCompetitionsPage/types.ts": [
    "29334",
    9
  ],
  "./_deziiign/main/pages/moderView/": [
    "15597",
    9,
    "70494"
  ],
  "./_ftbl/main/types/table.ts": [
    "59446",
    9,
    "81851"
  ],
  "./_deziiign/lmsmediiia/routesList": [
    "74328",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54209"
  ],
  "./_deziiign/newcha/routesList.tsx": [
    "3598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58339"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_3.png": [
    "49778",
    1,
    "15823"
  ],
  "./_deziiign/books/core/components/bookCard/style.ts": [
    "94938",
    9
  ],
  "./_geograffee/dafes/icons/sliderIcons/SliderArtIcon": [
    "96271",
    9,
    "44868"
  ],
  "./_geograffee/dafes/icons/awardsTopBlockIcons/AwardsCrownIcon.tsx": [
    "64309",
    9,
    "19158"
  ],
  "./_deziiign/greenaward/routesList.tsx": [
    "29293",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23591"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/next.svg": [
    "66407",
    1,
    "24780"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/mymediiia/app.tsx": [
    "16439",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94524"
  ],
  "./_deziiign/s-cognitive/routesList.tsx": [
    "92970",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "6167"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList": [
    "81206",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "66107"
  ],
  "./_geograffee/dafes/icons/awardsNominations/CGRaveIcon": [
    "77373",
    9,
    "54030"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/styles.ts": [
    "10145",
    9,
    "538"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesComponent.tsx": [
    "33879",
    9,
    "17316",
    "60764"
  ],
  "./_competition/pages/CreateCompetitionPage/helpers/specialCompetitionHelpers.tsx": [
    "97666",
    9,
    "44735"
  ],
  "./_kz/dafes-education/routesList.tsx": [
    "74274",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67007"
  ],
  "./_deziiign/school/app.tsx": [
    "46931",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "44080"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/UserTable": [
    "40174",
    9,
    "32611"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/PartnersAwards2025": [
    "5168",
    9,
    "94498",
    "28809"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DIcon.tsx": [
    "9737",
    9,
    "34674"
  ],
  "./_deziiign/books/core/components/grid/index.tsx": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/ageytomesh/routesList.tsx": [
    "92044",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67741"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_deziiign/main/styles.tsx": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/s-music/app.tsx": [
    "62310",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "98411"
  ],
  "./_ftbl/main/pages/MainPage/styles": [
    "39174",
    9,
    "95531"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/edu-en-54f240ac75a148a2acac41074ac7527f.jpg": [
    "94106",
    1,
    "99463"
  ],
  "./_competition/pages/CompetitionsAdmin/components/CreateFolderComponent.tsx": [
    "10294",
    9,
    "17275"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/continuumsite/img/image_1920.png": [
    "89373",
    1,
    "48046"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/design-b1e23c003f964e53b854f41d957276da.jpg": [
    "74065",
    1,
    "79370"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/modals/EditUser.tsx": [
    "68730",
    9,
    "5894"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image": [
    "75542",
    9,
    "13243"
  ],
  "./_ftbl/main/pages/MainPage/styles.ts": [
    "39174",
    9,
    "95531"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer.ts": [
    "13411",
    9,
    "41906"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueItem.tsx": [
    "54921",
    9,
    "46130"
  ],
  "./_ftbl/main/pages/MainPage/components/TableComponent/styles": [
    "97041",
    9,
    "24682"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/styles": [
    "53051",
    9,
    "23867"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "56581",
    9,
    "16646"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/": [
    "71795",
    9
  ],
  "./_geograffee/academy/routesList.tsx": [
    "28768",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71769"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/CouncilBlock": [
    "26534",
    9,
    "95992",
    "99723"
  ],
  "./_deziiign/online/routesList": [
    "51217",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2026"
  ],
  "./_deziiign/onlinesdesign/styles.tsx": [
    "60180",
    9,
    "4245"
  ],
  "./_deziiign/onlines/utils/index": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plus.svg": [
    "81440",
    1,
    "40729"
  ],
  "./_deziiign/hsespace/utils/index": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage.tsx": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_competition/pages/ShortListPage/styles": [
    "42270",
    9
  ],
  "./_competition/components/TellingStoriesSuccess.tsx": [
    "43479",
    9,
    "10684"
  ],
  "./_geograffee/dafes/icons/blackBlockIcons/ProfilesIcon.tsx": [
    "91598",
    9,
    "93699"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/TagsComponent": [
    "40805",
    9,
    "7494"
  ],
  "./_competition/pages/CompetitionTable/index": [
    "69432",
    9,
    "22056",
    "80140",
    "38708",
    "91137"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts.ts": [
    "61644",
    9,
    "82173"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation": [
    "36014",
    9
  ],
  "./_deziiign/portfolioartz/routesList": [
    "28207",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45444"
  ],
  "./_fr/mumbai/styles": [
    "26294",
    9,
    "6171"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/vertical_card.svg": [
    "96378",
    1,
    "57159"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblCard": [
    "61365",
    9,
    "34486"
  ],
  "./_deziiign/cgrave/routesList": [
    "7524",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54821"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage.tsx": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage": [
    "166",
    9
  ],
  "./_geograffee/dafes/images/F1_fashion_designEN.jpg": [
    "65130",
    1,
    "31895"
  ],
  "./_deziiign/books/core/components/designerSearch/styles.tsx": [
    "46609",
    9,
    "97450"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsTopBlock/AwardsTopBlock": [
    "98386",
    9,
    "95992",
    "97387",
    "21647"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/declension.ts": [
    "47607",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCheckbox.tsx": [
    "64258",
    9,
    "11679"
  ],
  "./_competition/pages/ShortListPage/ShortListPage.tsx": [
    "37613",
    9
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection": [
    "80194",
    9,
    "59071"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage.tsx": [
    "55002",
    9,
    "53972"
  ],
  "./_deziiign/game/app": [
    "86185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "49170"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField.tsx": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/profmediiia/routesList": [
    "10777",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67810"
  ],
  "./_deziiign/s-software-engineering/routesList.tsx": [
    "45829",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "5318"
  ],
  "./_geograffee/dafes/icons/sliderIcons/SIcon": [
    "82381",
    9,
    "90951"
  ],
  "./_deziiign/naturemediiia/routesList": [
    "93869",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97758"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/books/core/components/bookCard/": [
    "21273",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types": [
    "94393",
    9
  ],
  "./_deziiign/naturemediiia/app.tsx": [
    "78614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "51835"
  ],
  "./_deziiign/books/pages/BookEdit/": [
    "25525",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497",
    "44086"
  ],
  "./_deziiign/ranepa/routesList": [
    "65621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "69910"
  ],
  "./_deziiign/lmshsecreative/routesList.tsx": [
    "83811",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "91424"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR.tsx": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage.tsx": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/s-psychology/app.tsx": [
    "32336",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31145"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/HeaderAwards2025": [
    "83534",
    9,
    "94498",
    "71779"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/styles": [
    "95213",
    9,
    "99326"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/GoldBlock/GoldBlock.tsx": [
    "85302",
    9,
    "10203"
  ],
  "./_geograffee/dafes/icons/sliderIcons/DIcon": [
    "9737",
    9,
    "34674"
  ],
  "./_geograffee/dafes/pages/ui/DafesButtons/DafesSmallButton.tsx": [
    "88678",
    9,
    "34603"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit.tsx": [
    "20260",
    9,
    "60901"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock": [
    "2850",
    9,
    "58591"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationThreeReadymag.svg": [
    "6219",
    1,
    "76184"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ.ts": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_fr/dubai/app": [
    "12475",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "72168"
  ],
  "./_deziiign/books/pages/tag/": [
    "17800",
    9,
    "13908",
    "21565",
    "57493",
    "59761"
  ],
  "./_ftbl/main/pages/MainPage/components/GameTabs": [
    "66007",
    9,
    "65148"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/art-6e63304c030c4c98bbe05fdb5892dd6c.jpg": [
    "8619",
    1,
    "51256"
  ],
  "./_fr/main/routesList.tsx": [
    "41816",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97281"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard.tsx": [
    "35468",
    9
  ],
  "./_deziiign/s-political-science/routesList": [
    "7938",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "90783"
  ],
  "./_deziiign/lmsmediiia/routesList.tsx": [
    "74328",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54209"
  ],
  "./_deziiign/onlinesdesign/styles": [
    "60180",
    9,
    "4245"
  ],
  "./_deziiign/s-management/app.tsx": [
    "46822",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46507"
  ],
  "./_deziiign/s-mathematics/routesList": [
    "82264",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "15905"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner12.svg": [
    "10288",
    1,
    "84009"
  ],
  "./_deziiign/s-urban-development/app.tsx": [
    "69291",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "61528"
  ],
  "./_ftbl/main/helpers/tableUtils.ts": [
    "75613",
    9,
    "26222"
  ],
  "./_deziiign/school/utils/index": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "43782",
    9,
    "33355"
  ],
  "./_geograffee/dafes/images/awards2026/mobileHeaderBgNew.png": [
    "98353",
    1,
    "41354"
  ],
  "./_deziiign/books/core/components/designerSearch/styles": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ps.svg": [
    "48820",
    1,
    "98453"
  ],
  "./_geograffee/dafes/pages/ui/PartnersBlock/styles": [
    "86826",
    9,
    "32375"
  ],
  "./_competition/pages/PreRegistrationResult/index.ts": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/fairmediiia/app": [
    "6467",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "54624"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout.tsx": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate": [
    "52636",
    9,
    "85357"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/slides.tsx": [
    "16420",
    9,
    "53317"
  ],
  "./_geograffee/dafes/images/awards2026/navLogo.svg": [
    "85423",
    1,
    "59108"
  ],
  "./_deziiign/sciencemediiia/app": [
    "65447",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "58028"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection": [
    "84390",
    9,
    "33131"
  ],
  "./_fr/bengaluru/routesList": [
    "19488",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "3449"
  ],
  "./_deziiign/transfermediiia/app.tsx": [
    "56774",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "70987"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/Timelines": [
    "29534",
    9,
    "36435"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesDate/GamesDate": [
    "42824",
    9,
    "82705"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flag.svg": [
    "58764",
    1,
    "19421"
  ],
  "./_deziiign/s-music/routesList": [
    "10621",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "31790"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts": [
    "2696",
    9
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/components/styles": [
    "36749",
    9,
    "89854"
  ],
  "./_deziiign/profmediiia/routesList.tsx": [
    "10777",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "67810"
  ],
  "./_deziiign/s-cinema/app.tsx": [
    "64646",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "363"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs": [
    "70789",
    9,
    "27494"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblButtons.tsx": [
    "92324",
    9,
    "72133"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconRu.tsx": [
    "75477",
    9,
    "35254"
  ],
  "./_geograffee/dafes/images/F1_fashion_photo.jpg": [
    "14037",
    1,
    "29046"
  ],
  "./_geograffee/dafes/images/awards2026/covers/ru/startups-4ac9aba7802f4803b36c4c163836bc48.jpg": [
    "15811",
    1,
    "90688"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/DafesMainSlider/slides": [
    "16420",
    9,
    "53317"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage": [
    "21593",
    9,
    "62850"
  ],
  "./_deziiign/books/core/components/bookCard/index.tsx": [
    "21273",
    9
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/PartnersResidents/styles.ts": [
    "24222",
    9,
    "96467"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage": [
    "43455",
    9,
    "54452"
  ],
  "./_ftbl/main/styles.tsx": [
    "5836",
    9,
    "36477"
  ],
  "./_deziiign/artmediiia/app.tsx": [
    "43916",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "6749"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage.tsx": [
    "51697",
    9,
    "73706"
  ],
  "./_deziiign/s-culturology/app.tsx": [
    "9048",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "37729"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/UniversitiesFeatures/styles.ts": [
    "50263",
    9,
    "88988"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/s-biology/app.tsx": [
    "72594",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "77743"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-3cda2e20741e4b1db94ee060d6a57d36.jpg": [
    "72460",
    1,
    "20701"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner10.svg": [
    "17490",
    1,
    "86895"
  ],
  "./_deziiign/continuumsite/img/image_744.png": [
    "46966",
    1,
    "57627"
  ],
  "./_deziiign/foodmediiia/app": [
    "86805",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "59126"
  ],
  "./_deziiign/admediiia/app": [
    "9468",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "38445"
  ],
  "./_deziiign/s-culturology/routesList.tsx": [
    "49467",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "76872"
  ],
  "./_competition/pages/CompetitionResultsPage/index.tsx": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_fr/main/styles": [
    "40912",
    9,
    "43369"
  ],
  "./_deziiign/s-management/app": [
    "46822",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46507"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/interiorImg.png": [
    "90616",
    1,
    "30689"
  ],
  "./_deziiign/s-virtualspace/routesList.tsx": [
    "22057",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71762"
  ],
  "./_ftbl/main/pages/MainPage/components/NewsPlayer/icons/PlayIcon.tsx": [
    "1764",
    9,
    "60261"
  ],
  "./_deziiign/artmediiia/routesList": [
    "6743",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "88156"
  ],
  "./_deziiign/pro/routesList.tsx": [
    "16598",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "46706"
  ],
  "./_deziiign/booksgallllery/app.tsx": [
    "76643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "66688"
  ],
  "./_fr/marseille/styles.tsx": [
    "19993",
    9,
    "26050"
  ],
  "./_ftbl/main/types/games.ts": [
    "40701",
    9,
    "84942"
  ],
  "./_fr/kolkata/styles": [
    "6174",
    9,
    "26419"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign.tsx": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage": [
    "11278",
    9,
    "31120"
  ],
  "./_deziiign/greenaward/styles.tsx": [
    "52890",
    9,
    "32455"
  ],
  "./_ftbl/main/app": [
    "87614",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "63539"
  ],
  "./_geograffee/academy/routesList": [
    "28768",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71769"
  ],
  "./_deziiign/mymediiia/app": [
    "16439",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "94524"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/EducationBlock.tsx": [
    "56668",
    9,
    "9348"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types.ts": [
    "94393",
    9
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/NominationItem.tsx": [
    "18729",
    9,
    "29938"
  ],
  "./_deziiign/hsecreativehub/app.tsx": [
    "44527",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "95620"
  ],
  "./_ftbl/main/assets/clubEmblems/Athletic_Moscow.png": [
    "13723",
    1,
    "34792"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage.tsx": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useProjectChapters.tsx": [
    "50502",
    9
  ],
  "./_deziiign/s-jurisprudence/app": [
    "87039",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "64605"
  ],
  "./_geograffee/dafes/images/E1_visual_researchEN.jpg": [
    "19435",
    1,
    "62881"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/edu-en-8119c54fba784b5ba27098e025112721.jpg": [
    "7158",
    1,
    "13435"
  ],
  "./_geograffee/dafes/icons/communityIcons/CommunityMobIconEn": [
    "99755",
    9,
    "57336"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage.tsx": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/pages/JuryPage/styles": [
    "80070",
    9
  ],
  "./_uz/main/routesList.tsx": [
    "75937",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "2554"
  ],
  "./_deziiign/s-computer-science-and-engineering/app.tsx": [
    "24643",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "10720"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms": [
    "59628",
    9
  ],
  "./_deziiign/game/app.tsx": [
    "86185",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "49170"
  ],
  "./_deziiign/naturemediiia/routesList.tsx": [
    "93869",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "97758"
  ],
  "./_competition/helpers/useShowRatingCompetitionTag.ts": [
    "32511",
    9
  ],
  "./_deziiign/s-physics/app.tsx": [
    "76764",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "89997"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/NominationsList.tsx": [
    "73450",
    9,
    "26199"
  ],
  "./_kz/dafes/components/SegmentSwitcher": [
    "6992",
    9,
    "9961"
  ],
  "./_deziiign/kiiids/routesList.tsx": [
    "85885",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "81038"
  ],
  "./_deziiign/hseanimation/app": [
    "36769",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "25562"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs.tsx": [
    "79982",
    9,
    "12035"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/DesignSchoolAmIcon": [
    "88622",
    9,
    "8227"
  ],
  "./_geograffee/dafes/icons/communityIcons/DafesCommunityIconRu": [
    "24290",
    9,
    "29599"
  ],
  "./_geograffee/dafes/icons/councilBlockIcons/CouncilIconEn.tsx": [
    "68643",
    9,
    "37289"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit": [
    "72536",
    9,
    "24074",
    "94148",
    "76826",
    "43779",
    "64156",
    "26957",
    "28942",
    "6049",
    "47268",
    "83275",
    "41317",
    "71960",
    "31771",
    "24115",
    "16476",
    "78001",
    "41996",
    "64445",
    "18243",
    "19833",
    "21398",
    "39313",
    "80147",
    "97305",
    "70497"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/styles.ts": [
    "31255",
    9,
    "52828"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/styles": [
    "92847",
    9,
    "77924"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/FooterAwards2025.tsx": [
    "12840",
    9,
    "28977"
  ],
  "./_deziiign/mediiia/routesList": [
    "24864",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "45497"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/styles.ts": [
    "7522",
    9,
    "1343"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star2.svg": [
    "57359",
    1,
    "54532"
  ],
  "./_geograffee/dafes/icons/ButtonArrowIcon.tsx": [
    "19980",
    9,
    "61373"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderView": [
    "15597",
    9,
    "70494"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles.ts": [
    "21768",
    9,
    "89105"
  ],
  "./_geograffee/dafes/icons/awardsNominations/ZharKnigaIcon": [
    "85172",
    9,
    "12789"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/": [
    "67884",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "1882"
  ],
  "./_geograffee/dafes/icons/sliderIcons/EIcon.tsx": [
    "56416",
    9,
    "28985"
  ],
  "./_geograffee/dafes/images/awards2026/hse_art_and_design_school_logo_for_site.svg": [
    "90813",
    1,
    "81166"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/ColorfulBlocks/BlueBlock/BlueBlock": [
    "16178",
    9,
    "95992",
    "48591"
  ],
  "./_deziiign/creativemediiia/app.tsx": [
    "38719",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "86621"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus": [
    "89004",
    9,
    "52701"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage.tsx": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer": [
    "29312",
    9,
    "97305"
  ],
  "./_competition/pages/AllCompetitionsPage/styles.css": [
    "30922",
    9,
    "64471"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 122.jpg": [
    "9969",
    1,
    "40170"
  ],
  "./_deziiign/onlines/app.tsx": [
    "51476",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "13836"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblSortBar": [
    "34752",
    9,
    "153"
  ],
  "./_deziiign/s-virtualspace/routesList": [
    "22057",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "71762"
  ],
  "./_ftbl/main/pages/MainPage/components/TabsSectionComponent/TabsSectionContent.tsx": [
    "29996",
    9,
    "73917"
  ],
  "./_deziiign/awards/utils/index": [
    "97022",
    9,
    "7539"
  ],
  "./_geograffee/dafes/pages/ui/UniversitiesPage/TitleImage/TitleImg": [
    "63168",
    9,
    "89017"
  ],
  "./_deziiign/hsedesign/pages/StatusesAdminPage/hooks/useGetStatusesActions.tsx": [
    "52485",
    9,
    "5894"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext.tsx": [
    "51106",
    9,
    "50323",
    "15969",
    "69775",
    "90370",
    "56768",
    "32500"
  ],
  "./_deziiign/admediiia/routesList.tsx": [
    "21959",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "34636"
  ],
  "./_deziiign/s-economy/app.tsx": [
    "30587",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "69032"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/DesktopReadymag.svg": [
    "11811",
    1,
    "51200"
  ],
  "./_deziiign/s-jurisprudence/routesList.tsx": [
    "35639",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "85500"
  ],
  "./_competition/const.ts": [
    "19408",
    9
  ],
  "./_geograffee/main/routesList": [
    "29087",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "18900"
  ],
  "./_ftbl/main/assets/icons/TableSortArrow.tsx": [
    "48776",
    9,
    "76593"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/TechnologicalBlock.tsx": [
    "2303",
    9,
    "95992",
    "44372"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames.tsx": [
    "88358",
    9
  ],
  "./_deziiign/awards/utils": [
    "97022",
    9,
    "7539"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard.tsx": [
    "76742",
    9
  ],
  "./_deziiign/books/pages/BookListView/BookListView.tsx": [
    "85406",
    9,
    "13908",
    "21565",
    "5357",
    "96979"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign.tsx": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/hsecolors/styles": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView": [
    "53627",
    9,
    "99272"
  ],
  "./_geograffee/dafes/images/awards2026/partners/Frame 124.jpg": [
    "33407",
    1,
    "11060"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit.tsx": [
    "441",
    9,
    "70530"
  ],
  "./_fr/bengaluru/app": [
    "53377",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "46938"
  ],
  "./_geograffee/dafes/images/awards2026/covers/en/design-en-8bb7da9aca9244d78f72d4d808554f73.jpg": [
    "56184",
    1,
    "28801"
  ],
  "./_deziiign/fashionmediiia/routesList": [
    "77396",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "7477"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles": [
    "48516",
    9,
    "73637"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner2.svg": [
    "62525",
    1,
    "48622"
  ],
  "./_deziiign/hsecolors/styles.tsx": [
    "9186",
    9,
    "86719"
  ],
  "./_competition/pages/CompetitionsAdmin/components/CreateFolderComponent": [
    "10294",
    9,
    "17275"
  ],
  "./_deziiign/superpuper/routesList": [
    "76673",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "23130"
  ],
  "./_competition/pages/JuryPage": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-architect/routesList.tsx": [
    "52833",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "74394"
  ],
  "./_deziiign/cgrave/routesList.tsx": [
    "7524",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "54821"
  ],
  "./_ftbl/main/pages/AllMatches/components/FtblButtons": [
    "92324",
    9,
    "72133"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles.ts": [
    "63545",
    9,
    "82850"
  ],
  "./_geograffee/dafes/images/blueSlider/blue_slider_item_2.png": [
    "54971",
    1,
    "59304"
  ],
  "./_ftbl/main/assets/leagues/spain.png": [
    "71748",
    1,
    "86437"
  ],
  "./_deziiign/eventmediiia/app.tsx": [
    "98329",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "5890"
  ],
  "./_geograffee/dafes/pages/ui/MainPage/WhiteMainBlock/WhiteMainBlock": [
    "63325",
    9,
    "95992",
    "67566"
  ],
  "./_geograffee/dafes/icons/sliderIcons/EIcon": [
    "56416",
    9,
    "28985"
  ],
  "./_deziiign/aimediiia/app": [
    "49867",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "31576"
  ],
  "./_ftbl/main/assets/icons/TableSortLabelIcon": [
    "46",
    9,
    "5155"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput.tsx": [
    "40837",
    9,
    "99142"
  ],
  "./_ftbl/main/pages/MainPage/components/LeagueList/LeagueItem": [
    "54921",
    9,
    "46130"
  ],
  "./_deziiign/s-culturology/app": [
    "9048",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "37729"
  ],
  "./_geograffee/dafes/icons/sliderIcons/FIcon.tsx": [
    "53767",
    9,
    "2476"
  ],
  "./_ftbl/main/pages/MainPage/components/GamesInfoComponent.tsx": [
    "69615",
    9,
    "17316"
  ],
  "./_geograffee/dafes/icons/partnersBlockIcons/HSEArtIcon.tsx": [
    "34205",
    9,
    "61262"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "56581",
    9,
    "16646"
  ],
  "./_competition/pages/AllOpenCalls": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/eventmediiia/routesList.tsx": [
    "4152",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "79073"
  ],
  "./_competition/pages/EmptyPage.tsx": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/lmshse/app.tsx": [
    "59755",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "7512"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/books/pages/BookEdit/hooks/useBookChaptersEdit": [
    "50250",
    9,
    "3063"
  ],
  "./_ftbl/main/hooks/useGetResultsTable.ts": [
    "11716",
    9,
    "33381"
  ],
  "./_geograffee/dafes/pages/ui/Awards2025Page/AboutAwards2025": [
    "44807",
    9,
    "12725"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_geograffee/dafes/pages/ui/AwardsPage/awardsNominations/AwardsNominations": [
    "60064",
    9,
    "77097",
    "22713",
    "27700"
  ],
  "./_geograffee/dafes/images/awards2026/partners/partner9.svg": [
    "94486",
    1,
    "57659"
  ],
  "./_competition/pages/CompetitionsAdmin/components/Timelines/const.ts": [
    "93273",
    9,
    "16514"
  ],
  "./_deziiign/dvadesign/app.tsx": [
    "31062",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay.tsx": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/urbanmediiia/routesList.tsx": [
    "31300",
    9,
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "58533"
  ],
  "./_geograffee/dafes/pages/data/profilesData.ts": [
    "69221",
    9,
    "89830"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles.ts": [
    "73222",
    9
  ],
  "./_geograffee/dafes/pages/ui/DafesFooter/DafesFooter.tsx": [
    "48618",
    9,
    "55383"
  ],
  "./_deziiign/hsedesign/utils/": [
    "46106",
    9,
    "87527"
  ],
  "./_deziiign/fashion/app.tsx": [
    "979",
    9,
    "24074",
    "83762",
    "15969",
    "6049",
    "99448",
    "16433",
    "79757",
    "34161",
    "78074",
    "47268",
    "83275",
    "41317",
    "97775",
    "38815",
    "76792",
    "86248",
    "71856"
  ],
  "./_deziiign/books/core/components/tooltips/index": [
    "40356",
    9
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64979;
module.exports = webpackAsyncContext;
